/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LoginCreateData {
  accessToken: string;
  refreshToken: string;
  user: {
    id: number;
    phoneNumber: string | null;
    name: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    profileImageUrl: string | null;
  };
}

export type SignupVerificationCreateData = any;

export type SignupVerifyCreateData = any;

export type SignupCreateData = any;

export type ResetPasswordVerificationCreateData = any;

export type ResetPasswordVerifyCreateData = any;

export type ResetPasswordCreateData = any;

export type InstructorSignupCreateData = any;

export interface RefreshCreateData {
  accessToken: string;
  refreshToken: string;
}

export type ParentPhoneVerificationCreateData = any;

export type ParentPhoneVerifyCreateData = any;

export type ChildLinkVerificationCreateData = any;

export type ChildLinkVerifyCreateData = any;

export interface GetUsersData {
  id: number;
  name: string | null;
  createdAt: string;
  phoneNumber: string | null;
  birth: string | null;
  gender: ("MALE" | "FEMALE") | null;
  isNotification: boolean;
  isAdNotification: boolean;
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  address: string | null;
  profileImageUrl: string | null;
  description: string | null;
  entrancePhotoUrl: string | null;
  userStores: {
    id: number;
    userId: number;
    storeId: number;
    latestPresentAt: string | null;
    presentCount: number;
    monthlyPresentCount: number;
    classPresentCount: number;
    classMonthlyPresentCount: number;
    classCount: number;
    monthlyClassCount: number;
    monthlyNoShowCount: number;
    noShowPenaltyStartedAt: string | null;
    color: string | null;
    name: string | null;
    tossCustomerKey: string | null;
    hasRegisteredCard: boolean;
    createdAt: string;
    deletedAt: string | null;
    store: {
      id: number;
      /** @maxLength 255 */
      name: string;
      tel: string | null;
      phoneNumber: string | null;
      businessNumber: string | null;
      representative: string | null;
      types: (string | number | boolean | null) | any[] | Record<string, any>;
      gymDidAccount: string | null;
      pilatesDidAccount: string | null;
      bareDidAccount: string | null;
      address: string | null;
      addressDetail: string | null;
      branchTel: string | null;
      naverPlaceRepresentative: string | null;
      naverPlaceBusinessNumber: string | null;
      naverPlaceTel: string | null;
      point: number;
      bodyAnalysisPoint: number;
      timeTable:
        | (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
              }[]
            | null
          )
        | null;
      isFnbEnabled: boolean;
      fnbTimeTable:
        | (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
              }[]
            | null
          )
        | null;
      color: string | null;
      images: null;
      fnbImage: string | null;
      fnbScreenImages: null;
      tossClientKey: string | null;
      tossCultureClientKey: string | null;
      createdAt: string;
      updatedAt: string;
      storeSettings: {
        id: number;
        storeId: number;
        reservationAvailableHour: number;
        groupClassCancelHour: number;
        groupClassWaitingCancelHour: number;
        privateClassCancelHour: number;
        sameDayChangeHour: number;
        waitingAutoReserveHour: number;
        dailyReservationLimit: number;
        closingTimeInterval: number;
        checkInScreenImage: string | null;
        isQrEntranceEnabled: boolean;
        createdAt: string;
        updatedAt: string;
      };
    };
  }[];
}

export type PatchUsersData = any;

export type StoreDeleteData = any;

export interface AttendanceListData {
  monthlyAttendanceCount: number;
  continuousAttendanceCount: number;
  continuousMembershipAttendanceCount: number;
  monthlyNoshowCount: number;
  totalGroupClassAttendanceCount: number;
}

export type InbodyHistoriesListData = {
  id: number;
  userId: number;
  phoneNumber: string | null;
  weight: number | null;
  weightStatus: ("UP" | "DOWN" | "STABLE") | null;
  fat: number | null;
  fatStatus: ("UP" | "DOWN" | "STABLE") | null;
  muscle: number | null;
  muscleStatus: ("UP" | "DOWN" | "STABLE") | null;
  fatPercentage: number | null;
  fatPercentageStatus: ("UP" | "DOWN" | "STABLE") | null;
  BMR: number | null;
  rawData:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  createdAt: string;
  updatedAt: string;
}[];

export type RowingRankingListData = {
  id: number;
  classId: number;
  distance: number;
  time: number;
  rank: number;
  createdAt: string;
  updatedAt: string;
  class: {
    id: number;
    /** @maxLength 255 */
    name: string;
    maxCapacity: number;
    type: "GROUP" | "PRIVATE";
    reservationAvailableHour: number | null;
    classCancelHour: number;
    classWaitingCancelHour: number;
    sameDayChangeHour: number | null;
    startedAt: string;
    endedAt: string;
    roomId: number | null;
    adminUserId: number | null;
    isReservationEnabled: boolean;
    deductionCount: number;
    groupClassId: number | null;
    storeId: number;
    deletedReason: string | null;
    deletedUserId: number | null;
    openedAt: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
    userCount: number;
    store: {
      id: number;
      /** @maxLength 255 */
      name: string;
      tel: string | null;
      phoneNumber: string | null;
      businessNumber: string | null;
      representative: string | null;
      types: (string | number | boolean | null) | any[] | Record<string, any>;
      gymDidAccount: string | null;
      pilatesDidAccount: string | null;
      bareDidAccount: string | null;
      address: string | null;
      addressDetail: string | null;
      branchTel: string | null;
      naverPlaceRepresentative: string | null;
      naverPlaceBusinessNumber: string | null;
      naverPlaceTel: string | null;
      point: number;
      bodyAnalysisPoint: number;
      timeTable:
        | (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
              }[]
            | null
          )
        | null;
      isFnbEnabled: boolean;
      fnbTimeTable:
        | (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
              }[]
            | null
          )
        | null;
      color: string | null;
      images: null;
      fnbImage: string | null;
      fnbScreenImages: null;
      tossClientKey: string | null;
      tossCultureClientKey: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
  rowingGroups: {
    id: number;
    userId: number;
    rowingHistoryId: number;
    groupNumber: number;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  }[];
}[];

export interface TodayRowingListData {
  id: number;
  classId: number;
  distance: number;
  time: number;
  rank: number;
  createdAt: string;
  updatedAt: string;
}

export type MonthlyPresentRankingListData = {
  id: number;
  userId: number;
  storeId: number;
  latestPresentAt: string | null;
  presentCount: number;
  monthlyPresentCount: number;
  classPresentCount: number;
  classMonthlyPresentCount: number;
  classCount: number;
  monthlyClassCount: number;
  monthlyNoShowCount: number;
  noShowPenaltyStartedAt: string | null;
  color: string | null;
  name: string | null;
  tossCustomerKey: string | null;
  hasRegisteredCard: boolean;
  createdAt: string;
  deletedAt: string | null;
  user: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type AchievementsListData = {
  id: number;
  userId: number;
  storeId: number | null;
  classId: number | null;
  type:
    | "FIRST_PRESENT"
    | "WEEK_3"
    | "WEEK_5"
    | "MONTH_20"
    | "50"
    | "100"
    | "200"
    | "300"
    | "500";
  attendanceType: "CLASS" | "MEMBERSHIP";
  createdAt: string;
}[];

export type QuitCreateData = any;

export type ChangePasswordCreateData = any;

export type LockerSettingsListData = {
  id: number;
  storeId: number;
  type: "UNISEX" | "MALE" | "FEMALE";
  rows: number;
  cols: number;
  startNumber: number;
  numberDirection: "HORIZONTAL" | "VERTICAL";
  startPosition: "TOP_LEFT" | "TOP_RIGHT" | "BOTTOM_LEFT" | "BOTTOM_RIGHT";
  createdAt: string;
  updatedAt: string;
}[];

export interface AuthSigninCreateData {
  accessToken: string;
  refreshToken: string;
}

export type AuthSignupCreateData = any;

export interface AuthRefreshCreateData {
  accessToken: string;
  refreshToken: string;
}

export type AuthUserListData = {
  username: string;
}[];

export type AuthSendUsernameCreateData = any;

export type AuthSendResetCreateData = any;

export type AuthResetPasswordCreateData = any;

export interface UserMeListData {
  id: number;
  isActivated: boolean;
  /** @maxLength 255 */
  username: string;
  name: string | null;
  phoneNumber: string | null;
  refreshToken: string | null;
  role: "USER" | "ADMIN";
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  password: string | null;
  fcmToken: string | null;
  profileImageUrl: string | null;
  entrancePhotoUrl: string | null;
  color: string | null;
  description: string | null;
  timeTable:
    | {
        isDayOff: boolean;
        open?: string;
        close?: string;
      }[]
    | null;
  isNotification: boolean;
  isAdNotification: boolean;
  isLinked: boolean;
  gender: ("MALE" | "FEMALE") | null;
  birth: string | null;
  address: string | null;
  isUnder14: boolean;
  parentName: string | null;
  parentPhoneNumber: string | null;
  isParentPhoneVerified: boolean;
  paymentPin: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  store: null | {
    id: number;
    /** @maxLength 255 */
    name: string;
    tel: string | null;
    phoneNumber: string | null;
    businessNumber: string | null;
    representative: string | null;
    types: (string | number | boolean | null) | any[] | Record<string, any>;
    gymDidAccount: string | null;
    pilatesDidAccount: string | null;
    bareDidAccount: string | null;
    address: string | null;
    addressDetail: string | null;
    branchTel: string | null;
    naverPlaceRepresentative: string | null;
    naverPlaceBusinessNumber: string | null;
    naverPlaceTel: string | null;
    point: number;
    bodyAnalysisPoint: number;
    timeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    isFnbEnabled: boolean;
    fnbTimeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    color: string | null;
    images: null;
    fnbImage: string | null;
    fnbScreenImages: null;
    tossClientKey: string | null;
    tossCultureClientKey: string | null;
    createdAt: string;
    updatedAt: string;
  };
}

export type UserStudentsListData = {
  id: number;
  isActivated: boolean;
  /** @maxLength 255 */
  username: string;
  name: string | null;
  phoneNumber: string | null;
  refreshToken: string | null;
  role: "USER" | "ADMIN";
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  password: string | null;
  fcmToken: string | null;
  profileImageUrl: string | null;
  entrancePhotoUrl: string | null;
  color: string | null;
  description: string | null;
  timeTable:
    | {
        isDayOff: boolean;
        open?: string;
        close?: string;
      }[]
    | null;
  isNotification: boolean;
  isAdNotification: boolean;
  isLinked: boolean;
  gender: ("MALE" | "FEMALE") | null;
  birth: string | null;
  address: string | null;
  isUnder14: boolean;
  parentName: string | null;
  parentPhoneNumber: string | null;
  isParentPhoneVerified: boolean;
  paymentPin: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  latestPresentAt: string | null;
  noShowPenaltyStartedAt: string | null;
  userStore: {
    id: number;
    userId: number;
    storeId: number;
    latestPresentAt: string | null;
    presentCount: number;
    monthlyPresentCount: number;
    classPresentCount: number;
    classMonthlyPresentCount: number;
    classCount: number;
    monthlyClassCount: number;
    monthlyNoShowCount: number;
    noShowPenaltyStartedAt: string | null;
    color: string | null;
    name: string | null;
    tossCustomerKey: string | null;
    hasRegisteredCard: boolean;
    createdAt: string;
    deletedAt: string | null;
  } | null;
  parentChildLink: {
    id: number;
    parentUserId: number;
    parentName: string | null;
    parentPhoneNumber: string | null;
    paymentConsentType: "ALWAYS_REQUIRE" | "NO_REQUIRE";
  } | null;
  memberships: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    locker: {
      id: number;
      storeId: number;
      type: "UNISEX" | "MALE" | "FEMALE";
      number: number;
      password: string | null;
      status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
      currentMembershipId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membershipSuspensions: {
      id: number;
      membershipId: number;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
    }[];
    membershipInstructors: {
      id: number;
      membershipId: number;
      userId: number;
      createdAt: string;
      updatedAt: string;
      user: {
        id: number;
        isActivated: boolean;
        /** @maxLength 255 */
        username: string;
        name: string | null;
        phoneNumber: string | null;
        refreshToken: string | null;
        role: "USER" | "ADMIN";
        adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
        password: string | null;
        fcmToken: string | null;
        profileImageUrl: string | null;
        entrancePhotoUrl: string | null;
        color: string | null;
        description: string | null;
        timeTable:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isNotification: boolean;
        isAdNotification: boolean;
        isLinked: boolean;
        gender: ("MALE" | "FEMALE") | null;
        birth: string | null;
        address: string | null;
        isUnder14: boolean;
        parentName: string | null;
        parentPhoneNumber: string | null;
        isParentPhoneVerified: boolean;
        paymentPin: string | null;
        deletedAt: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
    }[];
  }[];
}[];

export type UserQuitDeleteData = any;

export type UserDeleteData = any;

export type UserPartialUpdateData = any;

export interface UserDetailData {
  id: number;
  isActivated: boolean;
  /** @maxLength 255 */
  username: string;
  name: string | null;
  phoneNumber: string | null;
  refreshToken: string | null;
  role: "USER" | "ADMIN";
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  password: string | null;
  fcmToken: string | null;
  profileImageUrl: string | null;
  entrancePhotoUrl: string | null;
  color: string | null;
  description: string | null;
  timeTable:
    | {
        isDayOff: boolean;
        open?: string;
        close?: string;
      }[]
    | null;
  isNotification: boolean;
  isAdNotification: boolean;
  isLinked: boolean;
  gender: ("MALE" | "FEMALE") | null;
  birth: string | null;
  address: string | null;
  isUnder14: boolean;
  parentName: string | null;
  parentPhoneNumber: string | null;
  isParentPhoneVerified: boolean;
  paymentPin: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  latestPresentAt: string | null;
  noShowPenaltyStartedAt: string | null;
  userStore: {
    id: number;
    userId: number;
    storeId: number;
    latestPresentAt: string | null;
    presentCount: number;
    monthlyPresentCount: number;
    classPresentCount: number;
    classMonthlyPresentCount: number;
    classCount: number;
    monthlyClassCount: number;
    monthlyNoShowCount: number;
    noShowPenaltyStartedAt: string | null;
    color: string | null;
    name: string | null;
    tossCustomerKey: string | null;
    hasRegisteredCard: boolean;
    createdAt: string;
    deletedAt: string | null;
  } | null;
  parentChildLink: {
    id: number;
    parentUserId: number;
    parentName: string | null;
    parentPhoneNumber: string | null;
    paymentConsentType: "ALWAYS_REQUIRE" | "NO_REQUIRE";
  } | null;
  memberships: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    locker: {
      id: number;
      storeId: number;
      type: "UNISEX" | "MALE" | "FEMALE";
      number: number;
      password: string | null;
      status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
      currentMembershipId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membershipSuspensions: {
      id: number;
      membershipId: number;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
    }[];
    membershipInstructors: {
      id: number;
      membershipId: number;
      userId: number;
      createdAt: string;
      updatedAt: string;
      user: {
        id: number;
        isActivated: boolean;
        /** @maxLength 255 */
        username: string;
        name: string | null;
        phoneNumber: string | null;
        refreshToken: string | null;
        role: "USER" | "ADMIN";
        adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
        password: string | null;
        fcmToken: string | null;
        profileImageUrl: string | null;
        entrancePhotoUrl: string | null;
        color: string | null;
        description: string | null;
        timeTable:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isNotification: boolean;
        isAdNotification: boolean;
        isLinked: boolean;
        gender: ("MALE" | "FEMALE") | null;
        birth: string | null;
        address: string | null;
        isUnder14: boolean;
        parentName: string | null;
        parentPhoneNumber: string | null;
        isParentPhoneVerified: boolean;
        paymentPin: string | null;
        deletedAt: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
    }[];
  }[];
}

export interface UserCreateData {
  id: number;
}

export type UserClassesListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  userCount: number;
}[];

export type UserStudentsList2Data = {
  id: number;
  isActivated: boolean;
  /** @maxLength 255 */
  username: string;
  name: string | null;
  phoneNumber: string | null;
  refreshToken: string | null;
  role: "USER" | "ADMIN";
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  password: string | null;
  fcmToken: string | null;
  profileImageUrl: string | null;
  entrancePhotoUrl: string | null;
  color: string | null;
  description: string | null;
  timeTable:
    | {
        isDayOff: boolean;
        open?: string;
        close?: string;
      }[]
    | null;
  isNotification: boolean;
  isAdNotification: boolean;
  isLinked: boolean;
  gender: ("MALE" | "FEMALE") | null;
  birth: string | null;
  address: string | null;
  isUnder14: boolean;
  parentName: string | null;
  parentPhoneNumber: string | null;
  isParentPhoneVerified: boolean;
  paymentPin: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  latestPresentAt: string | null;
  noShowPenaltyStartedAt: string | null;
  userStore: {
    id: number;
    userId: number;
    storeId: number;
    latestPresentAt: string | null;
    presentCount: number;
    monthlyPresentCount: number;
    classPresentCount: number;
    classMonthlyPresentCount: number;
    classCount: number;
    monthlyClassCount: number;
    monthlyNoShowCount: number;
    noShowPenaltyStartedAt: string | null;
    color: string | null;
    name: string | null;
    tossCustomerKey: string | null;
    hasRegisteredCard: boolean;
    createdAt: string;
    deletedAt: string | null;
  } | null;
  parentChildLink: {
    id: number;
    parentUserId: number;
    parentName: string | null;
    parentPhoneNumber: string | null;
    paymentConsentType: "ALWAYS_REQUIRE" | "NO_REQUIRE";
  } | null;
  memberships: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    locker: {
      id: number;
      storeId: number;
      type: "UNISEX" | "MALE" | "FEMALE";
      number: number;
      password: string | null;
      status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
      currentMembershipId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membershipSuspensions: {
      id: number;
      membershipId: number;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
    }[];
    membershipInstructors: {
      id: number;
      membershipId: number;
      userId: number;
      createdAt: string;
      updatedAt: string;
      user: {
        id: number;
        isActivated: boolean;
        /** @maxLength 255 */
        username: string;
        name: string | null;
        phoneNumber: string | null;
        refreshToken: string | null;
        role: "USER" | "ADMIN";
        adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
        password: string | null;
        fcmToken: string | null;
        profileImageUrl: string | null;
        entrancePhotoUrl: string | null;
        color: string | null;
        description: string | null;
        timeTable:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isNotification: boolean;
        isAdNotification: boolean;
        isLinked: boolean;
        gender: ("MALE" | "FEMALE") | null;
        birth: string | null;
        address: string | null;
        isUnder14: boolean;
        parentName: string | null;
        parentPhoneNumber: string | null;
        isParentPhoneVerified: boolean;
        paymentPin: string | null;
        deletedAt: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
    }[];
  }[];
}[];

export interface UserReservationCountListData {
  reservedCount: number;
  canceledCount: number;
  presentCount: number;
  noshowCount: number;
}

export type UserInbodyHistoriesListData = {
  id: number;
  userId: number;
  phoneNumber: string | null;
  weight: number | null;
  weightStatus: ("UP" | "DOWN" | "STABLE") | null;
  fat: number | null;
  fatStatus: ("UP" | "DOWN" | "STABLE") | null;
  muscle: number | null;
  muscleStatus: ("UP" | "DOWN" | "STABLE") | null;
  fatPercentage: number | null;
  fatPercentageStatus: ("UP" | "DOWN" | "STABLE") | null;
  BMR: number | null;
  rawData:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type UserInbodyHistoriesList2Data = {
  id: number;
  userId: number;
  phoneNumber: string | null;
  weight: number | null;
  weightStatus: ("UP" | "DOWN" | "STABLE") | null;
  fat: number | null;
  fatStatus: ("UP" | "DOWN" | "STABLE") | null;
  muscle: number | null;
  muscleStatus: ("UP" | "DOWN" | "STABLE") | null;
  fatPercentage: number | null;
  fatPercentageStatus: ("UP" | "DOWN" | "STABLE") | null;
  BMR: number | null;
  rawData:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type UserMembershipHistoriesListData = {
  id: number;
  adminUserId: number | null;
  membershipId: number;
  action: "CREATE" | "UPDATE" | "EXTEND" | "SUSPENSION" | "UNSUSPENSION";
  before: {
    capacity?: number;
    count?: number;
    startedAt?: string;
    endedAt?: string;
    suspensionStartedAt?: string;
    suspensionEndedAt?: string;
    membershipInstructorsNames?: string[];
    cancelableCount?: number;
    lockerId?: number | null;
    lockerNumber?: number | null;
    lockerType?: "UNISEX" | "MALE" | "FEMALE" | null;
  } | null;
  after: {
    capacity?: number;
    count?: number;
    startedAt?: string;
    endedAt?: string;
    suspensionStartedAt?: string;
    suspensionEndedAt?: string;
    membershipInstructorsNames?: string[];
    cancelableCount?: number;
    lockerId?: number | null;
    lockerNumber?: number | null;
    lockerType?: "UNISEX" | "MALE" | "FEMALE" | null;
  } | null;
  description: string | null;
  createdAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  membership: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    locker: {
      id: number;
      storeId: number;
      type: "UNISEX" | "MALE" | "FEMALE";
      number: number;
      password: string | null;
      status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
      currentMembershipId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
}[];

export type UserMembershipHistoriesList2Data = {
  id: number;
  adminUserId: number | null;
  membershipId: number;
  action: "CREATE" | "UPDATE" | "EXTEND" | "SUSPENSION" | "UNSUSPENSION";
  before: {
    capacity?: number;
    count?: number;
    startedAt?: string;
    endedAt?: string;
    suspensionStartedAt?: string;
    suspensionEndedAt?: string;
    membershipInstructorsNames?: string[];
    cancelableCount?: number;
    lockerId?: number | null;
    lockerNumber?: number | null;
    lockerType?: "UNISEX" | "MALE" | "FEMALE" | null;
  } | null;
  after: {
    capacity?: number;
    count?: number;
    startedAt?: string;
    endedAt?: string;
    suspensionStartedAt?: string;
    suspensionEndedAt?: string;
    membershipInstructorsNames?: string[];
    cancelableCount?: number;
    lockerId?: number | null;
    lockerNumber?: number | null;
    lockerType?: "UNISEX" | "MALE" | "FEMALE" | null;
  } | null;
  description: string | null;
  createdAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  membership: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    locker: {
      id: number;
      storeId: number;
      type: "UNISEX" | "MALE" | "FEMALE";
      number: number;
      password: string | null;
      status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
      currentMembershipId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
}[];

export type UserMemosListData = {
  id: number;
  userId: number;
  adminUserId: number;
  content: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type UserMemosCreateData = any;

export type UserMemosDeleteData = any;

export type UserMemosPartialUpdateData = any;

export type UserMembershipsListData = {
  id: number;
  userId: number;
  planId: number;
  capacity: number;
  count: number;
  reservationAvailableCount: number;
  cancelableCount: number;
  presentCount: number;
  canceledCount: number;
  noShowCount: number;
  lockerId: number | null;
  isSubscription: boolean;
  subscriptionStatus:
    | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
    | null;
  nextBillingDate: string | null;
  billingId: number | null;
  tossMethodKey: string | null;
  startedAt: string;
  endedAt: string;
  createdAt: string;
  updatedAt: string;
  locker: {
    id: number;
    storeId: number;
    type: "UNISEX" | "MALE" | "FEMALE";
    number: number;
    password: string | null;
    status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
    currentMembershipId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type UserMembershipsCreateData = any;

export type UserMembershipsPartialUpdateData = any;

export type UserExtendCreateData = any;

export type UserSuspendCreateData = any;

export type UserInstructorsListData = {
  id: number;
  isActivated: boolean;
  /** @maxLength 255 */
  username: string;
  name: string | null;
  phoneNumber: string | null;
  refreshToken: string | null;
  role: "USER" | "ADMIN";
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  password: string | null;
  fcmToken: string | null;
  profileImageUrl: string | null;
  entrancePhotoUrl: string | null;
  color: string | null;
  description: string | null;
  timeTable:
    | {
        isDayOff: boolean;
        open?: string;
        close?: string;
      }[]
    | null;
  isNotification: boolean;
  isAdNotification: boolean;
  isLinked: boolean;
  gender: ("MALE" | "FEMALE") | null;
  birth: string | null;
  address: string | null;
  isUnder14: boolean;
  parentName: string | null;
  parentPhoneNumber: string | null;
  isParentPhoneVerified: boolean;
  paymentPin: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  hasScheduledClass: boolean;
  userStore: {
    id: number;
    userId: number;
    storeId: number;
    latestPresentAt: string | null;
    presentCount: number;
    monthlyPresentCount: number;
    classPresentCount: number;
    classMonthlyPresentCount: number;
    classCount: number;
    monthlyClassCount: number;
    monthlyNoShowCount: number;
    noShowPenaltyStartedAt: string | null;
    color: string | null;
    name: string | null;
    tossCustomerKey: string | null;
    hasRegisteredCard: boolean;
    createdAt: string;
    deletedAt: string | null;
  } | null;
}[];

export type UserInstructorsAllListData = {
  id: number;
  isActivated: boolean;
  /** @maxLength 255 */
  username: string;
  name: string | null;
  phoneNumber: string | null;
  refreshToken: string | null;
  role: "USER" | "ADMIN";
  adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
  password: string | null;
  fcmToken: string | null;
  profileImageUrl: string | null;
  entrancePhotoUrl: string | null;
  color: string | null;
  description: string | null;
  timeTable:
    | {
        isDayOff: boolean;
        open?: string;
        close?: string;
      }[]
    | null;
  isNotification: boolean;
  isAdNotification: boolean;
  isLinked: boolean;
  gender: ("MALE" | "FEMALE") | null;
  birth: string | null;
  address: string | null;
  isUnder14: boolean;
  parentName: string | null;
  parentPhoneNumber: string | null;
  isParentPhoneVerified: boolean;
  paymentPin: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  hasScheduledClass: boolean;
  userStore: {
    id: number;
    userId: number;
    storeId: number;
    latestPresentAt: string | null;
    presentCount: number;
    monthlyPresentCount: number;
    classPresentCount: number;
    classMonthlyPresentCount: number;
    classCount: number;
    monthlyClassCount: number;
    monthlyNoShowCount: number;
    noShowPenaltyStartedAt: string | null;
    color: string | null;
    name: string | null;
    tossCustomerKey: string | null;
    hasRegisteredCard: boolean;
    createdAt: string;
    deletedAt: string | null;
  } | null;
}[];

export type UserInstructorsChangePasswordCreateData = any;

export type UserPenaltyDeleteData = any;

export type UserPaymentMethodsListData = any;

export type StoreListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  tel: string | null;
  phoneNumber: string | null;
  businessNumber: string | null;
  representative: string | null;
  types: (string | number | boolean | null) | any[] | Record<string, any>;
  gymDidAccount: string | null;
  pilatesDidAccount: string | null;
  bareDidAccount: string | null;
  address: string | null;
  addressDetail: string | null;
  branchTel: string | null;
  naverPlaceRepresentative: string | null;
  naverPlaceBusinessNumber: string | null;
  naverPlaceTel: string | null;
  point: number;
  bodyAnalysisPoint: number;
  timeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  isFnbEnabled: boolean;
  fnbTimeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  color: string | null;
  images: null;
  fnbImage: string | null;
  fnbScreenImages: null;
  tossClientKey: string | null;
  tossCultureClientKey: string | null;
  createdAt: string;
  updatedAt: string;
  username: string;
  adminName: string;
  hasScheduledClass: boolean;
}[];

export type StoreCreateData = any;

export type StorePartialUpdateData = any;

export interface StoreMyListData {
  id: number;
  /** @maxLength 255 */
  name: string;
  tel: string | null;
  phoneNumber: string | null;
  businessNumber: string | null;
  representative: string | null;
  types: (string | number | boolean | null) | any[] | Record<string, any>;
  gymDidAccount: string | null;
  pilatesDidAccount: string | null;
  bareDidAccount: string | null;
  address: string | null;
  addressDetail: string | null;
  branchTel: string | null;
  naverPlaceRepresentative: string | null;
  naverPlaceBusinessNumber: string | null;
  naverPlaceTel: string | null;
  point: number;
  bodyAnalysisPoint: number;
  timeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  isFnbEnabled: boolean;
  fnbTimeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  color: string | null;
  images: null;
  fnbImage: string | null;
  fnbScreenImages: null;
  tossClientKey: string | null;
  tossCultureClientKey: string | null;
  createdAt: string;
  updatedAt: string;
}

export type StoreStoreDeleteData = any;

export type StoreStorePartialUpdateData = any;

export interface StoreSettingsListData {
  id: number;
  storeId: number;
  reservationAvailableHour: number;
  groupClassCancelHour: number;
  groupClassWaitingCancelHour: number;
  privateClassCancelHour: number;
  sameDayChangeHour: number;
  waitingAutoReserveHour: number;
  dailyReservationLimit: number;
  closingTimeInterval: number;
  checkInScreenImage: string | null;
  isQrEntranceEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StoreSettingsCreateData {
  id: number;
  storeId: number;
  reservationAvailableHour: number;
  groupClassCancelHour: number;
  groupClassWaitingCancelHour: number;
  privateClassCancelHour: number;
  sameDayChangeHour: number;
  waitingAutoReserveHour: number;
  dailyReservationLimit: number;
  closingTimeInterval: number;
  checkInScreenImage: string | null;
  isQrEntranceEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StorePermissionsListData {
  id: number;
  storeId: number;
  instructorGroupClassModifyYn: boolean;
  instructorPrivateClassCreateYn: boolean;
  instructorPrivateClassModifyYn: boolean;
  instructorPrivateClassReserveModifyYn: boolean;
  instructorPrivateClassDeleteYn: boolean;
  otherInstructorGroupClassViewYn: boolean;
  otherInstructorPrivateClassViewYn: boolean;
  memberListViewYn: boolean;
  memberCreateYn: boolean;
  memberTicketModifyYn: boolean;
  instructorListViewYn: boolean;
  ticketCreateYn: boolean;
  ticketModifyYn: boolean;
  operationSettingYn: boolean;
  fnbProductCreateYn: boolean;
  fnbProductModifyYn: boolean;
  fnbCategoryManageYn: boolean;
  fnbProductOrderYn: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StoreStorePermissionsCreateData {
  id: number;
  storeId: number;
  instructorGroupClassModifyYn: boolean;
  instructorPrivateClassCreateYn: boolean;
  instructorPrivateClassModifyYn: boolean;
  instructorPrivateClassReserveModifyYn: boolean;
  instructorPrivateClassDeleteYn: boolean;
  otherInstructorGroupClassViewYn: boolean;
  otherInstructorPrivateClassViewYn: boolean;
  memberListViewYn: boolean;
  memberCreateYn: boolean;
  memberTicketModifyYn: boolean;
  instructorListViewYn: boolean;
  ticketCreateYn: boolean;
  ticketModifyYn: boolean;
  operationSettingYn: boolean;
  fnbProductCreateYn: boolean;
  fnbProductModifyYn: boolean;
  fnbCategoryManageYn: boolean;
  fnbProductOrderYn: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StoreNotificationsListData {
  id: number;
  storeId: number;
  ticketExpireDays: number;
  ticketExpireTemplate: string;
  ticketExpireNotificationType: "PUSH" | "SMS";
  ticketRemainCount: number;
  ticketRemainTemplate: string;
  ticketRemainNotificationType: "PUSH" | "SMS";
  pausePeriodExpireDays: number;
  pausePeriodExpireTemplate: string;
  pausePeriodExpireNotificationType: "PUSH" | "SMS";
  waitingToReserveTemplate: string;
  waitingToReserveNotificationType: "PUSH" | "SMS";
  groupClassStartHour: number;
  groupClassStartTemplate: string;
  groupClassStartNotificationType: "PUSH" | "SMS";
  privateClassStartHour: number;
  privateClassStartTemplate: string;
  privateClassStartNotificationType: "PUSH" | "SMS";
  birthdayTemplate: string;
  birthdayNotificationType: "PUSH" | "SMS";
  createdAt: string;
  updatedAt: string;
}

export interface StoreNotificationsPartialUpdateData {
  id: number;
  storeId: number;
  ticketExpireDays: number;
  ticketExpireTemplate: string;
  ticketExpireNotificationType: "PUSH" | "SMS";
  ticketRemainCount: number;
  ticketRemainTemplate: string;
  ticketRemainNotificationType: "PUSH" | "SMS";
  pausePeriodExpireDays: number;
  pausePeriodExpireTemplate: string;
  pausePeriodExpireNotificationType: "PUSH" | "SMS";
  waitingToReserveTemplate: string;
  waitingToReserveNotificationType: "PUSH" | "SMS";
  groupClassStartHour: number;
  groupClassStartTemplate: string;
  groupClassStartNotificationType: "PUSH" | "SMS";
  privateClassStartHour: number;
  privateClassStartTemplate: string;
  privateClassStartNotificationType: "PUSH" | "SMS";
  birthdayTemplate: string;
  birthdayNotificationType: "PUSH" | "SMS";
  createdAt: string;
  updatedAt: string;
}

export interface StorePaymentSettingsListData {
  id: number;
  storeId: number;
  tossSecretKey: string | null;
  tossCultureSecretKey: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface StorePaymentSettingsCreateData {
  id: number;
  storeId: number;
  tossSecretKey: string | null;
  tossCultureSecretKey: string | null;
  createdAt: string;
  updatedAt: string;
}

export type StoreRoomsListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  storeId: number | null;
  createdAt: string;
  updatedAt: string;
}[];

export type StoreRoomsCreateData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  storeId: number | null;
  createdAt: string;
  updatedAt: string;
}[];

export interface MembershipListData {
  id: number;
  userId: number;
  planId: number;
  capacity: number;
  count: number;
  reservationAvailableCount: number;
  cancelableCount: number;
  presentCount: number;
  canceledCount: number;
  noShowCount: number;
  lockerId: number | null;
  isSubscription: boolean;
  subscriptionStatus:
    | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
    | null;
  nextBillingDate: string | null;
  billingId: number | null;
  tossMethodKey: string | null;
  startedAt: string;
  endedAt: string;
  createdAt: string;
  updatedAt: string;
}

export type MembershipCreateData = any;

export type MembershipDeleteData = any;

export type MembershipSuspendDeleteData = any;

export type MembershipSuspendCreateData = any;

export type MembershipPlanListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  durationType: "COUNT_BASED" | "PERIOD_BASED";
  storeId: number | null;
  classType: "GROUP" | "PRIVATE";
  color: string | null;
  count: number;
  cancelableCount: number;
  durationDays: number | null;
  maxCapacity: number | null;
  liked: boolean;
  isActive: boolean;
  groupId: number | null;
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  price: number;
  sellOnApp: boolean;
  monthlyPrice: number | null;
  subscriptionDiscount: number | null;
  discountAppliedMonths: number | null;
  validityDays: number | null;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  group: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    productType:
      | ("CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER")
      | null;
    paymentType: ("ONE_TIME" | "SUBSCRIPTION") | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type MembershipPlanCreateData = any;

export interface MembershipPlanDetailData {
  id: number;
  /** @maxLength 255 */
  name: string;
  durationType: "COUNT_BASED" | "PERIOD_BASED";
  storeId: number | null;
  classType: "GROUP" | "PRIVATE";
  color: string | null;
  count: number;
  cancelableCount: number;
  durationDays: number | null;
  maxCapacity: number | null;
  liked: boolean;
  isActive: boolean;
  groupId: number | null;
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  price: number;
  sellOnApp: boolean;
  monthlyPrice: number | null;
  subscriptionDiscount: number | null;
  discountAppliedMonths: number | null;
  validityDays: number | null;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  group: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    productType:
      | ("CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER")
      | null;
    paymentType: ("ONE_TIME" | "SUBSCRIPTION") | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}

export type MembershipPlanMembershipsListData = {
  id: number;
  userId: number;
  planId: number;
  capacity: number;
  count: number;
  reservationAvailableCount: number;
  cancelableCount: number;
  presentCount: number;
  canceledCount: number;
  noShowCount: number;
  lockerId: number | null;
  isSubscription: boolean;
  subscriptionStatus:
    | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
    | null;
  nextBillingDate: string | null;
  billingId: number | null;
  tossMethodKey: string | null;
  startedAt: string;
  endedAt: string;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  membershipSuspensions: {
    id: number;
    membershipId: number;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
  }[];
}[];

export interface MembershipPlanStatusPartialUpdateData {
  success: boolean;
}

export type MembershipGroupListData = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}[];

export type MembershipGroupCreateData = boolean;

export interface MembershipGroupDetailData {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export type MembershipGroupUpdateData = boolean;

export type MembershipGroupDeleteData = any;

export type ClassListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userCount: number;
  reservations: {
    id: number;
    userId: number;
    classId: number;
    status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
    membershipId: number;
    deductionCount: number;
    canceledAt: string | null;
    membershipMaxCount: number | null;
    membershipReservationAvailableCount: number | null;
    membershipStartedAt: string | null;
    membershipEndedAt: string | null;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      plan: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId: number | null;
        classType: "GROUP" | "PRIVATE";
        color: string | null;
        count: number;
        cancelableCount: number;
        durationDays: number | null;
        maxCapacity: number | null;
        liked: boolean;
        isActive: boolean;
        groupId: number | null;
        productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType: "ONE_TIME" | "SUBSCRIPTION";
        price: number;
        sellOnApp: boolean;
        monthlyPrice: number | null;
        subscriptionDiscount: number | null;
        discountAppliedMonths: number | null;
        validityDays: number | null;
        displayOrder: number;
        createdAt: string;
        updatedAt: string;
      };
    } | null;
  }[];
}[];

export type ClassBulkOpenCreateData = any;

export type ClassBulkDeleteDeleteData = any;

export type ClassBulkUpdateCreateData = any;

export type ClassReservationsListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  deletedUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userCount: number;
  classAvailablePlans: {
    id: number;
    classId: number;
    planId: number;
    createdAt: string;
    updatedAt: string;
  }[];
  reservations: {
    id: number;
    userId: number;
    classId: number;
    status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
    membershipId: number;
    deductionCount: number;
    canceledAt: string | null;
    membershipMaxCount: number | null;
    membershipReservationAvailableCount: number | null;
    membershipStartedAt: string | null;
    membershipEndedAt: string | null;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      plan: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId: number | null;
        classType: "GROUP" | "PRIVATE";
        color: string | null;
        count: number;
        cancelableCount: number;
        durationDays: number | null;
        maxCapacity: number | null;
        liked: boolean;
        isActive: boolean;
        groupId: number | null;
        productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType: "ONE_TIME" | "SUBSCRIPTION";
        price: number;
        sellOnApp: boolean;
        monthlyPrice: number | null;
        subscriptionDiscount: number | null;
        discountAppliedMonths: number | null;
        validityDays: number | null;
        displayOrder: number;
        createdAt: string;
        updatedAt: string;
      };
      membershipSuspensions: {
        id: number;
        membershipId: number;
        startedAt: string;
        endedAt: string;
        createdAt: string;
        updatedAt: string;
      }[];
    } | null;
  }[];
}[];

export type ClassDeletedListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  deletedUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userCount: number;
  classAvailablePlans: {
    id: number;
    classId: number;
    planId: number;
    createdAt: string;
    updatedAt: string;
  }[];
  reservations: {
    id: number;
    userId: number;
    classId: number;
    status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
    membershipId: number;
    deductionCount: number;
    canceledAt: string | null;
    membershipMaxCount: number | null;
    membershipReservationAvailableCount: number | null;
    membershipStartedAt: string | null;
    membershipEndedAt: string | null;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      plan: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId: number | null;
        classType: "GROUP" | "PRIVATE";
        color: string | null;
        count: number;
        cancelableCount: number;
        durationDays: number | null;
        maxCapacity: number | null;
        liked: boolean;
        isActive: boolean;
        groupId: number | null;
        productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType: "ONE_TIME" | "SUBSCRIPTION";
        price: number;
        sellOnApp: boolean;
        monthlyPrice: number | null;
        subscriptionDiscount: number | null;
        discountAppliedMonths: number | null;
        validityDays: number | null;
        displayOrder: number;
        createdAt: string;
        updatedAt: string;
      };
      membershipSuspensions: {
        id: number;
        membershipId: number;
        startedAt: string;
        endedAt: string;
        createdAt: string;
        updatedAt: string;
      }[];
    } | null;
  }[];
}[];

export interface ClassDetailData {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userCount: number;
  classAvailablePlans: {
    id: number;
    classId: number;
    planId: number;
    createdAt: string;
    updatedAt: string;
  }[];
  reservations: {
    id: number;
    userId: number;
    classId: number;
    status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
    membershipId: number;
    deductionCount: number;
    canceledAt: string | null;
    membershipMaxCount: number | null;
    membershipReservationAvailableCount: number | null;
    membershipStartedAt: string | null;
    membershipEndedAt: string | null;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      plan: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId: number | null;
        classType: "GROUP" | "PRIVATE";
        color: string | null;
        count: number;
        cancelableCount: number;
        durationDays: number | null;
        maxCapacity: number | null;
        liked: boolean;
        isActive: boolean;
        groupId: number | null;
        productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType: "ONE_TIME" | "SUBSCRIPTION";
        price: number;
        sellOnApp: boolean;
        monthlyPrice: number | null;
        subscriptionDiscount: number | null;
        discountAppliedMonths: number | null;
        validityDays: number | null;
        displayOrder: number;
        createdAt: string;
        updatedAt: string;
      };
    } | null;
  }[];
  groupClass: {
    id: number;
    /** @maxLength 255 */
    name: string;
    maxCapacity: number;
    reservationAvailableHour: number | null;
    classCancelHour: number;
    classWaitingCancelHour: number;
    sameDayChangeHour: number | null;
    startedAt: string;
    endedAt: string;
    timeTable: {
      day: number;
      start: string;
      end: string;
      adminUserId: number;
      roomId: number | null;
    }[];
    storeId: number;
    openedAt: string | null;
    createdAt: string;
    updatedAt: string;
    groupClassesPlans: {
      id: number;
      groupClassId: number;
      planId: number;
      createdAt: string;
      updatedAt: string;
      plan: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId: number | null;
        classType: "GROUP" | "PRIVATE";
        color: string | null;
        count: number;
        cancelableCount: number;
        durationDays: number | null;
        maxCapacity: number | null;
        liked: boolean;
        isActive: boolean;
        groupId: number | null;
        productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType: "ONE_TIME" | "SUBSCRIPTION";
        price: number;
        sellOnApp: boolean;
        monthlyPrice: number | null;
        subscriptionDiscount: number | null;
        discountAppliedMonths: number | null;
        validityDays: number | null;
        displayOrder: number;
        createdAt: string;
        updatedAt: string;
      };
    }[];
  } | null;
}

export type ClassDeleteData = any;

export type ClassPartialUpdateData = any;

export type ClassPrivateCreateData = any;

export type ClassMemosListData = {
  id: number;
  classId: number;
  adminUserId: number;
  content: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type ClassMemosCreateData = any;

export type ClassMemosDeleteData = any;

export type ClassMemosPartialUpdateData = any;

export type ClassInstructorPrivateListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  userCount: number;
}[];

export interface ClassNavigationListData {
  previousClassId: number | null;
  nextClassId: number | null;
}

export type GroupClassCreateData = any;

export type GroupClassPartialUpdateData = any;

export type GroupClassCheckConflictCreateData = any;

export type GroupClassInstructorsDetailData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  timeTable: {
    day: number;
    start: string;
    end: string;
    adminUserId: number;
    roomId: number | null;
  }[];
  storeId: number;
  openedAt: string | null;
  createdAt: string;
  updatedAt: string;
}[];

export interface PaymentAuthCallbackCreateData {
  id: number;
}

export type MessagesPurchaseCreateData = string;

export type MessagesPurchaseBillingCreateData = any;

export type MessagesListData = {
  id: number;
  senderId: number;
  storeId: number | null;
  title: string | null;
  message: string;
  type: "SMS" | "LMS" | "MMS";
  scheduleAt: string | null;
  imageUrls: string[] | null;
  usingPoint: number;
  createdAt: string;
  updatedAt: string;
  messageHistories: {
    id: number;
    userId: number;
    messageId: number;
    requestId: string | null;
    status: "PENDING" | "SENT" | "FAILED" | "CANCELLED";
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    };
  }[];
}[];

export type MessagesCreateData = any;

export type MessagesPushListData = {
  id: number;
  senderId: number;
  storeId: number | null;
  title: string | null;
  message: string;
  scheduleAt: string | null;
  jobScheduleId: number | null;
  createdAt: string;
  updatedAt: string;
  pushNotificationHistories: {
    id: number;
    userId: number;
    pushNotificationId: number;
    status: "PENDING" | "SENT" | "FAILED" | "CANCELLED";
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
      userStores: {
        id: number;
        userId: number;
        storeId: number;
        latestPresentAt: string | null;
        presentCount: number;
        monthlyPresentCount: number;
        classPresentCount: number;
        classMonthlyPresentCount: number;
        classCount: number;
        monthlyClassCount: number;
        monthlyNoShowCount: number;
        noShowPenaltyStartedAt: string | null;
        color: string | null;
        name: string | null;
        tossCustomerKey: string | null;
        hasRegisteredCard: boolean;
        createdAt: string;
        deletedAt: string | null;
      }[];
    };
  }[];
}[];

export type MessagesPushCreateData = any;

export type MessagesDeleteData = any;

export type MessagesPushDeleteData = any;

export type MessagesPointPaymentHistoriesListData = {
  id: number;
  userId: number;
  storeId: number | null;
  addedPoint: number;
  afterPoint: number;
  amount: number;
  tid: string | null;
  paymentMethod: "CARD" | "PHONE" | "KAKAO" | "BILLING" | "NAVER";
  approvalCode: string | null;
  createdAt: string;
}[];

export type MessagesAllPointPaymentHistoriesListData = {
  id: number;
  storeId: number | null;
  addedPoint: number;
  afterPoint: number;
  createdAt: string | null;
  type: "SMS" | "BODY_ANALYSIS";
  userId?: number | null;
  amount?: number | null;
  tid?: string | null;
  paymentMethod?: string | null;
  approvalCode?: string | null;
  adminUserId?: number | null;
  beforePoint?: number | null;
  reason?: string | null;
}[];

export type BillingsRegisterCreateData = string;

export type BillingsUnauthRegisterCreateData = any;

export type BillingsDeleteData = any;

export type BillingsListData = {
  id: number;
  storeId: number;
  cardName: string | null;
  cardCi: string | null;
  createdAt: string;
  updatedAt: string;
}[];

export type ReservationsPartialUpdateData = any;

export type ReservationsDeleteData = any;

export type ReservationsUserDetailData = {
  id: number;
  userId: number;
  classId: number;
  status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
  membershipId: number;
  deductionCount: number;
  canceledAt: string | null;
  membershipMaxCount: number | null;
  membershipReservationAvailableCount: number | null;
  membershipStartedAt: string | null;
  membershipEndedAt: string | null;
  createdAt: string;
  updatedAt: string;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  class: {
    id: number;
    /** @maxLength 255 */
    name: string;
    maxCapacity: number;
    type: "GROUP" | "PRIVATE";
    reservationAvailableHour: number | null;
    classCancelHour: number;
    classWaitingCancelHour: number;
    sameDayChangeHour: number | null;
    startedAt: string;
    endedAt: string;
    roomId: number | null;
    adminUserId: number | null;
    isReservationEnabled: boolean;
    deductionCount: number;
    groupClassId: number | null;
    storeId: number;
    deletedReason: string | null;
    deletedUserId: number | null;
    openedAt: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
    userCount: number;
  } | null;
  instructor: string;
}[];

export interface ReservationsUserReservationsListData {
  reservations: {
    id: number;
    startedAt: string;
    endedAt: string;
    roomName: string;
    instructor: string;
    name: string;
  }[];
  userName: string;
  userStoreName: string;
  memberships: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      name: string | null;
      profileImageUrl: string | null;
      phoneNumber: string | null;
    } | null;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
  }[];
}

export interface ReservationsCreateData {
  waitingCount?: number;
}

export type ReservationsPresentCreateData = any;

export type ReservationsAttendanceHistoryDeleteData = any;

export type DietListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  imageUrl: string | null;
  protein: number;
  carbs: number;
  fat: number;
  size: number;
  allergens: string[] | null;
  benefits: string[] | null;
  source: "PROTEIN" | "CARBS" | "FAT";
  createdAt: string;
  updatedAt: string;
}[];

export type DietCreateData = any;

export interface DietDetailData {
  id: number;
  /** @maxLength 255 */
  name: string;
  imageUrl: string | null;
  protein: number;
  carbs: number;
  fat: number;
  size: number;
  allergens: string[] | null;
  benefits: string[] | null;
  source: "PROTEIN" | "CARBS" | "FAT";
  createdAt: string;
  updatedAt: string;
}

export type DietPartialUpdateData = any;

export type DietDeleteData = any;

export interface BodyCheckUserListData {
  name: string;
}

export interface BodyCreateData {
  success: boolean;
}

export type BodyHistoriesDetailData = {
  id: number;
  userId: number;
  adminUserId: number | null;
  /** @maxLength 500 */
  frontImageUrl: string;
  /** @maxLength 500 */
  rightSideImageUrl: string;
  /** @maxLength 500 */
  leftSideImageUrl: string;
  /** @maxLength 500 */
  frontAnalysisImagePath: string;
  /** @maxLength 500 */
  rightSideAnalysisImagePath: string;
  /** @maxLength 500 */
  leftSideAnalysisImagePath: string;
  frontAnalysisData: {
    far_coords?: string;
    /** 머리 균형도(머리 기울기). degree 단위 */
    far_head_bal_m_?: number;
    /**
     * 머리 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_head_bal_grade?: number;
    /** 골반 균형도(골반 기울기). degree 단위 */
    far_pelvic_bal_m_?: number;
    /**
     * 골반 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_pelvic_bal_grade?: number;
    /** 어깨 균형도(어깨 기울기). degree 단위 */
    far_shoulder_bal_m_?: number;
    /**
     * 어깨 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_shoulder_bal_grade?: number;
    /** 왼쪽 오다리 값. degree 단위 */
    far_left_qang_m_?: number;
    /**
     * 왼쪽 오다리 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_left_qang_grade?: number;
    /** 오른쪽 오다리 값. degree 단위 */
    far_right_qang_m_?: number;
    /**
     * 오른쪽 오다리 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_right_qang_grade?: number;
    /** 무릎 균형도(무릎 기울기). degree 단위 */
    far_knee_bal_m_?: number;
    /**
     * 무릎 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_knee_bal_grade?: number;
    /** 정면 축 기울기(좌우 기울기). degree 단위 */
    far_tilt_m_?: number;
    /**
     * 정면 축 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_tilt_grade?: number;
  } | null;
  rightSideAnalysisData: {
    sar_coords?: string;
    /** 굽은 어깨 기울기. degree 단위 */
    round_shoulder_m_?: number;
    /**
     * 굽은 어깨 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    round_shoulder_grade?: number;
    /** 측면 머리 균형도(머리 앞뒤 기울기). degree 단위 */
    sar_head_tilt_m_?: number;
    /**
     * 측면 머리 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_head_tilt_grade?: number;
    /** 측면 기울기(전신 앞뒤 기울기). degree 단위 */
    sar_tilt_m_?: number;
    /**
     * 측면 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_tilt_grade?: number;
    /** 거북목 기울기. degree 단위 */
    turtle_neck_m_?: number;
    /**
     * 거북목 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    turtle_neck_grade?: number;
  } | null;
  leftSideAnalysisData: {
    sar_coords?: string;
    /** 굽은 어깨 기울기. degree 단위 */
    round_shoulder_m_?: number;
    /**
     * 굽은 어깨 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    round_shoulder_grade?: number;
    /** 측면 머리 균형도(머리 앞뒤 기울기). degree 단위 */
    sar_head_tilt_m_?: number;
    /**
     * 측면 머리 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_head_tilt_grade?: number;
    /** 측면 기울기(전신 앞뒤 기울기). degree 단위 */
    sar_tilt_m_?: number;
    /**
     * 측면 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_tilt_grade?: number;
    /** 거북목 기울기. degree 단위 */
    turtle_neck_m_?: number;
    /**
     * 거북목 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    turtle_neck_grade?: number;
  } | null;
  createdAt: string;
  updatedAt: string;
}[];

export type DietScheduleListData = {
  id: number;
  userId: number;
  scheduleDate: string;
  mealNumber: number;
  mealTime: string;
  targetCarbs: number;
  targetProtein: number;
  targetFat: number;
  totalCalories: number;
  isCompleted: boolean;
  foods: {
    id: number;
    name: string;
    imageUrl: string | null;
    grams: number;
    protein: number;
    carbs: number;
    fat: number;
    createdAt: string;
    updatedAt: string;
  }[];
  createdAt: string;
  updatedAt: string;
}[];

export type DietScheduleDailyDietPreferencesListData = {
  id: number;
  userId: number;
  preferenceDate: string;
  wakeUpTime: string;
  exerciseTime: string;
  mealsPerDay: number;
  recommendedCalories: number;
  isCustomized: boolean;
  createdAt: string;
  updatedAt: string;
}[];

export type DietPreferencesListData = {
  id: number;
  userId: number;
  height: number;
  weight: number;
  birthDate: string;
  gender: "MALE" | "FEMALE";
  exerciseLevel: "NONE" | "LIGHT" | "MODERATE" | "ACTIVE" | "VERY_ACTIVE";
  exerciseGoal: "DIET" | "HEALTH" | "MUSCLE_GAIN";
  mealsPerDay: number;
  wakeUpTime: string | null;
  exerciseTime: string | null;
  allergies: string[];
  createdAt: string;
  updatedAt: string;
} | null;

export type ProductsListData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  durationType: "COUNT_BASED" | "PERIOD_BASED";
  storeId: number | null;
  classType: "GROUP" | "PRIVATE";
  color: string | null;
  count: number;
  cancelableCount: number;
  durationDays: number | null;
  maxCapacity: number | null;
  liked: boolean;
  isActive: boolean;
  groupId: number | null;
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  price: number;
  sellOnApp: boolean;
  monthlyPrice: number | null;
  subscriptionDiscount: number | null;
  discountAppliedMonths: number | null;
  validityDays: number | null;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  group: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    productType:
      | ("CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER")
      | null;
    paymentType: ("ONE_TIME" | "SUBSCRIPTION") | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export interface ProductsCreateData {
  id: number;
}

export interface ProductsDetailData {
  id: number;
  /** @maxLength 255 */
  name: string;
  durationType: "COUNT_BASED" | "PERIOD_BASED";
  storeId: number | null;
  classType: "GROUP" | "PRIVATE";
  color: string | null;
  count: number;
  cancelableCount: number;
  durationDays: number | null;
  maxCapacity: number | null;
  liked: boolean;
  isActive: boolean;
  groupId: number | null;
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  price: number;
  sellOnApp: boolean;
  monthlyPrice: number | null;
  subscriptionDiscount: number | null;
  discountAppliedMonths: number | null;
  validityDays: number | null;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  group: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    productType:
      | ("CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER")
      | null;
    paymentType: ("ONE_TIME" | "SUBSCRIPTION") | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  addons: {
    id: number;
    name: string;
    productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
    price: number;
    validityDays: number | null;
  }[];
}

export interface ProductsUpdateData {
  success: boolean;
}

export type ProductsDeleteData = any;

export interface ProductsStatusPartialUpdateData {
  success: boolean;
}

export interface ProductsOrderPartialUpdateData {
  success: boolean;
}

export type ProductGroupsListData = {
  id: number;
  name: string;
  productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType?: "ONE_TIME" | "SUBSCRIPTION";
  createdAt: string;
  updatedAt: string;
}[];

export type ProductGroupsCreateData = boolean;

export interface ProductGroupsDetailData {
  id: number;
  name: string;
  productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType?: "ONE_TIME" | "SUBSCRIPTION";
  createdAt: string;
  updatedAt: string;
}

export type ProductGroupsUpdateData = boolean;

export type ProductGroupsDeleteData = any;

export type PaymentHistoriesListData = {
  id: number;
  storeId: number;
  userId: number;
  planId: number;
  membershipId: number | null;
  paymentGroupId: string | null;
  paymentItemType: ("NORMAL" | "CULTURE") | null;
  isAddon: boolean;
  /** @maxLength 255 */
  orderNumber: string;
  transactionDate: string;
  status: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
  originalPaymentId: number | null;
  paymentMethod:
    | "CARD"
    | "KAKAO"
    | "NAVER"
    | "CASH"
    | "TRANSFER"
    | "BILLING"
    | "MIXED";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  paymentSource: "APP" | "IN_STORE";
  /** @maxLength 255 */
  productName: string;
  originalPrice: number;
  discountAmount: number;
  finalAmount: number;
  cardAmount: number | null;
  cashAmount: number | null;
  transferAmount: number | null;
  receivableAmount: number | null;
  /** @maxLength 255 */
  userName: string;
  /** @maxLength 50 */
  userPhone: string;
  pgTid: string | null;
  pgResponse: null;
  isCulturePayment: boolean;
  cultureAmount: number;
  culturePgTid: string | null;
  culturePgResponse:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  canRefund: boolean;
  refundAmount: number | null;
  refundReason: string | null;
  refundedAt: string | null;
  refundedBy: number | null;
  adminNote: string | null;
  adminUserId: number | null;
  createdAt: string;
  updatedAt: string;
}[];

export interface PaymentHistoriesRefundListData {
  originalPayment: {
    id: number;
    storeId: number;
    userId: number;
    planId: number;
    membershipId: number | null;
    paymentGroupId: string | null;
    paymentItemType: ("NORMAL" | "CULTURE") | null;
    isAddon: boolean;
    /** @maxLength 255 */
    orderNumber: string;
    transactionDate: string;
    status: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
    originalPaymentId: number | null;
    paymentMethod:
      | "CARD"
      | "KAKAO"
      | "NAVER"
      | "CASH"
      | "TRANSFER"
      | "BILLING"
      | "MIXED";
    paymentType: "ONE_TIME" | "SUBSCRIPTION";
    paymentSource: "APP" | "IN_STORE";
    /** @maxLength 255 */
    productName: string;
    originalPrice: number;
    discountAmount: number;
    finalAmount: number;
    cardAmount: number | null;
    cashAmount: number | null;
    transferAmount: number | null;
    receivableAmount: number | null;
    /** @maxLength 255 */
    userName: string;
    /** @maxLength 50 */
    userPhone: string;
    pgTid: string | null;
    pgResponse: null;
    isCulturePayment: boolean;
    cultureAmount: number;
    culturePgTid: string | null;
    culturePgResponse:
      | ((string | number | boolean | null) | any[] | Record<string, any>)
      | null;
    canRefund: boolean;
    refundAmount: number | null;
    refundReason: string | null;
    refundedAt: string | null;
    refundedBy: number | null;
    adminNote: string | null;
    adminUserId: number | null;
    createdAt: string;
    updatedAt: string;
  };
  refundPayment: {
    id: number;
    storeId: number;
    userId: number;
    planId: number;
    membershipId: number | null;
    paymentGroupId: string | null;
    paymentItemType: ("NORMAL" | "CULTURE") | null;
    isAddon: boolean;
    /** @maxLength 255 */
    orderNumber: string;
    transactionDate: string;
    status: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
    originalPaymentId: number | null;
    paymentMethod:
      | "CARD"
      | "KAKAO"
      | "NAVER"
      | "CASH"
      | "TRANSFER"
      | "BILLING"
      | "MIXED";
    paymentType: "ONE_TIME" | "SUBSCRIPTION";
    paymentSource: "APP" | "IN_STORE";
    /** @maxLength 255 */
    productName: string;
    originalPrice: number;
    discountAmount: number;
    finalAmount: number;
    cardAmount: number | null;
    cashAmount: number | null;
    transferAmount: number | null;
    receivableAmount: number | null;
    /** @maxLength 255 */
    userName: string;
    /** @maxLength 50 */
    userPhone: string;
    pgTid: string | null;
    pgResponse: null;
    isCulturePayment: boolean;
    cultureAmount: number;
    culturePgTid: string | null;
    culturePgResponse:
      | ((string | number | boolean | null) | any[] | Record<string, any>)
      | null;
    canRefund: boolean;
    refundAmount: number | null;
    refundReason: string | null;
    refundedAt: string | null;
    refundedBy: number | null;
    adminNote: string | null;
    adminUserId: number | null;
    createdAt: string;
    updatedAt: string;
  };
}

export interface PaymentHistoriesRefundCreateData {
  success: boolean;
}

export type LockerSettingsCreateData = any;

export type LockerSettingsListResult = {
  id: number;
  storeId: number;
  type: "UNISEX" | "MALE" | "FEMALE";
  rows: number;
  cols: number;
  startNumber: number;
  numberDirection: "HORIZONTAL" | "VERTICAL";
  startPosition: "TOP_LEFT" | "TOP_RIGHT" | "BOTTOM_LEFT" | "BOTTOM_RIGHT";
  createdAt: string;
  updatedAt: string;
}[];

export type LockerSettingsDetailData = any;

export type LockerGenerateCreateData = any;

export interface LockerListData {
  data: {
    id: number;
    storeId: number;
    type: "UNISEX" | "MALE" | "FEMALE";
    number: number;
    password: string | null;
    status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
    currentMembershipId: number | null;
    createdAt: string;
    updatedAt: string;
    currentMembership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      user: {
        id: number;
        isActivated: boolean;
        /** @maxLength 255 */
        username: string;
        name: string | null;
        phoneNumber: string | null;
        refreshToken: string | null;
        role: "USER" | "ADMIN";
        adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
        password: string | null;
        fcmToken: string | null;
        profileImageUrl: string | null;
        entrancePhotoUrl: string | null;
        color: string | null;
        description: string | null;
        timeTable:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isNotification: boolean;
        isAdNotification: boolean;
        isLinked: boolean;
        gender: ("MALE" | "FEMALE") | null;
        birth: string | null;
        address: string | null;
        isUnder14: boolean;
        parentName: string | null;
        parentPhoneNumber: string | null;
        isParentPhoneVerified: boolean;
        paymentPin: string | null;
        deletedAt: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      plan: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId: number | null;
        classType: "GROUP" | "PRIVATE";
        color: string | null;
        count: number;
        cancelableCount: number;
        durationDays: number | null;
        maxCapacity: number | null;
        liked: boolean;
        isActive: boolean;
        groupId: number | null;
        productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType: "ONE_TIME" | "SUBSCRIPTION";
        price: number;
        sellOnApp: boolean;
        monthlyPrice: number | null;
        subscriptionDiscount: number | null;
        discountAppliedMonths: number | null;
        validityDays: number | null;
        displayOrder: number;
        createdAt: string;
        updatedAt: string;
      } | null;
      membershipSuspensions: {
        id: number;
        membershipId: number;
        startedAt: string;
        endedAt: string;
        createdAt: string;
        updatedAt: string;
      }[];
    } | null;
  }[];
  total: number;
  page: number;
  limit: number;
}

export interface LockerDetailData {
  id: number;
  storeId: number;
  type: "UNISEX" | "MALE" | "FEMALE";
  number: number;
  password: string | null;
  status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
  currentMembershipId: number | null;
  createdAt: string;
  updatedAt: string;
  currentMembership: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
    membershipSuspensions: {
      id: number;
      membershipId: number;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
    }[];
  } | null;
  histories: {
    id: number;
    lockerId: number;
    membershipId: number | null;
    action:
      | "ASSIGNED"
      | "RELEASED"
      | "CHANGED"
      | "BROKEN"
      | "REPAIRED"
      | "PASSWORD_CHANGED";
    previousLockerId: number | null;
    newPassword: string | null;
    memo: string | null;
    adminUserId: number;
    createdAt: string;
    adminUser: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      user: {
        id: number;
        isActivated: boolean;
        /** @maxLength 255 */
        username: string;
        name: string | null;
        phoneNumber: string | null;
        refreshToken: string | null;
        role: "USER" | "ADMIN";
        adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
        password: string | null;
        fcmToken: string | null;
        profileImageUrl: string | null;
        entrancePhotoUrl: string | null;
        color: string | null;
        description: string | null;
        timeTable:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isNotification: boolean;
        isAdNotification: boolean;
        isLinked: boolean;
        gender: ("MALE" | "FEMALE") | null;
        birth: string | null;
        address: string | null;
        isUnder14: boolean;
        parentName: string | null;
        parentPhoneNumber: string | null;
        isParentPhoneVerified: boolean;
        paymentPin: string | null;
        deletedAt: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
    } | null;
  }[];
}

export type LockerDeleteData = any;

export type LockerAssignCreateData = any;

export type LockerReleaseCreateData = any;

export type LockerChangeCreateData = any;

export type LockerPasswordPartialUpdateData = any;

export type LockerBrokenPartialUpdateData = any;

export type LockerRepairPartialUpdateData = any;

export interface LockerHistoriesListData {
  data: {
    id: number;
    lockerId: number;
    membershipId: number | null;
    action:
      | "ASSIGNED"
      | "RELEASED"
      | "CHANGED"
      | "BROKEN"
      | "REPAIRED"
      | "PASSWORD_CHANGED";
    previousLockerId: number | null;
    newPassword: string | null;
    memo: string | null;
    adminUserId: number;
    createdAt: string;
    adminUser: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    membership: {
      id: number;
      userId: number;
      planId: number;
      capacity: number;
      count: number;
      reservationAvailableCount: number;
      cancelableCount: number;
      presentCount: number;
      canceledCount: number;
      noShowCount: number;
      lockerId: number | null;
      isSubscription: boolean;
      subscriptionStatus:
        | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
        | null;
      nextBillingDate: string | null;
      billingId: number | null;
      tossMethodKey: string | null;
      startedAt: string;
      endedAt: string;
      createdAt: string;
      updatedAt: string;
      user: {
        id: number;
        isActivated: boolean;
        /** @maxLength 255 */
        username: string;
        name: string | null;
        phoneNumber: string | null;
        refreshToken: string | null;
        role: "USER" | "ADMIN";
        adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
        password: string | null;
        fcmToken: string | null;
        profileImageUrl: string | null;
        entrancePhotoUrl: string | null;
        color: string | null;
        description: string | null;
        timeTable:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isNotification: boolean;
        isAdNotification: boolean;
        isLinked: boolean;
        gender: ("MALE" | "FEMALE") | null;
        birth: string | null;
        address: string | null;
        isUnder14: boolean;
        parentName: string | null;
        parentPhoneNumber: string | null;
        isParentPhoneVerified: boolean;
        paymentPin: string | null;
        deletedAt: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
    } | null;
  }[];
  total: number;
  page: number;
  limit: number;
}

export type AttendanceListResult = {
  attendanceId: number;
  userId: number;
  entrancePhotoUrl: string | null;
  name: string;
  enteredAt: string;
  products: {
    class: {
      name: string;
      remaining: string;
    };
    pt: {
      name: string;
      remaining: string;
    };
    membership: {
      name: string;
      remaining: string;
    };
    locker: {
      name: string;
      remaining: string;
    };
    clothing: {
      name: string;
      remaining: string;
    };
  };
}[];

export type AttendanceRealtimeListData = {
  attendanceId: number;
  userId: number;
  entrancePhotoUrl: string | null;
  name: string;
  enteredAt: string;
  products: {
    class: {
      name: string;
      remaining: string;
    };
    pt: {
      name: string;
      remaining: string;
    };
    membership: {
      name: string;
      remaining: string;
    };
    locker: {
      name: string;
      remaining: string;
    };
    clothing: {
      name: string;
      remaining: string;
    };
  };
}[];

export type FnbCategoriesListData = {
  id: number;
  name: string;
  displayOrder: number;
  isActive: boolean;
  subCategories: {
    id: number;
    name: string;
    displayOrder: number;
    isActive: boolean;
    productCount: number;
    createdAt: string;
    updatedAt: string;
  }[];
  createdAt: string;
  updatedAt: string;
}[];

export type FnbCategoriesStoreSettingsMainPartialUpdateData = any;

export type FnbCategoriesStoreSettingsSubPartialUpdateData = any;

export interface FnbCategoriesMainCreateData {
  id: number;
  name: string;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export type FnbCategoriesMainPartialUpdateData = any;

export type FnbCategoriesMainDeleteData = any;

export type FnbCategoriesMainOrderPartialUpdateData = any;

export interface FnbCategoriesSubCreateData {
  id: number;
  name: string;
  mainCategoryId: number;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export type FnbCategoriesSubPartialUpdateData = any;

export type FnbCategoriesSubDeleteData = any;

export type FnbCategoriesSubOrderPartialUpdateData = any;

export type FnbProductsListData = {
  id: number;
  name: string;
  subCategoryId: number;
  subCategoryName: string;
  mainCategoryId: number;
  mainCategoryName: string;
  imageUrl: string | null;
  price: number;
  isDiscounted: boolean;
  discountPrice: number | null;
  stock: number;
  description: string | null;
  color: string | null;
  sellOnApp: boolean;
  isSoldOut: boolean;
  isFirstPurchaseOnly: boolean;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}[];

export interface FnbProductsCreateData {
  id: number;
  name: string;
  subCategoryId: number;
  imageUrl: string | null;
  price: number;
  isDiscounted: boolean;
  discountPrice: number | null;
  stock: number;
  description: string | null;
  color: string | null;
  sellOnApp: boolean;
  isSoldOut: boolean;
  isFirstPurchaseOnly: boolean;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface FnbProductsDetailData {
  id: number;
  name: string;
  subCategoryId: number;
  subCategoryName: string;
  mainCategoryId: number;
  mainCategoryName: string;
  imageUrl: string | null;
  price: number;
  isDiscounted: boolean;
  discountPrice: number | null;
  stock: number;
  description: string | null;
  color: string | null;
  sellOnApp: boolean;
  isSoldOut: boolean;
  isFirstPurchaseOnly: boolean;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export type FnbProductsPartialUpdateData = any;

export type FnbProductsDeleteData = any;

export type FnbProductsOrderPartialUpdateData = any;

export interface FnbProductsStockPartialUpdateData {
  stock: number;
}

export type FnbProductsStockHistoriesListData = {
  id: number;
  productId: number;
  type: string;
  quantity: number;
  beforeStock: number;
  afterStock: number;
  memo: string | null;
  adminUserId: number | null;
  adminUserName: string | null;
  createdAt: string;
}[];

export interface FnbOrdersCreateData {
  id: number;
  orderNumber: string;
}

export interface FnbOrdersListData {
  data: {
    id: number;
    orderNumber: string;
    status: string;
    orderType: string;
    finalAmount: number;
    user: {
      id: number;
      name: string | null;
    };
    items: {
      productName: string;
      quantity: number;
    }[];
    createdAt: string;
    paidAt?: string | null;
  }[];
  total: number;
  page: number;
  limit: number;
}

export type FnbOrdersPendingListData = {
  id: number;
  orderNumber: string;
  finalAmount: number;
  user: {
    id: number;
    name: string | null;
    tossCustomerKey: string | null;
  };
  createdAt: string;
}[];

export interface FnbOrdersStatusBoardListData {
  paid: string[];
  ready: string[];
}

export interface FnbOrdersPayCreateData {
  orderNumber: string;
  message: string;
}

export interface FnbOrdersDetailData {
  id: number;
  orderNumber: string;
  status: "PENDING_PAYMENT" | "PAID" | "READY" | "COMPLETED" | "REFUNDED";
  orderType: string;
  paymentMethod: string | null;
  cardName: string | null;
  cardNumber: string | null;
  approvalNumber: string | null;
  totalAmount: number;
  discountAmount: number;
  finalAmount: number;
  refundAmount?: number | null;
  refundReason?: string | null;
  paidAt?: string | null;
  readyAt?: string | null;
  completedAt?: string | null;
  refundedAt?: string | null;
  createdAt: string;
  user: {
    id: number;
    name: string | null;
    phoneNumber: string | null;
    customerKey: string | null;
  };
  parent: {
    id: number;
    name: string | null;
    phoneNumber: string | null;
  } | null;
  items: {
    id: number;
    productId: number;
    productName: string;
    productPrice: number;
    productDiscountPrice?: number | null;
    quantity: number;
    cancelQuantity: number;
    subtotal: number;
  }[];
}

export type FnbOrdersReadyPartialUpdateData = boolean;

export type FnbOrdersCompletePartialUpdateData = boolean;

export type FnbOrdersRefundCreateData = boolean;

export interface FnbOrdersPaymentRequestsCancelCreateData {
  success: boolean;
}

export interface ReceivablesListData {
  data: {
    id: number;
    transactionDate: string;
    orderNumber: string;
    productName: string;
    receivableAmount: number;
    paidAmount: number;
    balance: number;
    userName: string;
    userPhone: string;
  }[];
  total: number;
  page: number;
  limit: number;
}

export interface ReceivablesPaymentsListData {
  payments: {
    id: number;
    createdAt: string;
    amount: number;
  }[];
  balance: number;
}

export interface ReceivablesPayCreateData {
  success: boolean;
  balance: number;
}

export type GetMembershipsData = {
  id: number;
  userId: number;
  planId: number;
  capacity: number;
  count: number;
  reservationAvailableCount: number;
  cancelableCount: number;
  presentCount: number;
  canceledCount: number;
  noShowCount: number;
  lockerId: number | null;
  isSubscription: boolean;
  subscriptionStatus:
    | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
    | null;
  nextBillingDate: string | null;
  billingId: number | null;
  tossMethodKey: string | null;
  startedAt: string;
  endedAt: string;
  createdAt: string;
  updatedAt: string;
  plan: {
    id: number;
    /** @maxLength 255 */
    name: string;
    durationType: "COUNT_BASED" | "PERIOD_BASED";
    storeId: number | null;
    classType: "GROUP" | "PRIVATE";
    color: string | null;
    count: number;
    cancelableCount: number;
    durationDays: number | null;
    maxCapacity: number | null;
    liked: boolean;
    isActive: boolean;
    groupId: number | null;
    productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
    paymentType: "ONE_TIME" | "SUBSCRIPTION";
    price: number;
    sellOnApp: boolean;
    monthlyPrice: number | null;
    subscriptionDiscount: number | null;
    discountAppliedMonths: number | null;
    validityDays: number | null;
    displayOrder: number;
    createdAt: string;
    updatedAt: string;
  } | null;
  locker: {
    id: number;
    storeId: number;
    type: "UNISEX" | "MALE" | "FEMALE";
    number: number;
    password: string | null;
    status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
    currentMembershipId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  suspensions: {
    id: number;
    membershipId: number;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
  }[];
}[];

export type PaymentsListData = {
  id: number;
  orderNumber: string;
  transactionDate: string;
  status: string;
  paymentMethod: string;
  paymentType: string;
  productName: string;
  originalPrice: number;
  discountAmount: number;
  finalAmount: number;
  refundAmount?: number | null;
  refundReason?: string | null;
  refundedAt?: string | null;
}[];

export interface BillingPartialUpdateData {
  success: boolean;
  message: string;
}

export interface CancelSubscriptionPartialUpdateData {
  success: boolean;
  message: string;
}

export interface ReactivateSubscriptionPartialUpdateData {
  success: boolean;
  message: string;
}

export interface SubscriptionListData {
  subscriptionStartedAt: string;
  subscriptionCount: number;
  monthlyPrice: number;
  nextBillingDate: string | null;
  billingInfo: {
    cardName: string | null;
    cardNumber: string | null;
  } | null;
  subscriptionStatus:
    | "ACTIVE"
    | "PAUSED"
    | "CANCELED"
    | "CANCEL_REQUESTED"
    | null;
}

export type LockersListData = {
  id: number;
  number: number;
  type: "UNISEX" | "MALE" | "FEMALE";
  status: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
  isAvailable: boolean;
}[];

export type LockerCreateData = any;

export type ByMembershipDetailData = {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userCount: number;
  reservations: {
    id: number;
    userId: number;
    classId: number;
    status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
    membershipId: number;
    deductionCount: number;
    canceledAt: string | null;
    membershipMaxCount: number | null;
    membershipReservationAvailableCount: number | null;
    membershipStartedAt: string | null;
    membershipEndedAt: string | null;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  }[];
  classAvailableMemberships: {
    id: number;
    classId: number;
    membershipId: number;
    createdAt: string;
    updatedAt: string;
  }[];
  classAvailablePlans: {
    id: number;
    classId: number;
    planId: number;
    createdAt: string;
    updatedAt: string;
  }[];
}[];

export interface ClassDetailResult {
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  adminUser: {
    id: number;
    isActivated: boolean;
    /** @maxLength 255 */
    username: string;
    name: string | null;
    phoneNumber: string | null;
    refreshToken: string | null;
    role: "USER" | "ADMIN";
    adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
    password: string | null;
    fcmToken: string | null;
    profileImageUrl: string | null;
    entrancePhotoUrl: string | null;
    color: string | null;
    description: string | null;
    timeTable:
      | {
          isDayOff: boolean;
          open?: string;
          close?: string;
        }[]
      | null;
    isNotification: boolean;
    isAdNotification: boolean;
    isLinked: boolean;
    gender: ("MALE" | "FEMALE") | null;
    birth: string | null;
    address: string | null;
    isUnder14: boolean;
    parentName: string | null;
    parentPhoneNumber: string | null;
    isParentPhoneVerified: boolean;
    paymentPin: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  room: {
    id: number;
    /** @maxLength 255 */
    name: string;
    storeId: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userCount: number;
  reservations: {
    id: number;
    userId: number;
    classId: number;
    status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
    membershipId: number;
    deductionCount: number;
    canceledAt: string | null;
    membershipMaxCount: number | null;
    membershipReservationAvailableCount: number | null;
    membershipStartedAt: string | null;
    membershipEndedAt: string | null;
    createdAt: string;
    updatedAt: string;
    user: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  }[];
  classAvailableMemberships: {
    id: number;
    classId: number;
    membershipId: number;
    createdAt: string;
    updatedAt: string;
  }[];
  classAvailablePlans: {
    id: number;
    classId: number;
    planId: number;
    createdAt: string;
    updatedAt: string;
  }[];
}

export type DeleteReasonPartialUpdateData = any;

export type StoreListResult = {
  id: number;
  /** @maxLength 255 */
  name: string;
  tel: string | null;
  phoneNumber: string | null;
  businessNumber: string | null;
  representative: string | null;
  types: (string | number | boolean | null) | any[] | Record<string, any>;
  gymDidAccount: string | null;
  pilatesDidAccount: string | null;
  bareDidAccount: string | null;
  address: string | null;
  addressDetail: string | null;
  branchTel: string | null;
  naverPlaceRepresentative: string | null;
  naverPlaceBusinessNumber: string | null;
  naverPlaceTel: string | null;
  point: number;
  bodyAnalysisPoint: number;
  timeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  isFnbEnabled: boolean;
  fnbTimeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  color: string | null;
  images: null;
  fnbImage: string | null;
  fnbScreenImages: null;
  tossClientKey: string | null;
  tossCultureClientKey: string | null;
  createdAt: string;
  updatedAt: string;
}[];

export interface StoreDetailData {
  id: number;
  /** @maxLength 255 */
  name: string;
  tel: string | null;
  phoneNumber: string | null;
  businessNumber: string | null;
  representative: string | null;
  types: (string | number | boolean | null) | any[] | Record<string, any>;
  gymDidAccount: string | null;
  pilatesDidAccount: string | null;
  bareDidAccount: string | null;
  address: string | null;
  addressDetail: string | null;
  branchTel: string | null;
  naverPlaceRepresentative: string | null;
  naverPlaceBusinessNumber: string | null;
  naverPlaceTel: string | null;
  point: number;
  bodyAnalysisPoint: number;
  timeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  isFnbEnabled: boolean;
  fnbTimeTable:
    | (
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null
      )
    | null;
  color: string | null;
  images: null;
  fnbImage: string | null;
  fnbScreenImages: null;
  tossClientKey: string | null;
  tossCultureClientKey: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ConnectCreateData {
  userStoreId: number;
  tossCustomerKey: string;
}

export type GetReservationsData = {
  id: number;
  userId: number;
  classId: number;
  status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
  membershipId: number;
  deductionCount: number;
  canceledAt: string | null;
  membershipMaxCount: number | null;
  membershipReservationAvailableCount: number | null;
  membershipStartedAt: string | null;
  membershipEndedAt: string | null;
  createdAt: string;
  updatedAt: string;
  class: {
    id: number;
    /** @maxLength 255 */
    name: string;
    maxCapacity: number;
    type: "GROUP" | "PRIVATE";
    reservationAvailableHour: number | null;
    classCancelHour: number;
    classWaitingCancelHour: number;
    sameDayChangeHour: number | null;
    startedAt: string;
    endedAt: string;
    roomId: number | null;
    adminUserId: number | null;
    isReservationEnabled: boolean;
    deductionCount: number;
    groupClassId: number | null;
    storeId: number;
    deletedReason: string | null;
    deletedUserId: number | null;
    openedAt: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
    userCount: number;
    room: {
      id: number;
      /** @maxLength 255 */
      name: string;
      storeId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    adminUser: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
  membership: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
}[];

export type MyAllListData = {
  id: number;
  userId: number;
  classId: number;
  status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
  membershipId: number;
  deductionCount: number;
  canceledAt: string | null;
  membershipMaxCount: number | null;
  membershipReservationAvailableCount: number | null;
  membershipStartedAt: string | null;
  membershipEndedAt: string | null;
  createdAt: string;
  updatedAt: string;
  class: {
    id: number;
    /** @maxLength 255 */
    name: string;
    maxCapacity: number;
    type: "GROUP" | "PRIVATE";
    reservationAvailableHour: number | null;
    classCancelHour: number;
    classWaitingCancelHour: number;
    sameDayChangeHour: number | null;
    startedAt: string;
    endedAt: string;
    roomId: number | null;
    adminUserId: number | null;
    isReservationEnabled: boolean;
    deductionCount: number;
    groupClassId: number | null;
    storeId: number;
    deletedReason: string | null;
    deletedUserId: number | null;
    openedAt: string | null;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
    userCount: number;
    room: {
      id: number;
      /** @maxLength 255 */
      name: string;
      storeId: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    adminUser: {
      id: number;
      isActivated: boolean;
      /** @maxLength 255 */
      username: string;
      name: string | null;
      phoneNumber: string | null;
      refreshToken: string | null;
      role: "USER" | "ADMIN";
      adminType: ("INSTRUCTOR" | "MANAGER" | "HEADQUARTERS") | null;
      password: string | null;
      fcmToken: string | null;
      profileImageUrl: string | null;
      entrancePhotoUrl: string | null;
      color: string | null;
      description: string | null;
      timeTable:
        | {
            isDayOff: boolean;
            open?: string;
            close?: string;
          }[]
        | null;
      isNotification: boolean;
      isAdNotification: boolean;
      isLinked: boolean;
      gender: ("MALE" | "FEMALE") | null;
      birth: string | null;
      address: string | null;
      isUnder14: boolean;
      parentName: string | null;
      parentPhoneNumber: string | null;
      isParentPhoneVerified: boolean;
      paymentPin: string | null;
      deletedAt: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    store: {
      id: number;
      /** @maxLength 255 */
      name: string;
      tel: string | null;
      phoneNumber: string | null;
      businessNumber: string | null;
      representative: string | null;
      types: (string | number | boolean | null) | any[] | Record<string, any>;
      gymDidAccount: string | null;
      pilatesDidAccount: string | null;
      bareDidAccount: string | null;
      address: string | null;
      addressDetail: string | null;
      branchTel: string | null;
      naverPlaceRepresentative: string | null;
      naverPlaceBusinessNumber: string | null;
      naverPlaceTel: string | null;
      point: number;
      bodyAnalysisPoint: number;
      timeTable:
        | (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
              }[]
            | null
          )
        | null;
      isFnbEnabled: boolean;
      fnbTimeTable:
        | (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
              }[]
            | null
          )
        | null;
      color: string | null;
      images: null;
      fnbImage: string | null;
      fnbScreenImages: null;
      tossClientKey: string | null;
      tossCultureClientKey: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
  membership: {
    id: number;
    userId: number;
    planId: number;
    capacity: number;
    count: number;
    reservationAvailableCount: number;
    cancelableCount: number;
    presentCount: number;
    canceledCount: number;
    noShowCount: number;
    lockerId: number | null;
    isSubscription: boolean;
    subscriptionStatus:
      | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
      | null;
    nextBillingDate: string | null;
    billingId: number | null;
    tossMethodKey: string | null;
    startedAt: string;
    endedAt: string;
    createdAt: string;
    updatedAt: string;
    plan: {
      id: number;
      /** @maxLength 255 */
      name: string;
      durationType: "COUNT_BASED" | "PERIOD_BASED";
      storeId: number | null;
      classType: "GROUP" | "PRIVATE";
      color: string | null;
      count: number;
      cancelableCount: number;
      durationDays: number | null;
      maxCapacity: number | null;
      liked: boolean;
      isActive: boolean;
      groupId: number | null;
      productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
      paymentType: "ONE_TIME" | "SUBSCRIPTION";
      price: number;
      sellOnApp: boolean;
      monthlyPrice: number | null;
      subscriptionDiscount: number | null;
      discountAppliedMonths: number | null;
      validityDays: number | null;
      displayOrder: number;
      createdAt: string;
      updatedAt: string;
    } | null;
  } | null;
}[];

export interface ReservationsCreateResult {
  waitingCount?: number;
}

export type CancelCreateData = any;

export type ChangeClassCreateData = any;

export type AttendanceHistoriesListData = {
  id: number;
  membershipId: number;
  userId: number;
  storeId: number;
  snapshotProducts:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  createdAt: string;
}[];

export interface AttendanceCouponsCreateData {
  message: string;
}

export type AttendanceCouponsListData = {
  id: number;
  membershipId: number;
  userId: number;
  storeId: number;
  /** @maxLength 7 */
  yearMonth: string;
  isUsed: boolean;
  usedAt: string | null;
  createdAt: string;
}[];

export interface AttendanceCouponsUseCreateData {
  message: string;
}

export type AttendanceRankingListData = {
  rank: number;
  userId: number;
  userName: string;
  profileImageUrl: string | null;
  attendanceCount: number;
}[];

export type TodayClassesDetailData = ({
  id: number;
  /** @maxLength 255 */
  name: string;
  maxCapacity: number;
  type: "GROUP" | "PRIVATE";
  reservationAvailableHour: number | null;
  classCancelHour: number;
  classWaitingCancelHour: number;
  sameDayChangeHour: number | null;
  startedAt: string;
  endedAt: string;
  roomId: number | null;
  adminUserId: number | null;
  isReservationEnabled: boolean;
  deductionCount: number;
  groupClassId: number | null;
  storeId: number;
  deletedReason: string | null;
  deletedUserId: number | null;
  openedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
} & {
  userCount: number;
  roomName: string | null;
})[];

export type ReservationsDetailData = {
  id: number;
  userId: number;
  classId: number;
  status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
  membershipId: number;
  deductionCount: number;
  canceledAt: string | null;
  membershipMaxCount: number | null;
  membershipReservationAvailableCount: number | null;
  membershipStartedAt: string | null;
  membershipEndedAt: string | null;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    name: string | null;
    profileImageUrl: string | null;
  } | null;
}[];

export type RowingHistoriesCreateData = any;

export interface ClubDayBadgesDetailData {
  classAchievements: {
    id: number;
    userId: number;
    userName: string | null;
    userImage: string | null;
    type:
      | "FIRST_PRESENT"
      | "WEEK_3"
      | "WEEK_5"
      | "MONTH_20"
      | "50"
      | "100"
      | "200"
      | "300"
      | "500";
    createdAt: string;
  }[];
}

export interface HiroxSessionsDetailData {
  sessionId: number;
  classId: number | null;
  className: string | null;
  storeName: string | null;
  startedAt: string | null;
  endedAt: string | null;
  teams: {
    id: number;
    teamNumber: number;
    difficulty: "EASY" | "NORMAL" | "HARD";
    time: number | null;
    members: {
      id: number;
      name: string | null;
      profileImageUrl: string | null;
    }[];
  }[];
}

export interface HiroxSetupCreateData {
  sessionId: number;
}

export type HiroxRecordsCreateData = any;

export interface HiroxStoreBestListData {
  EASY: {
    time: number;
    classId: number | null;
    teamNumber: number;
    date: string;
  } | null;
  NORMAL: {
    time: number;
    classId: number | null;
    teamNumber: number;
    date: string;
  } | null;
  HARD: {
    time: number;
    classId: number | null;
    teamNumber: number;
    date: string;
  } | null;
}

export interface HiroxDailyBestListData {
  EASY: {
    rank: number;
    time: number;
    teamNumber: number;
    classId: number | null;
    className: string;
    startedAt: string;
    members: {
      id: number;
      name: string | null;
      profileImageUrl: string | null;
    }[];
  }[];
  NORMAL: {
    rank: number;
    time: number;
    teamNumber: number;
    classId: number | null;
    className: string;
    startedAt: string;
    members: {
      id: number;
      name: string | null;
      profileImageUrl: string | null;
    }[];
  }[];
  HARD: {
    rank: number;
    time: number;
    teamNumber: number;
    classId: number | null;
    className: string;
    startedAt: string;
    members: {
      id: number;
      name: string | null;
      profileImageUrl: string | null;
    }[];
  }[];
}

export type HiroxMyRecordsListData = {
  id: number;
  classId: number | null;
  teamNumber: number;
  difficulty: "EASY" | "NORMAL" | "HARD";
  time: number;
  date: string;
}[];

export type WebhookCreateData = any;

export type TestCreateData = any;

export type NotificationsListData = {
  id: number;
  userId: number;
  /** @maxLength 255 */
  title: string;
  content: string;
  path: string | null;
  isRead: boolean;
  type:
    | (
        | "MEMBERSHIP"
        | "CLASS"
        | "BIRTHDAY"
        | "INBODY_RESULT"
        | "CLUB_DAY"
        | "FNB_ORDER"
      )
    | null;
  storeId: number | null;
  createdAt: string;
  updatedAt: string;
  store: {
    id: number;
    /** @maxLength 255 */
    name: string;
    tel: string | null;
    phoneNumber: string | null;
    businessNumber: string | null;
    representative: string | null;
    types: (string | number | boolean | null) | any[] | Record<string, any>;
    gymDidAccount: string | null;
    pilatesDidAccount: string | null;
    bareDidAccount: string | null;
    address: string | null;
    addressDetail: string | null;
    branchTel: string | null;
    naverPlaceRepresentative: string | null;
    naverPlaceBusinessNumber: string | null;
    naverPlaceTel: string | null;
    point: number;
    bodyAnalysisPoint: number;
    timeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    isFnbEnabled: boolean;
    fnbTimeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    color: string | null;
    images: null;
    fnbImage: string | null;
    fnbScreenImages: null;
    tossClientKey: string | null;
    tossCultureClientKey: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
}[];

export type ReadCreateData = any;

export type GetDietPreferencesData = {
  id: number;
  userId: number;
  height: number;
  weight: number;
  birthDate: string;
  gender: "MALE" | "FEMALE";
  exerciseLevel: "NONE" | "LIGHT" | "MODERATE" | "ACTIVE" | "VERY_ACTIVE";
  exerciseGoal: "DIET" | "HEALTH" | "MUSCLE_GAIN";
  mealsPerDay: number;
  wakeUpTime: string | null;
  exerciseTime: string | null;
  allergies: string[];
  createdAt: string;
  updatedAt: string;
} | null;

export interface DietPreferencesCreateData {
  id: number;
}

export type DietPreferencesPartialUpdateData = any;

export type DietPreferencesDeleteData = any;

export type HistoriesListData = {
  id: number;
  userId: number;
  adminUserId: number | null;
  /** @maxLength 500 */
  frontImageUrl: string;
  /** @maxLength 500 */
  rightSideImageUrl: string;
  /** @maxLength 500 */
  leftSideImageUrl: string;
  /** @maxLength 500 */
  frontAnalysisImagePath: string;
  /** @maxLength 500 */
  rightSideAnalysisImagePath: string;
  /** @maxLength 500 */
  leftSideAnalysisImagePath: string;
  frontAnalysisData: {
    far_coords?: string;
    /** 머리 균형도(머리 기울기). degree 단위 */
    far_head_bal_m_?: number;
    /**
     * 머리 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_head_bal_grade?: number;
    /** 골반 균형도(골반 기울기). degree 단위 */
    far_pelvic_bal_m_?: number;
    /**
     * 골반 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_pelvic_bal_grade?: number;
    /** 어깨 균형도(어깨 기울기). degree 단위 */
    far_shoulder_bal_m_?: number;
    /**
     * 어깨 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_shoulder_bal_grade?: number;
    /** 왼쪽 오다리 값. degree 단위 */
    far_left_qang_m_?: number;
    /**
     * 왼쪽 오다리 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_left_qang_grade?: number;
    /** 오른쪽 오다리 값. degree 단위 */
    far_right_qang_m_?: number;
    /**
     * 오른쪽 오다리 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_right_qang_grade?: number;
    /** 무릎 균형도(무릎 기울기). degree 단위 */
    far_knee_bal_m_?: number;
    /**
     * 무릎 균형도 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_knee_bal_grade?: number;
    /** 정면 축 기울기(좌우 기울기). degree 단위 */
    far_tilt_m_?: number;
    /**
     * 정면 축 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    far_tilt_grade?: number;
  } | null;
  rightSideAnalysisData: {
    sar_coords?: string;
    /** 굽은 어깨 기울기. degree 단위 */
    round_shoulder_m_?: number;
    /**
     * 굽은 어깨 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    round_shoulder_grade?: number;
    /** 측면 머리 균형도(머리 앞뒤 기울기). degree 단위 */
    sar_head_tilt_m_?: number;
    /**
     * 측면 머리 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_head_tilt_grade?: number;
    /** 측면 기울기(전신 앞뒤 기울기). degree 단위 */
    sar_tilt_m_?: number;
    /**
     * 측면 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_tilt_grade?: number;
    /** 거북목 기울기. degree 단위 */
    turtle_neck_m_?: number;
    /**
     * 거북목 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    turtle_neck_grade?: number;
  } | null;
  leftSideAnalysisData: {
    sar_coords?: string;
    /** 굽은 어깨 기울기. degree 단위 */
    round_shoulder_m_?: number;
    /**
     * 굽은 어깨 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    round_shoulder_grade?: number;
    /** 측면 머리 균형도(머리 앞뒤 기울기). degree 단위 */
    sar_head_tilt_m_?: number;
    /**
     * 측면 머리 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_head_tilt_grade?: number;
    /** 측면 기울기(전신 앞뒤 기울기). degree 단위 */
    sar_tilt_m_?: number;
    /**
     * 측면 기울기 등급. -2~2 범위
     * @min -2
     * @max 2
     */
    sar_tilt_grade?: number;
    /** 거북목 기울기. degree 단위 */
    turtle_neck_m_?: number;
    /**
     * 거북목 등급. 0~2 범위
     * @min 0
     * @max 2
     */
    turtle_neck_grade?: number;
  } | null;
  createdAt: string;
  updatedAt: string;
}[];

export type GetDietScheduleData = {
  id: number;
  userId: number;
  scheduleDate: string;
  mealNumber: number;
  mealTime: string;
  targetCarbs: number;
  targetProtein: number;
  targetFat: number;
  totalCalories: number;
  isCompleted: boolean;
  foods: {
    id: number;
    name: string;
    imageUrl: string | null;
    grams: number;
    protein: number;
    carbs: number;
    fat: number;
    createdAt: string;
    updatedAt: string;
  }[];
  createdAt: string;
  updatedAt: string;
}[];

export interface DietScheduleDetailData {
  id: number;
  userId: number;
  scheduleDate: string;
  mealNumber: number;
  mealTime: string;
  targetCarbs: number;
  targetProtein: number;
  targetFat: number;
  totalCalories: number;
  isCompleted: boolean;
  foods: {
    id: number;
    name: string;
    imageUrl: string | null;
    grams: number;
    protein: number;
    carbs: number;
    fat: number;
    createdAt: string;
    updatedAt: string;
  }[];
  createdAt: string;
  updatedAt: string;
}

export interface DietScheduleCreateData {
  id: number;
}

export interface FoodsCreateData {
  id: number;
}

export type FoodsPartialUpdateData = any;

export type FoodsDeleteData = any;

export type RegenerateDayCreateData = any;

export type DailyDietPreferencesListData = {
  id: number;
  userId: number;
  preferenceDate: string;
  wakeUpTime: string;
  exerciseTime: string;
  mealsPerDay: number;
  recommendedCalories: number;
  isCustomized: boolean;
  createdAt: string;
  updatedAt: string;
}[];

export type DietListResult = {
  id: number;
  /** @maxLength 255 */
  name: string;
  imageUrl: string | null;
  protein: number;
  carbs: number;
  fat: number;
  size: number;
  allergens: string[] | null;
  benefits: string[] | null;
  source: "PROTEIN" | "CARBS" | "FAT";
  createdAt: string;
  updatedAt: string;
}[];

export interface RegisterCreateData {
  id: number;
}

export type BillingsListResult = {
  id: number;
  storeId: number;
  cardName: string | null;
  cardCi: string | null;
  /** @maxLength 255 */
  billingKey: string;
  createdAt: string;
  updatedAt: string;
}[];

export type BillingsDeleteResult = any;

export type ProductsListResult = {
  id: number;
  /** @maxLength 255 */
  name: string;
  durationType: "COUNT_BASED" | "PERIOD_BASED";
  storeId: number | null;
  classType: "GROUP" | "PRIVATE";
  color: string | null;
  count: number;
  cancelableCount: number;
  durationDays: number | null;
  maxCapacity: number | null;
  liked: boolean;
  isActive: boolean;
  groupId: number | null;
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  price: number;
  sellOnApp: boolean;
  monthlyPrice: number | null;
  subscriptionDiscount: number | null;
  discountAppliedMonths: number | null;
  validityDays: number | null;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  addons: {
    id: number;
    name: string;
    productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
    paymentType: "ONE_TIME" | "SUBSCRIPTION";
    originalPrice: number;
    price: number;
    discountAppliedMonths: number | null;
    validityDays: number | null;
  }[];
}[];

export interface PurchaseCreateData {
  success: boolean;
  purchasedItems: {
    planId: number;
    membershipId: number;
    paymentHistoryIds: number[];
  }[];
}

export type PaymentsListResult = ({
  id: number;
  storeId: number;
  userId: number;
  planId: number;
  membershipId: number | null;
  paymentGroupId: string | null;
  paymentItemType: ("NORMAL" | "CULTURE") | null;
  isAddon: boolean;
  /** @maxLength 255 */
  orderNumber: string;
  transactionDate: string;
  status: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
  originalPaymentId: number | null;
  paymentMethod:
    | "CARD"
    | "KAKAO"
    | "NAVER"
    | "CASH"
    | "TRANSFER"
    | "BILLING"
    | "MIXED";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  paymentSource: "APP" | "IN_STORE";
  /** @maxLength 255 */
  productName: string;
  originalPrice: number;
  discountAmount: number;
  finalAmount: number;
  cardAmount: number | null;
  cashAmount: number | null;
  transferAmount: number | null;
  receivableAmount: number | null;
  /** @maxLength 255 */
  userName: string;
  /** @maxLength 50 */
  userPhone: string;
  pgTid: string | null;
  pgResponse: null;
  isCulturePayment: boolean;
  cultureAmount: number;
  culturePgTid: string | null;
  culturePgResponse:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  canRefund: boolean;
  refundAmount: number | null;
  refundReason: string | null;
  refundedAt: string | null;
  refundedBy: number | null;
  adminNote: string | null;
  adminUserId: number | null;
  createdAt: string;
  updatedAt: string;
} & {
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER" | null;
  cardCompany: string | null;
  cardNumber: string | null;
  store: {
    id: number;
    /** @maxLength 255 */
    name: string;
    tel: string | null;
    phoneNumber: string | null;
    businessNumber: string | null;
    representative: string | null;
    types: (string | number | boolean | null) | any[] | Record<string, any>;
    gymDidAccount: string | null;
    pilatesDidAccount: string | null;
    bareDidAccount: string | null;
    address: string | null;
    addressDetail: string | null;
    branchTel: string | null;
    naverPlaceRepresentative: string | null;
    naverPlaceBusinessNumber: string | null;
    naverPlaceTel: string | null;
    point: number;
    bodyAnalysisPoint: number;
    timeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    isFnbEnabled: boolean;
    fnbTimeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    color: string | null;
    images: null;
    fnbImage: string | null;
    fnbScreenImages: null;
    tossClientKey: string | null;
    tossCultureClientKey: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
})[];

export type PaymentsDetailData = {
  id: number;
  storeId: number;
  userId: number;
  planId: number;
  membershipId: number | null;
  paymentGroupId: string | null;
  paymentItemType: ("NORMAL" | "CULTURE") | null;
  isAddon: boolean;
  /** @maxLength 255 */
  orderNumber: string;
  transactionDate: string;
  status: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
  originalPaymentId: number | null;
  paymentMethod:
    | "CARD"
    | "KAKAO"
    | "NAVER"
    | "CASH"
    | "TRANSFER"
    | "BILLING"
    | "MIXED";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  paymentSource: "APP" | "IN_STORE";
  /** @maxLength 255 */
  productName: string;
  originalPrice: number;
  discountAmount: number;
  finalAmount: number;
  cardAmount: number | null;
  cashAmount: number | null;
  transferAmount: number | null;
  receivableAmount: number | null;
  /** @maxLength 255 */
  userName: string;
  /** @maxLength 50 */
  userPhone: string;
  pgTid: string | null;
  pgResponse: null;
  isCulturePayment: boolean;
  cultureAmount: number;
  culturePgTid: string | null;
  culturePgResponse:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  canRefund: boolean;
  refundAmount: number | null;
  refundReason: string | null;
  refundedAt: string | null;
  refundedBy: number | null;
  adminNote: string | null;
  adminUserId: number | null;
  createdAt: string;
  updatedAt: string;
} & {
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER" | null;
  cardCompany: string | null;
  cardNumber: string | null;
  store: {
    id: number;
    /** @maxLength 255 */
    name: string;
    tel: string | null;
    phoneNumber: string | null;
    businessNumber: string | null;
    representative: string | null;
    types: (string | number | boolean | null) | any[] | Record<string, any>;
    gymDidAccount: string | null;
    pilatesDidAccount: string | null;
    bareDidAccount: string | null;
    address: string | null;
    addressDetail: string | null;
    branchTel: string | null;
    naverPlaceRepresentative: string | null;
    naverPlaceBusinessNumber: string | null;
    naverPlaceTel: string | null;
    point: number;
    bodyAnalysisPoint: number;
    timeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    isFnbEnabled: boolean;
    fnbTimeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    color: string | null;
    images: null;
    fnbImage: string | null;
    fnbScreenImages: null;
    tossClientKey: string | null;
    tossCultureClientKey: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type TermsListData = {
  id: number;
  title: string;
  version: string;
  url: string;
  required: boolean;
  agreed: boolean;
}[];

export interface TermsAgreeCreateData {
  code: string;
}

export interface AccessTokenCreateData {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

export interface RefreshAccessTokenCreateData {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

export type PromotionsCardListData = any;

export interface CardRegisteredCreateData {
  success: boolean;
}

export interface QrcodeCreateData {
  token: string;
  expiresIn: number;
}

export interface QrcodeInstructorCreateData {
  token: string;
  expiresIn: number;
}

export interface CheckCreateData {
  valid: boolean;
  remainingSeconds?: number;
}

export interface VerifyCreateData {
  valid: boolean;
  error?: string;
  memberName?: string;
  memberships?: {
    name: string;
    startedAt: string;
    endedAt: string;
  }[];
  classes?: {
    name: string;
    startedAt: string;
    endedAt: string;
  }[];
  pt?: {
    name: string;
    startedAt: string;
    endedAt: string;
  }[];
  clothing?: {
    name: string;
    startedAt: string;
    endedAt: string;
  }[];
  lockers?: {
    name: string;
    startedAt: string;
    endedAt: string;
  }[];
}

export interface PaymentPinListData {
  pin: string | null;
  isDefault: boolean;
}

export type PaymentPinPartialUpdateData = boolean;

export type CategoriesListData = {
  id: number;
  name: string;
  displayOrder: number;
  subCategories: {
    id: number;
    name: string;
    displayOrder: number;
  }[];
}[];

export type ProductsListOutput = {
  id: number;
  name: string;
  subCategoryId: number;
  imageUrl: string | null;
  price: number;
  isDiscounted: boolean;
  discountPrice: number | null;
  stock: number;
  description: string | null;
  color: string | null;
  isSoldOut: boolean;
  isFirstPurchaseOnly: boolean;
}[];

export interface OrdersCreateData {
  orderNumber: string;
}

export type OrdersListData = {
  id: number;
  orderNumber: string;
  status: string;
  discountAmount: number;
  finalAmount: number;
  approvalNumber: string | null;
  refundedAmount: number | null;
  createdAt: string;
  items: {
    productName: string;
    productPrice: number;
    productDiscountPrice: number | null;
    quantity: number;
    cancelQuantity: number;
    subtotal: number;
  }[];
}[];

export interface PaymentRequestCreateData {
  success: boolean;
  requestId: number;
  expiredAt: string;
}

export interface OrdersDetailData {
  id: number;
  orderNumber: string;
  status: string;
  originalAmount: number;
  totalAmount: number;
  discountAmount: number;
  finalAmount: number;
  refundAmount: number | null;
  refundReason: string | null;
  cardName: string | null;
  cardNumber: string | null;
  paidAt: string | null;
  readyAt: string | null;
  completedAt: string | null;
  refundedAt: string | null;
  createdAt: string;
  store: {
    id: number;
    /** @maxLength 255 */
    name: string;
    tel: string | null;
    phoneNumber: string | null;
    businessNumber: string | null;
    representative: string | null;
    types: (string | number | boolean | null) | any[] | Record<string, any>;
    gymDidAccount: string | null;
    pilatesDidAccount: string | null;
    bareDidAccount: string | null;
    address: string | null;
    addressDetail: string | null;
    branchTel: string | null;
    naverPlaceRepresentative: string | null;
    naverPlaceBusinessNumber: string | null;
    naverPlaceTel: string | null;
    point: number;
    bodyAnalysisPoint: number;
    timeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    isFnbEnabled: boolean;
    fnbTimeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    color: string | null;
    images: null;
    fnbImage: string | null;
    fnbScreenImages: null;
    tossClientKey: string | null;
    tossCultureClientKey: string | null;
    createdAt: string;
    updatedAt: string;
  };
  items: {
    productName: string;
    productPrice: number;
    productDiscountPrice: number | null;
    quantity: number;
    cancelQuantity: number;
    subtotal: number;
  }[];
}

export type ChildrenListData = {
  id: number;
  childUserId: number;
  childName: string | null;
  childProfileImageUrl: string | null;
  childPhoneNumber: string | null;
  paymentConsentType: "ALWAYS_REQUIRE" | "NO_REQUIRE";
  createdAt: string;
  stores: {
    id: number;
    name: string;
  }[];
}[];

export interface ChildrenRequestCreateData {
  success: boolean;
  requestId: number;
  expiresAt: string;
}

export interface ChildrenRequestConfirmCreateData {
  success: boolean;
}

export interface ChildrenDeleteData {
  success: boolean;
}

export interface ChildrenConsentPartialUpdateData {
  success: boolean;
}

export type PaymentRequestsListData = {
  id: number;
  type: "MEMBERSHIP" | "FNB";
  childUserId: number;
  childName: string | null;
  storeId: number;
  storeName: string | null;
  status: "PENDING" | "APPROVED" | "REJECTED" | "EXPIRED";
  methodKey: string;
  cardCompany: string | null;
  cardNumber: string | null;
  cardInstallmentPlan: number | null;
  items: any[];
  totalAmount: number;
  discountAmount: number | null;
  finalAmount: number | null;
  requestedAt: string;
  expiredAt: string;
  isExpired: boolean;
  remainingMinutes: number;
  processedAt: string | null;
}[];

export interface PaymentRequestsApproveCreateData {
  success: boolean;
  purchasedItems: {
    planId: number;
    membershipId: number;
    paymentHistoryId: number;
  }[];
}

export interface PaymentRequestsRejectCreateData {
  success: boolean;
}

export type ChildrenPaymentsListData = ({
  id: number;
  storeId: number;
  userId: number;
  planId: number;
  membershipId: number | null;
  paymentGroupId: string | null;
  paymentItemType: ("NORMAL" | "CULTURE") | null;
  isAddon: boolean;
  /** @maxLength 255 */
  orderNumber: string;
  transactionDate: string;
  status: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
  originalPaymentId: number | null;
  paymentMethod:
    | "CARD"
    | "KAKAO"
    | "NAVER"
    | "CASH"
    | "TRANSFER"
    | "BILLING"
    | "MIXED";
  paymentType: "ONE_TIME" | "SUBSCRIPTION";
  paymentSource: "APP" | "IN_STORE";
  /** @maxLength 255 */
  productName: string;
  originalPrice: number;
  discountAmount: number;
  finalAmount: number;
  cardAmount: number | null;
  cashAmount: number | null;
  transferAmount: number | null;
  receivableAmount: number | null;
  /** @maxLength 255 */
  userName: string;
  /** @maxLength 50 */
  userPhone: string;
  pgTid: string | null;
  pgResponse: null;
  isCulturePayment: boolean;
  cultureAmount: number;
  culturePgTid: string | null;
  culturePgResponse:
    | ((string | number | boolean | null) | any[] | Record<string, any>)
    | null;
  canRefund: boolean;
  refundAmount: number | null;
  refundReason: string | null;
  refundedAt: string | null;
  refundedBy: number | null;
  adminNote: string | null;
  adminUserId: number | null;
  createdAt: string;
  updatedAt: string;
} & {
  productType: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER" | null;
  cardCompany: string | null;
  cardNumber: string | null;
  store: {
    id: number;
    /** @maxLength 255 */
    name: string;
    tel: string | null;
    phoneNumber: string | null;
    businessNumber: string | null;
    representative: string | null;
    types: (string | number | boolean | null) | any[] | Record<string, any>;
    gymDidAccount: string | null;
    pilatesDidAccount: string | null;
    bareDidAccount: string | null;
    address: string | null;
    addressDetail: string | null;
    branchTel: string | null;
    naverPlaceRepresentative: string | null;
    naverPlaceBusinessNumber: string | null;
    naverPlaceTel: string | null;
    point: number;
    bodyAnalysisPoint: number;
    timeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    isFnbEnabled: boolean;
    fnbTimeTable:
      | (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        )
      | null;
    color: string | null;
    images: null;
    fnbImage: string | null;
    fnbScreenImages: null;
    tossClientKey: string | null;
    tossCultureClientKey: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
})[];

export type FnbPaymentRequestsListData = {
  id: number;
  childUserId: number;
  childName: string | null;
  storeId: number;
  storeName: string | null;
  status: "PENDING" | "APPROVED" | "REJECTED" | "EXPIRED";
  methodKey: string;
  items: {
    productId: number;
    productName?: string;
    quantity: number;
  }[];
  totalAmount: number;
  discountAmount: number;
  finalAmount: number;
  requestedAt: string;
  expiredAt: string;
  isExpired: boolean;
  remainingMinutes: number;
  processedAt: string | null;
}[];

export interface FnbPaymentRequestsApproveCreateData {
  success: boolean;
  orderNumber: string;
}

export interface FnbPaymentRequestsRejectCreateData {
  success: boolean;
}

export interface ParentInfoListData {
  hasParent: boolean;
  parentUserId: number | null;
  parentName: string | null;
  parentProfileImageUrl: string | null;
  parentPhoneNumber: string | null;
  paymentConsentType: "ALWAYS_REQUIRE" | "NO_REQUIRE" | null;
  parentTossCustomerKey: string | null;
  parentHasRegisteredCard: boolean;
}

export interface PaymentRequestCreateResult {
  success: boolean;
  requestId: number;
  expiredAt: string;
}

export interface LinkRequestListData {
  hasRequest: boolean;
  requestId: number | null;
  parentName: string | null;
  parentProfileImageUrl: string | null;
  parentPhoneNumber: string | null;
  verificationCode: string | null;
  expiresAt: string | null;
  remainingSeconds: number | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://api.abrtraining.co.kr";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title havenew-crm-backend
 * @version 0.1.0
 * @baseUrl https://api.abrtraining.co.kr
 *
 * 31..
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  auth = {
    /**
     * No description
     *
     * @tags 인증
     * @name LoginCreate
     * @request POST:/auth/login
     * @secure
     */
    loginCreate: (
      data: {
        phoneNumber: string;
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LoginCreateData, any>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name SignupVerificationCreate
     * @request POST:/auth/signup/verification
     * @secure
     */
    signupVerificationCreate: (
      data: {
        phoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignupVerificationCreateData, any>({
        path: `/auth/signup/verification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name SignupVerifyCreate
     * @request POST:/auth/signup/verify
     * @secure
     */
    signupVerifyCreate: (
      data: {
        phoneNumber: string;
        code: string;
        role?: "USER" | "ADMIN";
      },
      params: RequestParams = {},
    ) =>
      this.request<SignupVerifyCreateData, any>({
        path: `/auth/signup/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name SignupCreate
     * @request POST:/auth/signup
     * @secure
     */
    signupCreate: (
      data: {
        phoneNumber: string;
        password: string;
        isUnder14?: boolean;
        parentName?: string;
        parentPhoneNumber?: string;
        isParentPhoneVerified?: boolean;
        entrancePhotoUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignupCreateData, any>({
        path: `/auth/signup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ResetPasswordVerificationCreate
     * @request POST:/auth/reset-password/verification
     * @secure
     */
    resetPasswordVerificationCreate: (
      data: {
        phoneNumber: string;
        role?: "USER" | "ADMIN";
      },
      params: RequestParams = {},
    ) =>
      this.request<ResetPasswordVerificationCreateData, any>({
        path: `/auth/reset-password/verification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ResetPasswordVerifyCreate
     * @request POST:/auth/reset-password/verify
     * @secure
     */
    resetPasswordVerifyCreate: (
      data: {
        phoneNumber: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResetPasswordVerifyCreateData, any>({
        path: `/auth/reset-password/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ResetPasswordCreate
     * @request POST:/auth/reset-password
     * @secure
     */
    resetPasswordCreate: (
      data: {
        phoneNumber: string;
        code: string;
        newPassword: string;
        role?: "USER" | "ADMIN";
      },
      params: RequestParams = {},
    ) =>
      this.request<ResetPasswordCreateData, any>({
        path: `/auth/reset-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name InstructorSignupCreate
     * @request POST:/auth/instructor/signup
     * @secure
     */
    instructorSignupCreate: (
      data: {
        phoneNumber: string;
        password: string;
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InstructorSignupCreateData, any>({
        path: `/auth/instructor/signup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name RefreshCreate
     * @request POST:/auth/refresh
     * @secure
     */
    refreshCreate: (
      data: {
        refreshToken: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RefreshCreateData, any>({
        path: `/auth/refresh`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ParentPhoneVerificationCreate
     * @request POST:/auth/parent-phone/verification
     * @secure
     */
    parentPhoneVerificationCreate: (
      data: {
        parentPhoneNumber: string;
        storeType?: "HAVENEW" | "JOEUN";
      },
      params: RequestParams = {},
    ) =>
      this.request<ParentPhoneVerificationCreateData, any>({
        path: `/auth/parent-phone/verification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ParentPhoneVerifyCreate
     * @request POST:/auth/parent-phone/verify
     * @secure
     */
    parentPhoneVerifyCreate: (
      data: {
        parentPhoneNumber: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ParentPhoneVerifyCreateData, any>({
        path: `/auth/parent-phone/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ChildLinkVerificationCreate
     * @request POST:/auth/child-link/verification
     * @secure
     */
    childLinkVerificationCreate: (
      data: {
        childPhoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChildLinkVerificationCreateData, any>({
        path: `/auth/child-link/verification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name ChildLinkVerifyCreate
     * @request POST:/auth/child-link/verify
     * @secure
     */
    childLinkVerifyCreate: (
      data: {
        childPhoneNumber: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChildLinkVerifyCreateData, any>({
        path: `/auth/child-link/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags 유저
     * @name GetUsers
     * @request GET:/users/my
     * @secure
     */
    getUsers: (params: RequestParams = {}) =>
      this.request<GetUsersData, any>({
        path: `/users/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name PatchUsers
     * @request PATCH:/users/my
     * @secure
     */
    patchUsers: (
      data: {
        name?: string | null;
        birth?: string | null;
        gender?: ("MALE" | "FEMALE") | null;
        isNotification?: boolean;
        address?: string | null;
        description?: string | null;
        profileImageUrl?: string | null;
        fcmToken?: string | null;
        isAdNotification?: boolean;
        entrancePhotoUrl?: string | null;
        isGymStore?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PatchUsersData, any>({
        path: `/users/my`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name StoreDelete
     * @request DELETE:/users/store/{storeId}
     * @secure
     */
    storeDelete: (storeId: number, params: RequestParams = {}) =>
      this.request<StoreDeleteData, any>({
        path: `/users/store/${storeId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name AttendanceList
     * @request GET:/users/attendance
     * @secure
     */
    attendanceList: (params: RequestParams = {}) =>
      this.request<AttendanceListData, any>({
        path: `/users/attendance`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name InbodyHistoriesList
     * @request GET:/users/inbody-histories
     * @secure
     */
    inbodyHistoriesList: (params: RequestParams = {}) =>
      this.request<InbodyHistoriesListData, any>({
        path: `/users/inbody-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name RowingRankingList
     * @request GET:/users/rowing-ranking
     * @secure
     */
    rowingRankingList: (
      query?: {
        distance?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RowingRankingListData, any>({
        path: `/users/rowing-ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name TodayRowingList
     * @request GET:/users/today-rowing
     * @secure
     */
    todayRowingList: (params: RequestParams = {}) =>
      this.request<TodayRowingListData, any>({
        path: `/users/today-rowing`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name MonthlyPresentRankingList
     * @request GET:/users/monthly-present-ranking
     * @secure
     */
    monthlyPresentRankingList: (params: RequestParams = {}) =>
      this.request<MonthlyPresentRankingListData, any>({
        path: `/users/monthly-present-ranking`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name AchievementsList
     * @request GET:/users/achievements
     * @secure
     */
    achievementsList: (
      query?: {
        attendanceType?: "CLASS" | "MEMBERSHIP";
      },
      params: RequestParams = {},
    ) =>
      this.request<AchievementsListData, any>({
        path: `/users/achievements`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name QuitCreate
     * @request POST:/users/quit
     * @secure
     */
    quitCreate: (params: RequestParams = {}) =>
      this.request<QuitCreateData, any>({
        path: `/users/quit`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name ChangePasswordCreate
     * @request POST:/users/change-password
     * @secure
     */
    changePasswordCreate: (
      data: {
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangePasswordCreateData, any>({
        path: `/users/change-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 유저
     * @name LockerSettingsList
     * @request GET:/users/locker-settings
     * @secure
     */
    lockerSettingsList: (params: RequestParams = {}) =>
      this.request<LockerSettingsListData, any>({
        path: `/users/locker-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @tags 인증
     * @name AuthSigninCreate
     * @request POST:/admin/auth/signin
     * @secure
     */
    authSigninCreate: (
      data: {
        username: string;
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthSigninCreateData, any>({
        path: `/admin/auth/signin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name AuthSignupCreate
     * @request POST:/admin/auth/signup
     * @secure
     */
    authSignupCreate: (
      data: {
        username: string;
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthSignupCreateData, any>({
        path: `/admin/auth/signup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name AuthRefreshCreate
     * @request POST:/admin/auth/refresh
     * @secure
     */
    authRefreshCreate: (
      data: {
        refreshToken: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthRefreshCreateData, any>({
        path: `/admin/auth/refresh`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name AuthUserList
     * @request GET:/admin/auth/user
     * @secure
     */
    authUserList: (
      query: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthUserListData, any>({
        path: `/admin/auth/user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name AuthSendUsernameCreate
     * @request POST:/admin/auth/send-username
     * @secure
     */
    authSendUsernameCreate: (
      data: {
        phoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthSendUsernameCreateData, any>({
        path: `/admin/auth/send-username`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name AuthSendResetCreate
     * @request POST:/admin/auth/send-reset
     * @secure
     */
    authSendResetCreate: (
      data: {
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthSendResetCreateData, any>({
        path: `/admin/auth/send-reset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 인증
     * @name AuthResetPasswordCreate
     * @request POST:/admin/auth/reset-password
     * @secure
     */
    authResetPasswordCreate: (
      data: {
        password: string;
        code: string;
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthResetPasswordCreateData, any>({
        path: `/admin/auth/reset-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMeList
     * @request GET:/admin/user/me
     * @secure
     */
    userMeList: (params: RequestParams = {}) =>
      this.request<UserMeListData, any>({
        path: `/admin/user/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserStudentsList
     * @request GET:/admin/user/students
     * @secure
     */
    userStudentsList: (params: RequestParams = {}) =>
      this.request<UserStudentsListData, any>({
        path: `/admin/user/students`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserQuitDelete
     * @request DELETE:/admin/user/{id}/quit
     * @secure
     */
    userQuitDelete: (id: number, params: RequestParams = {}) =>
      this.request<UserQuitDeleteData, any>({
        path: `/admin/user/${id}/quit`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserDelete
     * @request DELETE:/admin/user/{id}
     * @secure
     */
    userDelete: (id: number, params: RequestParams = {}) =>
      this.request<UserDeleteData, any>({
        path: `/admin/user/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserPartialUpdate
     * @request PATCH:/admin/user/{id}
     * @secure
     */
    userPartialUpdate: (
      id: number,
      data: {
        /** @maxLength 255 */
        username?: string;
        name?: string | null;
        phoneNumber?: (string | null) & string;
        profileImageUrl?: string | null;
        entrancePhotoUrl?: string | null;
        color?: string | null;
        description?: string | null;
        timeTable?: (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        ) &
          (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
                description?: string;
              }[]
            | null
          );
        isNotification?: boolean;
        isAdNotification?: boolean;
        isLinked?: boolean;
        gender?: ("MALE" | "FEMALE") | null;
        birth?: string | null;
        address?: string | null;
        isUnder14?: boolean;
        parentName?: string | null;
        parentPhoneNumber?: string | null;
        isParentPhoneVerified?: boolean;
        paymentPin?: string | null;
        deletedAt?: string | null;
        updatedAt?: string;
        adminType?: "INSTRUCTOR" | null;
        role?: "ADMIN" | "USER";
      },
      params: RequestParams = {},
    ) =>
      this.request<UserPartialUpdateData, any>({
        path: `/admin/user/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserDetail
     * @request GET:/admin/user/{id}
     * @secure
     */
    userDetail: (id: number, params: RequestParams = {}) =>
      this.request<UserDetailData, any>({
        path: `/admin/user/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserCreate
     * @request POST:/admin/user/
     * @secure
     */
    userCreate: (
      data: {
        /** @maxLength 255 */
        username: string;
        name?: string | null;
        phoneNumber: (string | null) & string;
        profileImageUrl?: string | null;
        entrancePhotoUrl?: string | null;
        color?: string | null;
        description?: string | null;
        timeTable: (
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null
        ) &
          (
            | {
                isDayOff: boolean;
                open?: string;
                close?: string;
                description?: string;
              }[]
            | null
          );
        isNotification?: boolean;
        isAdNotification?: boolean;
        isLinked?: boolean;
        gender?: ("MALE" | "FEMALE") | null;
        birth?: string | null;
        address?: string | null;
        isUnder14?: boolean;
        parentName?: string | null;
        parentPhoneNumber?: string | null;
        isParentPhoneVerified?: boolean;
        paymentPin?: string | null;
        deletedAt?: string | null;
        updatedAt?: string;
        adminType: "INSTRUCTOR" | null;
        role: "ADMIN" | "USER";
      },
      params: RequestParams = {},
    ) =>
      this.request<UserCreateData, any>({
        path: `/admin/user/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserClassesList
     * @request GET:/admin/user/{id}/classes
     * @secure
     */
    userClassesList: (id: number, params: RequestParams = {}) =>
      this.request<UserClassesListData, any>({
        path: `/admin/user/${id}/classes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserStudentsList2
     * @request GET:/admin/user/{id}/students
     * @originalName userStudentsList
     * @duplicate
     * @secure
     */
    userStudentsList2: (id: number, params: RequestParams = {}) =>
      this.request<UserStudentsList2Data, any>({
        path: `/admin/user/${id}/students`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserReservationCountList
     * @request GET:/admin/user/{id}/reservation-count
     * @secure
     */
    userReservationCountList: (id: number, params: RequestParams = {}) =>
      this.request<UserReservationCountListData, any>({
        path: `/admin/user/${id}/reservation-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserInbodyHistoriesList
     * @request GET:/admin/user/inbody-histories
     * @secure
     */
    userInbodyHistoriesList: (params: RequestParams = {}) =>
      this.request<UserInbodyHistoriesListData, any>({
        path: `/admin/user/inbody-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserInbodyHistoriesList2
     * @request GET:/admin/user/{id}/inbody-histories
     * @originalName userInbodyHistoriesList
     * @duplicate
     * @secure
     */
    userInbodyHistoriesList2: (id: number, params: RequestParams = {}) =>
      this.request<UserInbodyHistoriesList2Data, any>({
        path: `/admin/user/${id}/inbody-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMembershipHistoriesList
     * @request GET:/admin/user/membership-histories
     * @secure
     */
    userMembershipHistoriesList: (params: RequestParams = {}) =>
      this.request<UserMembershipHistoriesListData, any>({
        path: `/admin/user/membership-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMembershipHistoriesList2
     * @request GET:/admin/user/{id}/membership-histories
     * @originalName userMembershipHistoriesList
     * @duplicate
     * @secure
     */
    userMembershipHistoriesList2: (id: number, params: RequestParams = {}) =>
      this.request<UserMembershipHistoriesList2Data, any>({
        path: `/admin/user/${id}/membership-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMemosList
     * @request GET:/admin/user/{id}/memos
     * @secure
     */
    userMemosList: (id: number, params: RequestParams = {}) =>
      this.request<UserMemosListData, any>({
        path: `/admin/user/${id}/memos`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMemosCreate
     * @request POST:/admin/user/{id}/memos
     * @secure
     */
    userMemosCreate: (
      id: number,
      data: {
        content: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserMemosCreateData, any>({
        path: `/admin/user/${id}/memos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMemosDelete
     * @request DELETE:/admin/user/{id}/memos/{memoId}
     * @secure
     */
    userMemosDelete: (id: number, memoId: number, params: RequestParams = {}) =>
      this.request<UserMemosDeleteData, any>({
        path: `/admin/user/${id}/memos/${memoId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMemosPartialUpdate
     * @request PATCH:/admin/user/{id}/memos/{memoId}
     * @secure
     */
    userMemosPartialUpdate: (
      id: number,
      memoId: number,
      data: {
        content: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserMemosPartialUpdateData, any>({
        path: `/admin/user/${id}/memos/${memoId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMembershipsList
     * @request GET:/admin/user/{id}/memberships
     * @secure
     */
    userMembershipsList: (id: number, params: RequestParams = {}) =>
      this.request<UserMembershipsListData, any>({
        path: `/admin/user/${id}/memberships`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMembershipsCreate
     * @request POST:/admin/user/{id}/memberships
     * @secure
     */
    userMembershipsCreate: (
      id: number,
      data: {
        planId: number;
        startedAt: string;
        endedAt: string;
        count: number;
        capacity: number;
        lockerId?: number | null;
        membershipInstructorIds: number[];
        originalPrice?: number;
        discountAmount?: number;
        finalAmount?: number;
        cardAmount?: number;
        cashAmount?: number;
        transferAmount?: number;
        receivableAmount?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserMembershipsCreateData, any>({
        path: `/admin/user/${id}/memberships`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserMembershipsPartialUpdate
     * @request PATCH:/admin/user/{id}/memberships/{membershipId}
     * @secure
     */
    userMembershipsPartialUpdate: (
      id: string,
      membershipId: string,
      data: {
        planId?: number;
        startedAt?: string;
        endedAt?: string;
        count?: number;
        capacity?: number;
        cancelableCount?: number;
        lockerId?: number | null;
        membershipInstructorIds?: number[];
        reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserMembershipsPartialUpdateData, any>({
        path: `/admin/user/${id}/memberships/${membershipId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserExtendCreate
     * @request POST:/admin/user/extend
     * @secure
     */
    userExtendCreate: (
      data: {
        membershipIds: number[];
        extendDays: number;
        extendCount: number;
        reason: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserExtendCreateData, any>({
        path: `/admin/user/extend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserSuspendCreate
     * @request POST:/admin/user/suspend
     * @secure
     */
    userSuspendCreate: (
      data: {
        membershipIds: number[];
        startedAt: string;
        endedAt: string;
        reason: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuspendCreateData, any>({
        path: `/admin/user/suspend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserInstructorsList
     * @request GET:/admin/user/instructors
     * @secure
     */
    userInstructorsList: (params: RequestParams = {}) =>
      this.request<UserInstructorsListData, any>({
        path: `/admin/user/instructors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserInstructorsAllList
     * @request GET:/admin/user/instructors/all
     * @secure
     */
    userInstructorsAllList: (params: RequestParams = {}) =>
      this.request<UserInstructorsAllListData, any>({
        path: `/admin/user/instructors/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserInstructorsChangePasswordCreate
     * @request POST:/admin/user/instructors/{id}/change-password
     * @secure
     */
    userInstructorsChangePasswordCreate: (
      id: number,
      data: {
        newPassword: string;
        oldPassword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserInstructorsChangePasswordCreateData, any>({
        path: `/admin/user/instructors/${id}/change-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserPenaltyDelete
     * @request DELETE:/admin/user/{id}/penalty
     * @secure
     */
    userPenaltyDelete: (id: number, params: RequestParams = {}) =>
      this.request<UserPenaltyDeleteData, any>({
        path: `/admin/user/${id}/penalty`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 어드민 유저
     * @name UserPaymentMethodsList
     * @request GET:/admin/user/{id}/payment-methods
     * @secure
     */
    userPaymentMethodsList: (id: number, params: RequestParams = {}) =>
      this.request<UserPaymentMethodsListData, any>({
        path: `/admin/user/${id}/payment-methods`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreList
     * @request GET:/admin/store/
     * @secure
     */
    storeList: (params: RequestParams = {}) =>
      this.request<StoreListData, any>({
        path: `/admin/store/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreCreate
     * @request POST:/admin/store/
     * @secure
     */
    storeCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        tel?: string | null;
        phoneNumber?: string | null;
        businessNumber?: string | null;
        representative?: string | null;
        types: (string | number | boolean | null) | any[] | Record<string, any>;
        gymDidAccount?: string | null;
        pilatesDidAccount?: string | null;
        bareDidAccount?: string | null;
        address?: string | null;
        addressDetail?: string | null;
        branchTel?: string | null;
        naverPlaceRepresentative?: string | null;
        naverPlaceBusinessNumber?: string | null;
        naverPlaceTel?: string | null;
        point?: number;
        bodyAnalysisPoint?: number;
        timeTable?:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isFnbEnabled?: boolean;
        fnbTimeTable?:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        color?: string | null;
        images?:
          | ((string | number | boolean | null) | any[] | Record<string, any>)
          | null;
        fnbImage?: string | null;
        fnbScreenImages?: string[] | null;
        tossClientKey?: string | null;
        tossCultureClientKey?: string | null;
        createdAt?: string;
        updatedAt?: string;
        adminName: string;
        adminPhoneNumber: string;
        username: string;
        password: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StoreCreateData, any>({
        path: `/admin/store/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name StorePartialUpdate
     * @request PATCH:/admin/store/
     * @secure
     */
    storePartialUpdate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name?: string;
        tel?: string | null;
        phoneNumber?: string | null;
        businessNumber?: string | null;
        representative?: string | null;
        types?:
          | (string | number | boolean | null)
          | any[]
          | Record<string, any>;
        gymDidAccount?: string | null;
        pilatesDidAccount?: string | null;
        bareDidAccount?: string | null;
        address?: string | null;
        addressDetail?: string | null;
        branchTel?: string | null;
        naverPlaceRepresentative?: string | null;
        naverPlaceBusinessNumber?: string | null;
        naverPlaceTel?: string | null;
        point?: number;
        bodyAnalysisPoint?: number;
        timeTable?:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isFnbEnabled?: boolean;
        fnbTimeTable?:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        color?: string | null;
        images?:
          | ((string | number | boolean | null) | any[] | Record<string, any>)
          | null;
        fnbImage?: string | null;
        fnbScreenImages?: string[] | null;
        tossClientKey?: string | null;
        tossCultureClientKey?: string | null;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StorePartialUpdateData, any>({
        path: `/admin/store/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreMyList
     * @request GET:/admin/store/my
     * @secure
     */
    storeMyList: (params: RequestParams = {}) =>
      this.request<StoreMyListData, any>({
        path: `/admin/store/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreStoreDelete
     * @request DELETE:/admin/store/store/{id}
     * @secure
     */
    storeStoreDelete: (id: number, params: RequestParams = {}) =>
      this.request<StoreStoreDeleteData, any>({
        path: `/admin/store/store/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreStorePartialUpdate
     * @request PATCH:/admin/store/store/{id}
     * @secure
     */
    storeStorePartialUpdate: (
      id: number,
      data: {
        id?: number;
        /** @maxLength 255 */
        name?: string;
        tel?: string | null;
        phoneNumber?: string | null;
        businessNumber?: string | null;
        representative?: string | null;
        types?:
          | (string | number | boolean | null)
          | any[]
          | Record<string, any>;
        gymDidAccount?: string | null;
        pilatesDidAccount?: string | null;
        bareDidAccount?: string | null;
        address?: string | null;
        addressDetail?: string | null;
        branchTel?: string | null;
        naverPlaceRepresentative?: string | null;
        naverPlaceBusinessNumber?: string | null;
        naverPlaceTel?: string | null;
        point?: number;
        bodyAnalysisPoint?: number;
        timeTable?:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        isFnbEnabled?: boolean;
        fnbTimeTable?:
          | {
              isDayOff: boolean;
              open?: string;
              close?: string;
            }[]
          | null;
        color?: string | null;
        images?:
          | ((string | number | boolean | null) | any[] | Record<string, any>)
          | null;
        fnbImage?: string | null;
        fnbScreenImages?: string[] | null;
        tossClientKey?: string | null;
        tossCultureClientKey?: string | null;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StoreStorePartialUpdateData, any>({
        path: `/admin/store/store/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreSettingsList
     * @request GET:/admin/store/settings
     * @secure
     */
    storeSettingsList: (params: RequestParams = {}) =>
      this.request<StoreSettingsListData, any>({
        path: `/admin/store/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreSettingsCreate
     * @request POST:/admin/store/settings
     * @secure
     */
    storeSettingsCreate: (
      data: {
        id?: number;
        reservationAvailableHour?: number;
        groupClassCancelHour?: number;
        groupClassWaitingCancelHour?: number;
        privateClassCancelHour?: number;
        sameDayChangeHour?: number;
        waitingAutoReserveHour?: number;
        dailyReservationLimit?: number;
        closingTimeInterval?: number;
        checkInScreenImage?: string | null;
        isQrEntranceEnabled?: boolean;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StoreSettingsCreateData, any>({
        path: `/admin/store/settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StorePermissionsList
     * @request GET:/admin/store/permissions
     * @secure
     */
    storePermissionsList: (params: RequestParams = {}) =>
      this.request<StorePermissionsListData, any>({
        path: `/admin/store/permissions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreStorePermissionsCreate
     * @request POST:/admin/store/store/permissions
     * @secure
     */
    storeStorePermissionsCreate: (
      data: {
        instructorGroupClassModifyYn?: boolean;
        instructorPrivateClassCreateYn?: boolean;
        instructorPrivateClassModifyYn?: boolean;
        instructorPrivateClassReserveModifyYn?: boolean;
        instructorPrivateClassDeleteYn?: boolean;
        otherInstructorGroupClassViewYn?: boolean;
        otherInstructorPrivateClassViewYn?: boolean;
        memberListViewYn?: boolean;
        memberCreateYn?: boolean;
        memberTicketModifyYn?: boolean;
        instructorListViewYn?: boolean;
        ticketCreateYn?: boolean;
        ticketModifyYn?: boolean;
        operationSettingYn?: boolean;
        fnbProductCreateYn?: boolean;
        fnbProductModifyYn?: boolean;
        fnbCategoryManageYn?: boolean;
        fnbProductOrderYn?: boolean;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StoreStorePermissionsCreateData, any>({
        path: `/admin/store/store/permissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreNotificationsList
     * @request GET:/admin/store/notifications
     * @secure
     */
    storeNotificationsList: (params: RequestParams = {}) =>
      this.request<StoreNotificationsListData, any>({
        path: `/admin/store/notifications`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreNotificationsPartialUpdate
     * @request PATCH:/admin/store/notifications
     * @secure
     */
    storeNotificationsPartialUpdate: (
      data: {
        ticketExpireDays?: number;
        ticketExpireTemplate?: string;
        ticketExpireNotificationType?: "PUSH" | "SMS";
        ticketRemainCount?: number;
        ticketRemainTemplate?: string;
        ticketRemainNotificationType?: "PUSH" | "SMS";
        pausePeriodExpireDays?: number;
        pausePeriodExpireTemplate?: string;
        pausePeriodExpireNotificationType?: "PUSH" | "SMS";
        waitingToReserveTemplate?: string;
        waitingToReserveNotificationType?: "PUSH" | "SMS";
        groupClassStartHour?: number;
        groupClassStartTemplate?: string;
        groupClassStartNotificationType?: "PUSH" | "SMS";
        privateClassStartHour?: number;
        privateClassStartTemplate?: string;
        privateClassStartNotificationType?: "PUSH" | "SMS";
        birthdayTemplate?: string;
        birthdayNotificationType?: "PUSH" | "SMS";
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StoreNotificationsPartialUpdateData, any>({
        path: `/admin/store/notifications`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StorePaymentSettingsList
     * @request GET:/admin/store/payment-settings
     * @secure
     */
    storePaymentSettingsList: (params: RequestParams = {}) =>
      this.request<StorePaymentSettingsListData, any>({
        path: `/admin/store/payment-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StorePaymentSettingsCreate
     * @request POST:/admin/store/payment-settings
     * @secure
     */
    storePaymentSettingsCreate: (
      data: {
        tossSecretKey?: string | null;
        tossCultureSecretKey?: string | null;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StorePaymentSettingsCreateData, any>({
        path: `/admin/store/payment-settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreRoomsList
     * @request GET:/admin/store/rooms
     * @secure
     */
    storeRoomsList: (params: RequestParams = {}) =>
      this.request<StoreRoomsListData, any>({
        path: `/admin/store/rooms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StoreRoomsCreate
     * @request POST:/admin/store/rooms
     * @secure
     */
    storeRoomsCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        storeId?: number | null;
        createdAt?: string;
        updatedAt?: string;
      }[],
      params: RequestParams = {},
    ) =>
      this.request<StoreRoomsCreateData, any>({
        path: `/admin/store/rooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipList
     * @request GET:/admin/membership/
     * @secure
     */
    membershipList: (params: RequestParams = {}) =>
      this.request<MembershipListData, any>({
        path: `/admin/membership/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipCreate
     * @request POST:/admin/membership/
     * @secure
     */
    membershipCreate: (
      data: {
        id?: number;
        userId: number;
        planId: number;
        capacity: number;
        count: number;
        reservationAvailableCount?: number;
        cancelableCount: number;
        presentCount?: number;
        canceledCount?: number;
        noShowCount?: number;
        lockerId?: number | null;
        isSubscription?: boolean;
        subscriptionStatus?:
          | ("ACTIVE" | "PAUSED" | "CANCELED" | "CANCEL_REQUESTED")
          | null;
        nextBillingDate?: string | null;
        billingId?: number | null;
        tossMethodKey?: string | null;
        startedAt: string;
        endedAt: string;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MembershipCreateData, any>({
        path: `/admin/membership/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipDelete
     * @request DELETE:/admin/membership/{membershipId}
     * @secure
     */
    membershipDelete: (membershipId: number, params: RequestParams = {}) =>
      this.request<MembershipDeleteData, any>({
        path: `/admin/membership/${membershipId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipSuspendDelete
     * @request DELETE:/admin/membership/suspend/{membershipId}
     * @secure
     */
    membershipSuspendDelete: (
      membershipId: number,
      params: RequestParams = {},
    ) =>
      this.request<MembershipSuspendDeleteData, any>({
        path: `/admin/membership/suspend/${membershipId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipSuspendCreate
     * @request POST:/admin/membership/suspend/{membershipId}
     * @secure
     */
    membershipSuspendCreate: (
      membershipId: number,
      data: {
        startedAt: string;
        endedAt: string;
        reason: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MembershipSuspendCreateData, any>({
        path: `/admin/membership/suspend/${membershipId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipPlanList
     * @request GET:/admin/membershipPlan/
     * @secure
     */
    membershipPlanList: (params: RequestParams = {}) =>
      this.request<MembershipPlanListData, any>({
        path: `/admin/membershipPlan/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipPlanCreate
     * @request POST:/admin/membershipPlan/
     * @secure
     */
    membershipPlanCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId?: number | null;
        classType: "GROUP" | "PRIVATE";
        color?: string | null;
        count: number;
        cancelableCount: number;
        durationDays?: number | null;
        maxCapacity?: number | null;
        liked?: boolean;
        isActive?: boolean;
        groupId?: (number | null) | null;
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
        price?: number;
        sellOnApp?: boolean;
        monthlyPrice?: number | null;
        subscriptionDiscount?: number | null;
        discountAppliedMonths?: number | null;
        validityDays?: number | null;
        displayOrder?: number;
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MembershipPlanCreateData, any>({
        path: `/admin/membershipPlan/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipPlanDetail
     * @request GET:/admin/membershipPlan/{id}
     * @secure
     */
    membershipPlanDetail: (id: number, params: RequestParams = {}) =>
      this.request<MembershipPlanDetailData, any>({
        path: `/admin/membershipPlan/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipPlanMembershipsList
     * @request GET:/admin/membershipPlan/{id}/memberships
     * @secure
     */
    membershipPlanMembershipsList: (id: number, params: RequestParams = {}) =>
      this.request<MembershipPlanMembershipsListData, any>({
        path: `/admin/membershipPlan/${id}/memberships`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MembershipPlanStatusPartialUpdate
     * @request PATCH:/admin/membershipPlan/{id}/status
     * @secure
     */
    membershipPlanStatusPartialUpdate: (
      id: number,
      data: {
        isActive: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MembershipPlanStatusPartialUpdateData, any>({
        path: `/admin/membershipPlan/${id}/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Membership Groups
     * @name MembershipGroupList
     * @request GET:/admin/membership-group/
     * @secure
     */
    membershipGroupList: (params: RequestParams = {}) =>
      this.request<MembershipGroupListData, any>({
        path: `/admin/membership-group/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Membership Groups
     * @name MembershipGroupCreate
     * @request POST:/admin/membership-group/
     * @secure
     */
    membershipGroupCreate: (
      data: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MembershipGroupCreateData, any>({
        path: `/admin/membership-group/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Membership Groups
     * @name MembershipGroupDetail
     * @request GET:/admin/membership-group/{id}
     * @secure
     */
    membershipGroupDetail: (id: number, params: RequestParams = {}) =>
      this.request<MembershipGroupDetailData, any>({
        path: `/admin/membership-group/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Membership Groups
     * @name MembershipGroupUpdate
     * @request PUT:/admin/membership-group/{id}
     * @secure
     */
    membershipGroupUpdate: (
      id: number,
      data: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MembershipGroupUpdateData, any>({
        path: `/admin/membership-group/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Membership Groups
     * @name MembershipGroupDelete
     * @request DELETE:/admin/membership-group/{id}
     * @secure
     */
    membershipGroupDelete: (id: number, params: RequestParams = {}) =>
      this.request<MembershipGroupDeleteData, any>({
        path: `/admin/membership-group/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassList
     * @request GET:/admin/class/
     * @secure
     */
    classList: (
      query?: {
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassListData, any>({
        path: `/admin/class/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassBulkOpenCreate
     * @request POST:/admin/class/bulk-open
     * @secure
     */
    classBulkOpenCreate: (
      data: {
        classIds: number[];
        opendedAt: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassBulkOpenCreateData, any>({
        path: `/admin/class/bulk-open`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassBulkDeleteDelete
     * @request DELETE:/admin/class/bulk-delete
     * @secure
     */
    classBulkDeleteDelete: (
      data: {
        classIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassBulkDeleteDeleteData, any>({
        path: `/admin/class/bulk-delete`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassBulkUpdateCreate
     * @request POST:/admin/class/bulk-update
     * @secure
     */
    classBulkUpdateCreate: (
      data: {
        name?: string;
        maxCapacity?: number;
        adminUserId?: number;
        roomId?: number;
        reservationAvailableHour?: number;
        classCancelHour?: number;
        classWaitingCancelHour?: number;
        sameDayChangeHour?: number;
        classIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassBulkUpdateCreateData, any>({
        path: `/admin/class/bulk-update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassReservationsList
     * @request GET:/admin/class/reservations
     * @secure
     */
    classReservationsList: (
      query?: {
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassReservationsListData, any>({
        path: `/admin/class/reservations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassDeletedList
     * @request GET:/admin/class/deleted
     * @secure
     */
    classDeletedList: (params: RequestParams = {}) =>
      this.request<ClassDeletedListData, any>({
        path: `/admin/class/deleted`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassDetail
     * @request GET:/admin/class/{classId}
     * @secure
     */
    classDetail: (classId: number, params: RequestParams = {}) =>
      this.request<ClassDetailData, any>({
        path: `/admin/class/${classId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassDelete
     * @request DELETE:/admin/class/{classId}
     * @secure
     */
    classDelete: (classId: number, params: RequestParams = {}) =>
      this.request<ClassDeleteData, any>({
        path: `/admin/class/${classId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassPartialUpdate
     * @request PATCH:/admin/class/{classId}
     * @secure
     */
    classPartialUpdate: (
      classId: number,
      data: {
        id?: number;
        /** @maxLength 255 */
        name?: string;
        maxCapacity?: number;
        type?: "GROUP" | "PRIVATE";
        reservationAvailableHour?: number | null;
        classCancelHour?: number;
        classWaitingCancelHour?: number;
        sameDayChangeHour?: number | null;
        startedAt?: string;
        endedAt?: string;
        roomId?: ((number | null) | null) & (number | null);
        adminUserId?: number | null;
        isReservationEnabled?: boolean;
        deductionCount?: number;
        groupClassId?: number | null;
        storeId?: number;
        deletedReason?: string | null;
        deletedUserId?: number | null;
        openedAt?: string | null;
        deletedAt?: string | null;
        createdAt?: string;
        updatedAt?: string;
        classAvailablePlanIds?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassPartialUpdateData, any>({
        path: `/admin/class/${classId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassPrivateCreate
     * @request POST:/admin/class/private
     * @secure
     */
    classPrivateCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        maxCapacity: number;
        reservationAvailableHour?: number | null;
        classCancelHour: number;
        classWaitingCancelHour?: number;
        sameDayChangeHour?: number | null;
        startedAt: string;
        endedAt: string;
        roomId?: (number | null) | null;
        adminUserId?: number | null;
        isReservationEnabled?: boolean;
        deductionCount?: number;
        groupClassId?: number | null;
        deletedReason?: string | null;
        deletedUserId?: number | null;
        openedAt?: string | null;
        deletedAt?: string | null;
        createdAt?: string;
        updatedAt?: string;
        classAvailableMembershipIds?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassPrivateCreateData, any>({
        path: `/admin/class/private`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassMemosList
     * @request GET:/admin/class/{id}/memos
     * @secure
     */
    classMemosList: (id: number, params: RequestParams = {}) =>
      this.request<ClassMemosListData, any>({
        path: `/admin/class/${id}/memos`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassMemosCreate
     * @request POST:/admin/class/{id}/memos
     * @secure
     */
    classMemosCreate: (
      id: number,
      data: {
        content: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassMemosCreateData, any>({
        path: `/admin/class/${id}/memos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassMemosDelete
     * @request DELETE:/admin/class/{id}/memos/{memoId}
     * @secure
     */
    classMemosDelete: (
      id: number,
      memoId: number,
      params: RequestParams = {},
    ) =>
      this.request<ClassMemosDeleteData, any>({
        path: `/admin/class/${id}/memos/${memoId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassMemosPartialUpdate
     * @request PATCH:/admin/class/{id}/memos/{memoId}
     * @secure
     */
    classMemosPartialUpdate: (
      id: number,
      memoId: number,
      data: {
        content: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClassMemosPartialUpdateData, any>({
        path: `/admin/class/${id}/memos/${memoId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassInstructorPrivateList
     * @request GET:/admin/class/instructor/{id}/private
     * @secure
     */
    classInstructorPrivateList: (id: number, params: RequestParams = {}) =>
      this.request<ClassInstructorPrivateListData, any>({
        path: `/admin/class/instructor/${id}/private`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name ClassNavigationList
     * @request GET:/admin/class/{classId}/navigation
     * @secure
     */
    classNavigationList: (classId: number, params: RequestParams = {}) =>
      this.request<ClassNavigationListData, any>({
        path: `/admin/class/${classId}/navigation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name GroupClassCreate
     * @request POST:/admin/group-class/
     * @secure
     */
    groupClassCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        maxCapacity: number;
        reservationAvailableHour?: number | null;
        classCancelHour: number;
        classWaitingCancelHour?: number;
        sameDayChangeHour?: number | null;
        startedAt: string;
        endedAt: string;
        timeTable: {
          day: number;
          start: string;
          end: string;
          adminUserId: number;
          roomId: number | null;
        }[];
        openedAt?: string | null;
        createdAt?: string;
        updatedAt?: string;
        classAvailablePlanIds: number[];
        /** @default 1 */
        deductionCount?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GroupClassCreateData, any>({
        path: `/admin/group-class/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name GroupClassPartialUpdate
     * @request PATCH:/admin/group-class/{id}
     * @secure
     */
    groupClassPartialUpdate: (
      id: number,
      data: {
        /** @maxLength 255 */
        name: string;
        maxCapacity: number;
        reservationAvailableHour?: number | null;
        classCancelHour: number;
        classWaitingCancelHour?: number;
        sameDayChangeHour?: number | null;
        classAvailablePlanIds?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GroupClassPartialUpdateData, any>({
        path: `/admin/group-class/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name GroupClassCheckConflictCreate
     * @request POST:/admin/group-class/check-conflict
     * @secure
     */
    groupClassCheckConflictCreate: (
      data: {
        classes: {
          adminUserId: number;
          startedAt: string;
          endedAt: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GroupClassCheckConflictCreateData, any>({
        path: `/admin/group-class/check-conflict`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name GroupClassInstructorsDetail
     * @request GET:/admin/group-class/instructors/{id}
     * @secure
     */
    groupClassInstructorsDetail: (id: number, params: RequestParams = {}) =>
      this.request<GroupClassInstructorsDetailData, any>({
        path: `/admin/group-class/instructors/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name PaymentAuthCallbackCreate
     * @request POST:/admin/payment/auth/callback
     * @secure
     */
    paymentAuthCallbackCreate: (
      data: {
        AuthResultCode: string;
        AuthResultMsg: string;
        TxTid: string;
        AuthToken: string;
        PayMethod: string;
        MID: string;
        Moid: string;
        Amt: string;
        ReqReserved: string;
        NextAppURL: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentAuthCallbackCreateData, string>({
        path: `/admin/payment/auth/callback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesPurchaseCreate
     * @request POST:/admin/messages/purchase
     * @secure
     */
    messagesPurchaseCreate: (
      data: {
        userId: string;
        storeId: string;
        paymentType: "CARD" | "KAKAO" | "NAVER";
        redirectUrl: string;
        errorRedirectUrl: string;
        purchasePoint:
          | ("10000" | "50000" | "100000")
          | ("2000" | "10000" | "20000");
        pointType?: "SMS" | "BODY_ANALYSIS";
      },
      params: RequestParams = {},
    ) =>
      this.request<MessagesPurchaseCreateData, any>({
        path: `/admin/messages/purchase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesPurchaseBillingCreate
     * @request POST:/admin/messages/purchase/billing
     * @secure
     */
    messagesPurchaseBillingCreate: (
      data: {
        billingId: number;
        purchasePoint: "10000" | "50000" | "100000";
        redirectUrl: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessagesPurchaseBillingCreateData, any>({
        path: `/admin/messages/purchase/billing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesList
     * @request GET:/admin/messages
     * @secure
     */
    messagesList: (params: RequestParams = {}) =>
      this.request<MessagesListData, any>({
        path: `/admin/messages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesCreate
     * @request POST:/admin/messages
     * @secure
     */
    messagesCreate: (
      data: {
        title?: string;
        message: string;
        userIds: number[];
        reserveTime?: string;
        isAd?: boolean;
        base64EncodedImages?: string[];
        imageUrls?: string[];
        type: "SMS" | "LMS" | "MMS";
      },
      params: RequestParams = {},
    ) =>
      this.request<MessagesCreateData, any>({
        path: `/admin/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesPushList
     * @request GET:/admin/messages/push
     * @secure
     */
    messagesPushList: (params: RequestParams = {}) =>
      this.request<MessagesPushListData, any>({
        path: `/admin/messages/push`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesPushCreate
     * @request POST:/admin/messages/push
     * @secure
     */
    messagesPushCreate: (
      data: {
        title: string;
        message: string;
        userIds: number[];
        reserveTime?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessagesPushCreateData, any>({
        path: `/admin/messages/push`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesDelete
     * @request DELETE:/admin/messages/{id}
     * @secure
     */
    messagesDelete: (id: string, params: RequestParams = {}) =>
      this.request<MessagesDeleteData, any>({
        path: `/admin/messages/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesPushDelete
     * @request DELETE:/admin/messages/push/{id}
     * @secure
     */
    messagesPushDelete: (id: string, params: RequestParams = {}) =>
      this.request<MessagesPushDeleteData, any>({
        path: `/admin/messages/push/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesPointPaymentHistoriesList
     * @request GET:/admin/messages/point-payment-histories
     * @secure
     */
    messagesPointPaymentHistoriesList: (params: RequestParams = {}) =>
      this.request<MessagesPointPaymentHistoriesListData, any>({
        path: `/admin/messages/point-payment-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MessagesAllPointPaymentHistoriesList
     * @request GET:/admin/messages/all-point-payment-histories
     * @secure
     */
    messagesAllPointPaymentHistoriesList: (params: RequestParams = {}) =>
      this.request<MessagesAllPointPaymentHistoriesListData, any>({
        path: `/admin/messages/all-point-payment-histories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BillingsRegisterCreate
     * @request POST:/admin/billings/register
     * @secure
     */
    billingsRegisterCreate: (
      data: {
        email: string;
        name: string;
        phoneNumber: string;
        redirectUrl: string;
        storeId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BillingsRegisterCreateData, any>({
        path: `/admin/billings/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BillingsUnauthRegisterCreate
     * @request POST:/admin/billings/unauth/register
     * @secure
     */
    billingsUnauthRegisterCreate: (
      data: {
        cardNumber: string;
        cardYear: string;
        cardMonth: string;
        cardPassword: string;
        businessNumber: string;
        email: string;
        name: string;
        phoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BillingsUnauthRegisterCreateData, any>({
        path: `/admin/billings/unauth/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BillingsAuthCallbackCreate
     * @request POST:/admin/billings/auth/callback
     * @secure
     */
    billingsAuthCallbackCreate: (
      data: {
        AuthResultCode: string;
        AuthResultMsg: string;
        TxTid: string;
        AuthToken: string;
        PayMethod: string;
        MID: string;
        Moid: string;
        Amt: string;
        ReqReserved: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, void | string>({
        path: `/admin/billings/auth/callback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BillingsDelete
     * @request DELETE:/admin/billings
     * @secure
     */
    billingsDelete: (
      data: {
        billingId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BillingsDeleteData, any>({
        path: `/admin/billings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BillingsList
     * @request GET:/admin/billings
     * @secure
     */
    billingsList: (params: RequestParams = {}) =>
      this.request<BillingsListData, any>({
        path: `/admin/billings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsPartialUpdate
     * @request PATCH:/admin/reservations/{id}
     * @secure
     */
    reservationsPartialUpdate: (
      id: number,
      data: {
        status: "RESERVED" | "CANCELED" | "PRESENT" | "NO_SHOW" | "WAITING";
      },
      params: RequestParams = {},
    ) =>
      this.request<ReservationsPartialUpdateData, any>({
        path: `/admin/reservations/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsDelete
     * @request DELETE:/admin/reservations/{id}
     * @secure
     */
    reservationsDelete: (id: number, params: RequestParams = {}) =>
      this.request<ReservationsDeleteData, any>({
        path: `/admin/reservations/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsUserDetail
     * @request GET:/admin/reservations/user/{userId}
     * @secure
     */
    reservationsUserDetail: (userId: number, params: RequestParams = {}) =>
      this.request<ReservationsUserDetailData, any>({
        path: `/admin/reservations/user/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsUserReservationsList
     * @request GET:/admin/reservations/user-reservations
     * @secure
     */
    reservationsUserReservationsList: (
      query: {
        phoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReservationsUserReservationsListData, any>({
        path: `/admin/reservations/user-reservations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsCreate
     * @request POST:/admin/reservations/
     * @secure
     */
    reservationsCreate: (
      data: {
        classId: number;
        membershipId: number;
        userId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReservationsCreateData, any>({
        path: `/admin/reservations/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsPresentCreate
     * @request POST:/admin/reservations/present
     * @secure
     */
    reservationsPresentCreate: (
      data: {
        phoneNumber: string;
        reservationId?: number;
        membershipId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReservationsPresentCreateData, any>({
        path: `/admin/reservations/present`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsAttendanceHistoryDelete
     * @request DELETE:/admin/reservations/attendance-history/{id}
     * @secure
     */
    reservationsAttendanceHistoryDelete: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        ReservationsAttendanceHistoryDeleteData,
        {
          error: string;
        }
      >({
        path: `/admin/reservations/attendance-history/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DietList
     * @request GET:/admin/diet/
     * @secure
     */
    dietList: (params: RequestParams = {}) =>
      this.request<DietListData, any>({
        path: `/admin/diet/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DietCreate
     * @request POST:/admin/diet/
     * @secure
     */
    dietCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        imageUrl?: string | null;
        protein: number;
        carbs: number;
        fat: number;
        size: number;
        allergens?: string[] | null;
        benefits?: string[] | null;
        source: "PROTEIN" | "CARBS" | "FAT";
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DietCreateData, any>({
        path: `/admin/diet/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DietDetail
     * @request GET:/admin/diet/{dietId}
     * @secure
     */
    dietDetail: (dietId: number, params: RequestParams = {}) =>
      this.request<DietDetailData, any>({
        path: `/admin/diet/${dietId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DietPartialUpdate
     * @request PATCH:/admin/diet/{dietId}
     * @secure
     */
    dietPartialUpdate: (
      dietId: number,
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        imageUrl?: string | null;
        protein: number;
        carbs: number;
        fat: number;
        size: number;
        allergens?: string[] | null;
        benefits?: string[] | null;
        source: "PROTEIN" | "CARBS" | "FAT";
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DietPartialUpdateData, any>({
        path: `/admin/diet/${dietId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name DietDelete
     * @request DELETE:/admin/diet/{dietId}
     * @secure
     */
    dietDelete: (dietId: number, params: RequestParams = {}) =>
      this.request<DietDeleteData, any>({
        path: `/admin/diet/${dietId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BodyCheckUserList
     * @request GET:/admin/body/check-user
     * @secure
     */
    bodyCheckUserList: (
      query: {
        phoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BodyCheckUserListData, any>({
        path: `/admin/body/check-user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BodyCreate
     * @request POST:/admin/body/
     * @secure
     */
    bodyCreate: (
      data: {
        /** 사용자 전화번호 */
        phoneNumber: string;
        /** 정면 사진 URL */
        frontImageUrl: string;
        /** 오른쪽 측면 사진 URL */
        rightSideImageUrl: string;
        /** 왼쪽 측면 사진 URL */
        leftSideImageUrl: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BodyCreateData, any>({
        path: `/admin/body/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 사용자의 체형 분석 기록 조회 (어드민용)
     *
     * @tags
     * @name BodyHistoriesDetail
     * @request GET:/admin/body/histories/{userId}
     * @secure
     */
    bodyHistoriesDetail: (
      userId: number,
      query?: {
        /**
         * 정렬 순서 (기본값: false - 내림차순)
         * @default false
         */
        asc?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BodyHistoriesDetailData,
        {
          message: string;
        }
      >({
        path: `/admin/body/histories/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name DietScheduleList
     * @request GET:/admin/diet-schedule/
     * @secure
     */
    dietScheduleList: (
      query: {
        userId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DietScheduleListData, any>({
        path: `/admin/diet-schedule/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name DietScheduleDailyDietPreferencesList
     * @request GET:/admin/diet-schedule/daily-diet-preferences
     * @secure
     */
    dietScheduleDailyDietPreferencesList: (
      query: {
        userId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DietScheduleDailyDietPreferencesListData, any>({
        path: `/admin/diet-schedule/daily-diet-preferences`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Preferences
     * @name DietPreferencesList
     * @request GET:/admin/diet-preferences/
     * @secure
     */
    dietPreferencesList: (
      query: {
        userId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DietPreferencesListData, any>({
        path: `/admin/diet-preferences/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsList
     * @request GET:/admin/products/
     * @secure
     */
    productsList: (
      query?: {
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
        isActive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsListData, any>({
        path: `/admin/products/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsCreate
     * @request POST:/admin/products/
     * @secure
     */
    productsCreate: (
      data: {
        id?: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId?: number | null;
        classType: "GROUP" | "PRIVATE";
        color?: string | null;
        count: number;
        cancelableCount: number;
        durationDays?: number | null;
        maxCapacity?: number | null;
        liked?: boolean;
        isActive?: boolean;
        groupId?: (number | null) | null;
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
        price?: number;
        sellOnApp?: boolean;
        monthlyPrice?: number | null;
        subscriptionDiscount?: number | null;
        discountAppliedMonths?: number | null;
        validityDays?: number | null;
        displayOrder?: number;
        createdAt?: string;
        updatedAt?: string;
        addonPlanIds?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsCreateData, any>({
        path: `/admin/products/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsDetail
     * @request GET:/admin/products/{id}
     * @secure
     */
    productsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        ProductsDetailData,
        {
          error: string;
        }
      >({
        path: `/admin/products/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsUpdate
     * @request PUT:/admin/products/{id}
     * @secure
     */
    productsUpdate: (
      id: number,
      data: {
        id: number;
        /** @maxLength 255 */
        name: string;
        durationType: "COUNT_BASED" | "PERIOD_BASED";
        storeId?: number | null;
        classType: "GROUP" | "PRIVATE";
        color?: string | null;
        count: number;
        cancelableCount: number;
        durationDays?: number | null;
        maxCapacity?: number | null;
        liked?: boolean;
        isActive?: boolean;
        groupId?: (number | null) | null;
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
        price?: number;
        sellOnApp?: boolean;
        monthlyPrice?: number | null;
        subscriptionDiscount?: number | null;
        discountAppliedMonths?: number | null;
        validityDays?: number | null;
        displayOrder?: number;
        createdAt?: string;
        updatedAt?: string;
        addonPlanIds?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsUpdateData, any>({
        path: `/admin/products/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsDelete
     * @request DELETE:/admin/products/{id}
     * @secure
     */
    productsDelete: (id: number, params: RequestParams = {}) =>
      this.request<ProductsDeleteData, any>({
        path: `/admin/products/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsStatusPartialUpdate
     * @request PATCH:/admin/products/{id}/status
     * @secure
     */
    productsStatusPartialUpdate: (
      id: number,
      data: {
        isActive: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsStatusPartialUpdateData, any>({
        path: `/admin/products/${id}/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Products
     * @name ProductsOrderPartialUpdate
     * @request PATCH:/admin/products/order
     * @secure
     */
    productsOrderPartialUpdate: (
      data: {
        productIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsOrderPartialUpdateData, any>({
        path: `/admin/products/order`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Groups
     * @name ProductGroupsList
     * @request GET:/admin/product-groups/
     * @secure
     */
    productGroupsList: (params: RequestParams = {}) =>
      this.request<ProductGroupsListData, any>({
        path: `/admin/product-groups/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Groups
     * @name ProductGroupsCreate
     * @request POST:/admin/product-groups/
     * @secure
     */
    productGroupsCreate: (
      data: {
        name: string;
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductGroupsCreateData, any>({
        path: `/admin/product-groups/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Groups
     * @name ProductGroupsDetail
     * @request GET:/admin/product-groups/{id}
     * @secure
     */
    productGroupsDetail: (id: number, params: RequestParams = {}) =>
      this.request<ProductGroupsDetailData, any>({
        path: `/admin/product-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Groups
     * @name ProductGroupsUpdate
     * @request PUT:/admin/product-groups/{id}
     * @secure
     */
    productGroupsUpdate: (
      id: number,
      data: {
        name: string;
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductGroupsUpdateData, any>({
        path: `/admin/product-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Groups
     * @name ProductGroupsDelete
     * @request DELETE:/admin/product-groups/{id}
     * @secure
     */
    productGroupsDelete: (id: number, params: RequestParams = {}) =>
      this.request<ProductGroupsDeleteData, any>({
        path: `/admin/product-groups/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Histories
     * @name PaymentHistoriesList
     * @request GET:/admin/payment-histories/
     * @secure
     */
    paymentHistoriesList: (
      query?: {
        status?: "PENDING" | "COMPLETED" | "CANCELED" | "REFUNDED";
        paymentMethod?:
          | "CARD"
          | "KAKAO"
          | "NAVER"
          | "CASH"
          | "TRANSFER"
          | "BILLING";
        paymentType?: "ONE_TIME" | "SUBSCRIPTION";
        paymentSource?: "APP" | "IN_STORE";
        startDate?: string;
        endDate?: string;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentHistoriesListData, any>({
        path: `/admin/payment-histories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Histories
     * @name PaymentHistoriesRefundList
     * @request GET:/admin/payment-histories/{id}/refund
     * @secure
     */
    paymentHistoriesRefundList: (id: number, params: RequestParams = {}) =>
      this.request<
        PaymentHistoriesRefundListData,
        {
          error: string;
        }
      >({
        path: `/admin/payment-histories/${id}/refund`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment Histories
     * @name PaymentHistoriesRefundCreate
     * @request POST:/admin/payment-histories/{id}/refund
     * @secure
     */
    paymentHistoriesRefundCreate: (
      id: number,
      data: {
        refundAmount: number;
        refundReason: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentHistoriesRefundCreateData,
        {
          error: string;
        }
      >({
        path: `/admin/payment-histories/${id}/refund`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerSettingsCreate
     * @request POST:/admin/locker/settings
     * @secure
     */
    lockerSettingsCreate: (
      data: {
        type: "UNISEX" | "MALE" | "FEMALE";
        rows: number;
        cols: number;
        /** @default 1 */
        startNumber: number;
        numberDirection: "HORIZONTAL" | "VERTICAL";
        startPosition:
          | "TOP_LEFT"
          | "TOP_RIGHT"
          | "BOTTOM_LEFT"
          | "BOTTOM_RIGHT";
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerSettingsCreateData, any>({
        path: `/admin/locker/settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerSettingsList
     * @request GET:/admin/locker/settings
     * @secure
     */
    lockerSettingsList: (params: RequestParams = {}) =>
      this.request<LockerSettingsListResult, any>({
        path: `/admin/locker/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerSettingsDetail
     * @request GET:/admin/locker/settings/{type}
     * @secure
     */
    lockerSettingsDetail: (type: string, params: RequestParams = {}) =>
      this.request<LockerSettingsDetailData, any>({
        path: `/admin/locker/settings/${type}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerGenerateCreate
     * @request POST:/admin/locker/generate
     * @secure
     */
    lockerGenerateCreate: (
      data: {
        type: "UNISEX" | "MALE" | "FEMALE";
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerGenerateCreateData, any>({
        path: `/admin/locker/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerList
     * @request GET:/admin/locker/
     * @secure
     */
    lockerList: (
      query?: {
        type?: "UNISEX" | "MALE" | "FEMALE";
        status?: "AVAILABLE" | "IN_USE" | "BROKEN" | "UNDER_REPAIR";
        /** @default 1 */
        page?: number;
        /** @default 50 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerListData, any>({
        path: `/admin/locker/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerDetail
     * @request GET:/admin/locker/{lockerId}
     * @secure
     */
    lockerDetail: (lockerId: string, params: RequestParams = {}) =>
      this.request<LockerDetailData, any>({
        path: `/admin/locker/${lockerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerDelete
     * @request DELETE:/admin/locker/{lockerId}
     * @secure
     */
    lockerDelete: (lockerId: string, params: RequestParams = {}) =>
      this.request<LockerDeleteData, any>({
        path: `/admin/locker/${lockerId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerAssignCreate
     * @request POST:/admin/locker/{lockerId}/assign
     * @secure
     */
    lockerAssignCreate: (
      lockerId: string,
      data: {
        membershipId: number;
        password?: string;
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerAssignCreateData, any>({
        path: `/admin/locker/${lockerId}/assign`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerReleaseCreate
     * @request POST:/admin/locker/{lockerId}/release
     * @secure
     */
    lockerReleaseCreate: (
      lockerId: string,
      data: {
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerReleaseCreateData, any>({
        path: `/admin/locker/${lockerId}/release`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerChangeCreate
     * @request POST:/admin/locker/{lockerId}/change
     * @secure
     */
    lockerChangeCreate: (
      lockerId: string,
      data: {
        newLockerId: number;
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerChangeCreateData, any>({
        path: `/admin/locker/${lockerId}/change`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerPasswordPartialUpdate
     * @request PATCH:/admin/locker/{lockerId}/password
     * @secure
     */
    lockerPasswordPartialUpdate: (
      lockerId: string,
      data: {
        newPassword: string;
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerPasswordPartialUpdateData, any>({
        path: `/admin/locker/${lockerId}/password`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerBrokenPartialUpdate
     * @request PATCH:/admin/locker/{lockerId}/broken
     * @secure
     */
    lockerBrokenPartialUpdate: (
      lockerId: string,
      data: {
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerBrokenPartialUpdateData, any>({
        path: `/admin/locker/${lockerId}/broken`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerRepairPartialUpdate
     * @request PATCH:/admin/locker/{lockerId}/repair
     * @secure
     */
    lockerRepairPartialUpdate: (
      lockerId: string,
      data: {
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerRepairPartialUpdateData, any>({
        path: `/admin/locker/${lockerId}/repair`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin - Locker
     * @name LockerHistoriesList
     * @request GET:/admin/locker/{lockerId}/histories
     * @secure
     */
    lockerHistoriesList: (
      lockerId: string,
      query?: {
        /** @default 1 */
        page?: number;
        /** @default 20 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerHistoriesListData, any>({
        path: `/admin/locker/${lockerId}/histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attendance
     * @name AttendanceList
     * @request GET:/admin/attendance/
     * @secure
     */
    attendanceList: (
      query: {
        /** @format date */
        date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttendanceListResult, any>({
        path: `/admin/attendance/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attendance
     * @name AttendanceRealtimeList
     * @request GET:/admin/attendance/realtime
     * @secure
     */
    attendanceRealtimeList: (
      query?: {
        since?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttendanceRealtimeListData, any>({
        path: `/admin/attendance/realtime`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesList
     * @request GET:/admin/fnb-categories/
     * @secure
     */
    fnbCategoriesList: (params: RequestParams = {}) =>
      this.request<FnbCategoriesListData, any>({
        path: `/admin/fnb-categories/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesStoreSettingsMainPartialUpdate
     * @request PATCH:/admin/fnb-categories/store-settings/main
     * @secure
     */
    fnbCategoriesStoreSettingsMainPartialUpdate: (
      data: {
        settings: {
          mainCategoryId: number;
          displayOrder?: number;
          isActive?: boolean;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbCategoriesStoreSettingsMainPartialUpdateData, any>({
        path: `/admin/fnb-categories/store-settings/main`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesStoreSettingsSubPartialUpdate
     * @request PATCH:/admin/fnb-categories/store-settings/sub
     * @secure
     */
    fnbCategoriesStoreSettingsSubPartialUpdate: (
      data: {
        settings: {
          subCategoryId: number;
          displayOrder?: number;
          isActive?: boolean;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbCategoriesStoreSettingsSubPartialUpdateData, any>({
        path: `/admin/fnb-categories/store-settings/sub`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesMainCreate
     * @request POST:/admin/fnb-categories/main
     * @secure
     */
    fnbCategoriesMainCreate: (
      data: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbCategoriesMainCreateData, any>({
        path: `/admin/fnb-categories/main`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesMainPartialUpdate
     * @request PATCH:/admin/fnb-categories/main/{id}
     * @secure
     */
    fnbCategoriesMainPartialUpdate: (
      id: number,
      data: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbCategoriesMainPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-categories/main/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesMainDelete
     * @request DELETE:/admin/fnb-categories/main/{id}
     * @secure
     */
    fnbCategoriesMainDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        FnbCategoriesMainDeleteData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-categories/main/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesMainOrderPartialUpdate
     * @request PATCH:/admin/fnb-categories/main/order
     * @secure
     */
    fnbCategoriesMainOrderPartialUpdate: (
      data: {
        orders: {
          id: number;
          displayOrder: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbCategoriesMainOrderPartialUpdateData, any>({
        path: `/admin/fnb-categories/main/order`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesSubCreate
     * @request POST:/admin/fnb-categories/sub
     * @secure
     */
    fnbCategoriesSubCreate: (
      data: {
        name: string;
        mainCategoryId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbCategoriesSubCreateData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-categories/sub`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesSubPartialUpdate
     * @request PATCH:/admin/fnb-categories/sub/{id}
     * @secure
     */
    fnbCategoriesSubPartialUpdate: (
      id: number,
      data: {
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbCategoriesSubPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-categories/sub/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesSubDelete
     * @request DELETE:/admin/fnb-categories/sub/{id}
     * @secure
     */
    fnbCategoriesSubDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        FnbCategoriesSubDeleteData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-categories/sub/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Categories
     * @name FnbCategoriesSubOrderPartialUpdate
     * @request PATCH:/admin/fnb-categories/sub/order
     * @secure
     */
    fnbCategoriesSubOrderPartialUpdate: (
      data: {
        orders: {
          id: number;
          displayOrder: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbCategoriesSubOrderPartialUpdateData, any>({
        path: `/admin/fnb-categories/sub/order`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsList
     * @request GET:/admin/fnb-products/
     * @secure
     */
    fnbProductsList: (
      query?: {
        subCategoryId?: number;
        mainCategoryId?: number;
        includeDeleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbProductsListData, any>({
        path: `/admin/fnb-products/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsCreate
     * @request POST:/admin/fnb-products/
     * @secure
     */
    fnbProductsCreate: (
      data: {
        name: string;
        subCategoryId: number;
        imageUrl?: string;
        price: number;
        isDiscounted?: boolean;
        discountPrice?: number;
        stock?: number;
        description?: string;
        color?: string;
        sellOnApp?: boolean;
        isSoldOut?: boolean;
        isFirstPurchaseOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbProductsCreateData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-products/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsDetail
     * @request GET:/admin/fnb-products/{id}
     * @secure
     */
    fnbProductsDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        FnbProductsDetailData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-products/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsPartialUpdate
     * @request PATCH:/admin/fnb-products/{id}
     * @secure
     */
    fnbProductsPartialUpdate: (
      id: number,
      data: {
        name?: string;
        subCategoryId?: number;
        imageUrl?: string | null;
        price?: number;
        isDiscounted?: boolean;
        discountPrice?: number | null;
        description?: string | null;
        color?: string | null;
        sellOnApp?: boolean;
        isSoldOut?: boolean;
        isFirstPurchaseOnly?: boolean;
        isActive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbProductsPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-products/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsDelete
     * @request DELETE:/admin/fnb-products/{id}
     * @secure
     */
    fnbProductsDelete: (id: number, params: RequestParams = {}) =>
      this.request<
        FnbProductsDeleteData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-products/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsOrderPartialUpdate
     * @request PATCH:/admin/fnb-products/order
     * @secure
     */
    fnbProductsOrderPartialUpdate: (
      data: {
        orders: {
          id: number;
          displayOrder: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbProductsOrderPartialUpdateData, any>({
        path: `/admin/fnb-products/order`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsStockPartialUpdate
     * @request PATCH:/admin/fnb-products/{id}/stock
     * @secure
     */
    fnbProductsStockPartialUpdate: (
      id: number,
      data: {
        quantity: number;
        memo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbProductsStockPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-products/${id}/stock`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Products
     * @name FnbProductsStockHistoriesList
     * @request GET:/admin/fnb-products/{id}/stock-histories
     * @secure
     */
    fnbProductsStockHistoriesList: (
      id: number,
      query?: {
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FnbProductsStockHistoriesListData,
        {
          error: string;
        }
      >({
        path: `/admin/fnb-products/${id}/stock-histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersCreate
     * @request POST:/admin/fnb-orders/
     * @secure
     */
    fnbOrdersCreate: (
      data: {
        userId: number;
        methodKey?: string;
        /** @minItems 1 */
        items: {
          productId: number;
          /** @min 1 */
          quantity: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbOrdersCreateData, any>({
        path: `/admin/fnb-orders/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersList
     * @request GET:/admin/fnb-orders/
     * @secure
     */
    fnbOrdersList: (
      query?: {
        status?:
          | "PENDING_PAYMENT"
          | "PAID"
          | "READY"
          | "COMPLETED"
          | "REFUNDED";
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbOrdersListData, any>({
        path: `/admin/fnb-orders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersPendingList
     * @request GET:/admin/fnb-orders/pending
     * @secure
     */
    fnbOrdersPendingList: (params: RequestParams = {}) =>
      this.request<FnbOrdersPendingListData, any>({
        path: `/admin/fnb-orders/pending`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersStatusBoardList
     * @request GET:/admin/fnb-orders/status-board
     * @secure
     */
    fnbOrdersStatusBoardList: (params: RequestParams = {}) =>
      this.request<FnbOrdersStatusBoardListData, any>({
        path: `/admin/fnb-orders/status-board`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersPayCreate
     * @request POST:/admin/fnb-orders/{id}/pay
     * @secure
     */
    fnbOrdersPayCreate: (
      id: number,
      data: {
        /**
         * @minLength 4
         * @maxLength 10
         */
        pin: string;
        methodKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbOrdersPayCreateData, any>({
        path: `/admin/fnb-orders/${id}/pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersDetail
     * @request GET:/admin/fnb-orders/{id}
     * @secure
     */
    fnbOrdersDetail: (id: number, params: RequestParams = {}) =>
      this.request<FnbOrdersDetailData, any>({
        path: `/admin/fnb-orders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersReadyPartialUpdate
     * @request PATCH:/admin/fnb-orders/{id}/ready
     * @secure
     */
    fnbOrdersReadyPartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<FnbOrdersReadyPartialUpdateData, any>({
        path: `/admin/fnb-orders/${id}/ready`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersCompletePartialUpdate
     * @request PATCH:/admin/fnb-orders/{id}/complete
     * @secure
     */
    fnbOrdersCompletePartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<FnbOrdersCompletePartialUpdateData, any>({
        path: `/admin/fnb-orders/${id}/complete`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersRefundCreate
     * @request POST:/admin/fnb-orders/{id}/refund
     * @secure
     */
    fnbOrdersRefundCreate: (
      id: number,
      data: {
        /** @min 0 */
        refundAmount: number;
        refundReason: string;
        cancelItems?: {
          orderItemId: number;
          /** @min 1 */
          cancelQuantity: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<FnbOrdersRefundCreateData, any>({
        path: `/admin/fnb-orders/${id}/refund`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B Orders
     * @name FnbOrdersPaymentRequestsCancelCreate
     * @request POST:/admin/fnb-orders/payment-requests/{id}/cancel
     * @secure
     */
    fnbOrdersPaymentRequestsCancelCreate: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<FnbOrdersPaymentRequestsCancelCreateData, any>({
        path: `/admin/fnb-orders/payment-requests/${id}/cancel`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Receivables
     * @name ReceivablesList
     * @request GET:/admin/receivables/
     * @secure
     */
    receivablesList: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 100
         * @default 20
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReceivablesListData, any>({
        path: `/admin/receivables/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Receivables
     * @name ReceivablesPaymentsList
     * @request GET:/admin/receivables/{id}/payments
     * @secure
     */
    receivablesPaymentsList: (id: number, params: RequestParams = {}) =>
      this.request<
        ReceivablesPaymentsListData,
        {
          error: string;
        }
      >({
        path: `/admin/receivables/${id}/payments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Receivables
     * @name ReceivablesPayCreate
     * @request POST:/admin/receivables/{id}/pay
     * @secure
     */
    receivablesPayCreate: (
      id: number,
      data: {
        /** @min 0 */
        cardAmount?: number;
        /** @min 0 */
        cashAmount?: number;
        /** @min 0 */
        transferAmount?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ReceivablesPayCreateData,
        {
          error: string;
        }
      >({
        path: `/admin/receivables/${id}/pay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  memberships = {
    /**
     * No description
     *
     * @tags
     * @name GetMemberships
     * @request GET:/memberships/my
     * @secure
     */
    getMemberships: (params: RequestParams = {}) =>
      this.request<GetMembershipsData, any>({
        path: `/memberships/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name PaymentsList
     * @request GET:/memberships/{id}/payments
     * @secure
     */
    paymentsList: (id: number, params: RequestParams = {}) =>
      this.request<
        PaymentsListData,
        {
          error: string;
        }
      >({
        path: `/memberships/${id}/payments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name BillingPartialUpdate
     * @request PATCH:/memberships/{id}/billing
     * @secure
     */
    billingPartialUpdate: (
      id: number,
      data: {
        methodKey: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        BillingPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/memberships/${id}/billing`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name CancelSubscriptionPartialUpdate
     * @request PATCH:/memberships/{id}/cancel-subscription
     * @secure
     */
    cancelSubscriptionPartialUpdate: (id: number, params: RequestParams = {}) =>
      this.request<
        CancelSubscriptionPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/memberships/${id}/cancel-subscription`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReactivateSubscriptionPartialUpdate
     * @request PATCH:/memberships/{id}/reactivate-subscription
     * @secure
     */
    reactivateSubscriptionPartialUpdate: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<
        ReactivateSubscriptionPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/memberships/${id}/reactivate-subscription`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name SubscriptionList
     * @request GET:/memberships/{id}/subscription
     * @secure
     */
    subscriptionList: (id: number, params: RequestParams = {}) =>
      this.request<SubscriptionListData, any>({
        path: `/memberships/${id}/subscription`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name LockersList
     * @request GET:/memberships/lockers
     * @secure
     */
    lockersList: (params: RequestParams = {}) =>
      this.request<LockersListData, any>({
        path: `/memberships/lockers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name LockerCreate
     * @request POST:/memberships/{id}/locker
     * @secure
     */
    lockerCreate: (
      id: number,
      data: {
        lockerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<LockerCreateData, any>({
        path: `/memberships/${id}/locker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  class = {
    /**
     * No description
     *
     * @tags
     * @name ByMembershipDetail
     * @request GET:/class/by-membership/{membershipId}
     * @secure
     */
    byMembershipDetail: (membershipId: number, params: RequestParams = {}) =>
      this.request<ByMembershipDetailData, any>({
        path: `/class/by-membership/${membershipId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ClassDetail
     * @request GET:/class/{id}
     * @secure
     */
    classDetail: (id: number, params: RequestParams = {}) =>
      this.request<ClassDetailResult, any>({
        path: `/class/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name DeleteReasonPartialUpdate
     * @request PATCH:/class/{id}/deleteReason
     * @secure
     */
    deleteReasonPartialUpdate: (
      id: number,
      data: {
        deletedReason: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteReasonPartialUpdateData, any>({
        path: `/class/${id}/deleteReason`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  store = {
    /**
     * No description
     *
     * @tags
     * @name StoreList
     * @request GET:/store/
     * @secure
     */
    storeList: (params: RequestParams = {}) =>
      this.request<StoreListResult, any>({
        path: `/store/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name StoreDetail
     * @request GET:/store/{id}
     * @secure
     */
    storeDetail: (id: number, params: RequestParams = {}) =>
      this.request<StoreDetailData, any>({
        path: `/store/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ConnectCreate
     * @request POST:/store/connect
     * @secure
     */
    connectCreate: (
      data: {
        storeId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConnectCreateData, any>({
        path: `/store/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  reservations = {
    /**
     * No description
     *
     * @tags
     * @name GetReservations
     * @request GET:/reservations/my
     * @secure
     */
    getReservations: (params: RequestParams = {}) =>
      this.request<GetReservationsData, any>({
        path: `/reservations/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name MyAllList
     * @request GET:/reservations/my-all
     * @secure
     */
    myAllList: (params: RequestParams = {}) =>
      this.request<MyAllListData, any>({
        path: `/reservations/my-all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsCreate
     * @request POST:/reservations/
     * @secure
     */
    reservationsCreate: (
      data: {
        classId: number;
        membershipId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ReservationsCreateResult,
        {
          message?: string;
        }
      >({
        path: `/reservations/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name CancelCreate
     * @request POST:/reservations/{id}/cancel
     * @secure
     */
    cancelCreate: (id: number, params: RequestParams = {}) =>
      this.request<CancelCreateData, any>({
        path: `/reservations/${id}/cancel`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ChangeClassCreate
     * @request POST:/reservations/change-class
     * @secure
     */
    changeClassCreate: (
      data: {
        reservationId: number;
        membershipId: number;
        newClassId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChangeClassCreateData, any>({
        path: `/reservations/change-class`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name AttendanceHistoriesList
     * @request GET:/reservations/attendance-histories
     * @secure
     */
    attendanceHistoriesList: (
      query?: {
        yearMonth?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttendanceHistoriesListData, any>({
        path: `/reservations/attendance-histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name AttendanceCouponsCreate
     * @request POST:/reservations/attendance-coupons
     * @secure
     */
    attendanceCouponsCreate: (data: object, params: RequestParams = {}) =>
      this.request<
        AttendanceCouponsCreateData,
        {
          error: string;
        }
      >({
        path: `/reservations/attendance-coupons`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name AttendanceCouponsList
     * @request GET:/reservations/attendance-coupons
     * @secure
     */
    attendanceCouponsList: (params: RequestParams = {}) =>
      this.request<AttendanceCouponsListData, any>({
        path: `/reservations/attendance-coupons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name AttendanceCouponsUseCreate
     * @request POST:/reservations/attendance-coupons/use
     * @secure
     */
    attendanceCouponsUseCreate: (data: object, params: RequestParams = {}) =>
      this.request<
        AttendanceCouponsUseCreateData,
        {
          error: string;
        }
      >({
        path: `/reservations/attendance-coupons/use`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name AttendanceRankingList
     * @request GET:/reservations/attendance-ranking
     * @secure
     */
    attendanceRankingList: (
      query?: {
        yearMonth?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttendanceRankingListData, any>({
        path: `/reservations/attendance-ranking`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  fits = {
    /**
     * No description
     *
     * @tags
     * @name TodayClassesDetail
     * @request GET:/fits/today-classes/{username}
     * @secure
     */
    todayClassesDetail: (username: string, params: RequestParams = {}) =>
      this.request<TodayClassesDetailData, any>({
        path: `/fits/today-classes/${username}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ReservationsDetail
     * @request GET:/fits/reservations/{classId}
     * @secure
     */
    reservationsDetail: (classId: number, params: RequestParams = {}) =>
      this.request<ReservationsDetailData, any>({
        path: `/fits/reservations/${classId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name RowingHistoriesCreate
     * @request POST:/fits/rowing-histories
     * @secure
     */
    rowingHistoriesCreate: (
      data: {
        rank: number;
        distance: number;
        time: number;
        userIds: number[];
        classId: number;
        groupNumber: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<RowingHistoriesCreateData, any>({
        path: `/fits/rowing-histories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name ClubDayBadgesDetail
     * @request GET:/fits/club-day-badges/{classId}
     * @secure
     */
    clubDayBadgesDetail: (classId: number, params: RequestParams = {}) =>
      this.request<ClubDayBadgesDetailData, any>({
        path: `/fits/club-day-badges/${classId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name HiroxSessionsDetail
     * @request GET:/fits/hirox/sessions/{sessionId}
     * @secure
     */
    hiroxSessionsDetail: (sessionId: number, params: RequestParams = {}) =>
      this.request<HiroxSessionsDetailData, any>({
        path: `/fits/hirox/sessions/${sessionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name HiroxSetupCreate
     * @request POST:/fits/hirox/setup
     * @secure
     */
    hiroxSetupCreate: (
      data: {
        username?: string;
        storeName?: string;
        classId?: number;
        teams: {
          teamNumber: number;
          difficulty: "EASY" | "NORMAL" | "HARD";
          userIds: number[];
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<HiroxSetupCreateData, any>({
        path: `/fits/hirox/setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name HiroxRecordsCreate
     * @request POST:/fits/hirox/records
     * @secure
     */
    hiroxRecordsCreate: (
      data: {
        hiroxTeamId: number;
        time: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<HiroxRecordsCreateData, any>({
        path: `/fits/hirox/records`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name HiroxStoreBestList
     * @request GET:/fits/hirox/store-best
     * @secure
     */
    hiroxStoreBestList: (params: RequestParams = {}) =>
      this.request<HiroxStoreBestListData, any>({
        path: `/fits/hirox/store-best`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name HiroxDailyBestList
     * @request GET:/fits/hirox/daily-best
     * @secure
     */
    hiroxDailyBestList: (
      query: {
        date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HiroxDailyBestListData, any>({
        path: `/fits/hirox/daily-best`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name HiroxMyRecordsList
     * @request GET:/fits/hirox/my-records
     * @secure
     */
    hiroxMyRecordsList: (params: RequestParams = {}) =>
      this.request<HiroxMyRecordsListData, any>({
        path: `/fits/hirox/my-records`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  inbody = {
    /**
     * No description
     *
     * @tags
     * @name WebhookCreate
     * @request POST:/inbody/webhook
     * @secure
     */
    webhookCreate: (
      data: {
        EquipSerial: string;
        TelHP: string;
        UserID: string;
        TestDatetimes: string;
        Account: string;
        Equip: string;
        Type: string;
        IsTempData: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebhookCreateData, any>({
        path: `/inbody/webhook`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags
     * @name TestCreate
     * @request POST:/inbody/test
     * @secure
     */
    testCreate: (
      data: {
        userId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestCreateData, any>({
        path: `/inbody/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsList
     * @request GET:/notifications/
     * @secure
     */
    notificationsList: (params: RequestParams = {}) =>
      this.request<NotificationsListData, any>({
        path: `/notifications/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name ReadCreate
     * @request POST:/notifications/read
     * @secure
     */
    readCreate: (params: RequestParams = {}) =>
      this.request<ReadCreateData, any>({
        path: `/notifications/read`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  dietPreferences = {
    /**
     * No description
     *
     * @tags Diet Preferences
     * @name GetDietPreferences
     * @request GET:/diet-preferences/my
     * @secure
     */
    getDietPreferences: (params: RequestParams = {}) =>
      this.request<GetDietPreferencesData, any>({
        path: `/diet-preferences/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Preferences
     * @name DietPreferencesCreate
     * @request POST:/diet-preferences/
     * @secure
     */
    dietPreferencesCreate: (
      data: {
        /**
         * @min 1
         * @max 300
         */
        height: number;
        /**
         * @min 1
         * @max 500
         */
        weight: number;
        /** @format date */
        birthDate: string;
        gender: "MALE" | "FEMALE";
        exerciseLevel: "NONE" | "LIGHT" | "MODERATE" | "ACTIVE" | "VERY_ACTIVE";
        exerciseGoal: "DIET" | "HEALTH" | "MUSCLE_GAIN";
        mealsPerDay: 3 | 4;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        wakeUpTime?: string;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        exerciseTime?: string;
        allergies: (
          | "EGG"
          | "MILK"
          | "SOY"
          | "PORK"
          | "CHICKEN"
          | "MACKEREL"
          | "BUCKWHEAT"
          | "WHEAT"
          | "TOMATO"
          | "PEACH"
          | "CITRUS"
          | "NUTS"
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<DietPreferencesCreateData, any>({
        path: `/diet-preferences/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Preferences
     * @name DietPreferencesPartialUpdate
     * @request PATCH:/diet-preferences/
     * @secure
     */
    dietPreferencesPartialUpdate: (
      data: {
        /**
         * @min 1
         * @max 300
         */
        height?: number;
        /**
         * @min 1
         * @max 500
         */
        weight?: number;
        /** @format date */
        birthDate?: string;
        gender?: "MALE" | "FEMALE";
        exerciseLevel?:
          | "NONE"
          | "LIGHT"
          | "MODERATE"
          | "ACTIVE"
          | "VERY_ACTIVE";
        exerciseGoal?: "DIET" | "HEALTH" | "MUSCLE_GAIN";
        mealsPerDay?: 3 | 4;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        wakeUpTime?: string;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        exerciseTime?: string;
        allergies?: (
          | "EGG"
          | "MILK"
          | "SOY"
          | "PORK"
          | "CHICKEN"
          | "MACKEREL"
          | "BUCKWHEAT"
          | "WHEAT"
          | "TOMATO"
          | "PEACH"
          | "CITRUS"
          | "NUTS"
        )[];
      },
      params: RequestParams = {},
    ) =>
      this.request<DietPreferencesPartialUpdateData, any>({
        path: `/diet-preferences/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Preferences
     * @name DietPreferencesDelete
     * @request DELETE:/diet-preferences/
     * @secure
     */
    dietPreferencesDelete: (params: RequestParams = {}) =>
      this.request<DietPreferencesDeleteData, any>({
        path: `/diet-preferences/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  bodyAnalysis = {
    /**
     * @description 본인의 체형 분석 기록 전체 조회
     *
     * @tags 사용자 체형 분석
     * @name HistoriesList
     * @request GET:/body-analysis/histories
     * @secure
     */
    historiesList: (
      query?: {
        /**
         * 정렬 순서 (기본값: false - 내림차순)
         * @default false
         */
        asc?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoriesListData, any>({
        path: `/body-analysis/histories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dietSchedule = {
    /**
     * No description
     *
     * @tags Diet Schedule
     * @name GetDietSchedule
     * @request GET:/diet-schedule/my
     * @secure
     */
    getDietSchedule: (params: RequestParams = {}) =>
      this.request<GetDietScheduleData, any>({
        path: `/diet-schedule/my`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name DietScheduleDetail
     * @request GET:/diet-schedule/{scheduleId}
     * @secure
     */
    dietScheduleDetail: (scheduleId: number, params: RequestParams = {}) =>
      this.request<DietScheduleDetailData, any>({
        path: `/diet-schedule/${scheduleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name DietScheduleCreate
     * @request POST:/diet-schedule/
     * @secure
     */
    dietScheduleCreate: (
      data: {
        /** @format date */
        scheduleDate: string;
        mealNumber: 1 | 2 | 3 | 4 | -1;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        mealTime: string;
        /** @min 0 */
        targetCarbs: number;
        /** @min 0 */
        targetProtein: number;
        /** @min 0 */
        targetFat: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DietScheduleCreateData, any>({
        path: `/diet-schedule/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name FoodsCreate
     * @request POST:/diet-schedule/{scheduleId}/foods
     * @secure
     */
    foodsCreate: (
      scheduleId: number,
      data: {
        name: string;
        imageUrl?: string;
        /** @min 0 */
        grams: number;
        /** @min 0 */
        protein: number;
        /** @min 0 */
        carbs: number;
        /** @min 0 */
        fat: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FoodsCreateData, any>({
        path: `/diet-schedule/${scheduleId}/foods`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name FoodsPartialUpdate
     * @request PATCH:/diet-schedule/{scheduleId}/foods/{foodId}
     * @secure
     */
    foodsPartialUpdate: (
      scheduleId: number,
      foodId: number,
      data: {
        name?: string;
        imageUrl?: string;
        /** @min 0 */
        grams?: number;
        /** @min 0 */
        protein?: number;
        /** @min 0 */
        carbs?: number;
        /** @min 0 */
        fat?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FoodsPartialUpdateData, any>({
        path: `/diet-schedule/${scheduleId}/foods/${foodId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name FoodsDelete
     * @request DELETE:/diet-schedule/{scheduleId}/foods/{foodId}
     * @secure
     */
    foodsDelete: (
      scheduleId: number,
      foodId: number,
      params: RequestParams = {},
    ) =>
      this.request<FoodsDeleteData, any>({
        path: `/diet-schedule/${scheduleId}/foods/${foodId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name RegenerateDayCreate
     * @request POST:/diet-schedule/regenerate-day
     * @secure
     */
    regenerateDayCreate: (
      data: {
        /** @format date */
        date: string;
        mealsPerDay?: 3 | 4;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        wakeUpTime?: string;
        /** @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$ */
        exerciseTime?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegenerateDayCreateData, any>({
        path: `/diet-schedule/regenerate-day`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diet Schedule
     * @name DailyDietPreferencesList
     * @request GET:/diet-schedule/daily-diet-preferences
     * @secure
     */
    dailyDietPreferencesList: (params: RequestParams = {}) =>
      this.request<DailyDietPreferencesListData, any>({
        path: `/diet-schedule/daily-diet-preferences`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  diet = {
    /**
     * No description
     *
     * @tags Admin
     * @name DietList
     * @request GET:/diet/
     * @secure
     */
    dietList: (params: RequestParams = {}) =>
      this.request<DietListResult, any>({
        path: `/diet/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  billings = {
    /**
     * No description
     *
     * @tags Billings
     * @name RegisterCreate
     * @request POST:/billings/register
     * @secure
     */
    registerCreate: (
      data: {
        cardNumber: string;
        cardYear: string;
        cardMonth: string;
        cardPassword: string;
        businessNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegisterCreateData, any>({
        path: `/billings/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsList
     * @request GET:/billings/
     * @secure
     */
    billingsList: (params: RequestParams = {}) =>
      this.request<BillingsListResult, any>({
        path: `/billings/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsDelete
     * @request DELETE:/billings/{id}
     * @secure
     */
    billingsDelete: (id: number, params: RequestParams = {}) =>
      this.request<BillingsDeleteResult, any>({
        path: `/billings/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  products = {
    /**
     * No description
     *
     * @tags Products
     * @name ProductsList
     * @request GET:/products/
     * @secure
     */
    productsList: (
      query?: {
        productType?: "CLASS" | "GYM_MEMBERSHIP" | "CLOTHING" | "PT" | "LOCKER";
        storeId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsListResult, any>({
        path: `/products/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  payments = {
    /**
     * No description
     *
     * @tags Payments
     * @name PurchaseCreate
     * @request POST:/payments/purchase
     * @secure
     */
    purchaseCreate: (
      data: {
        methodKey: string;
        cultureMethodKey?: string;
        cardInstallmentPlan?: number;
        useParentCard?: boolean;
        items: {
          planId: number;
          addonPlanIds?: number[];
          lockerId?: number;
          startedAt?: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PurchaseCreateData,
        {
          error: string;
        }
      >({
        path: `/payments/purchase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsList
     * @request GET:/payments/
     * @secure
     */
    paymentsList: (params: RequestParams = {}) =>
      this.request<PaymentsListResult, any>({
        path: `/payments/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsDetail
     * @request GET:/payments/{id}
     * @secure
     */
    paymentsDetail: (id: number, params: RequestParams = {}) =>
      this.request<PaymentsDetailData, any>({
        path: `/payments/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name TermsList
     * @request GET:/payments/terms
     * @secure
     */
    termsList: (
      query: {
        customerKey: string;
        scope: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        TermsListData,
        {
          error: string;
        }
      >({
        path: `/payments/terms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name TermsAgreeCreate
     * @request POST:/payments/terms/agree
     * @secure
     */
    termsAgreeCreate: (
      data: {
        customerKey: string;
        termsId: number[];
        /** @maxItems 2 */
        scope: ("REGISTER" | "ACCOUNT" | "BILLING" | "CARD")[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        TermsAgreeCreateData,
        {
          error: string;
        }
      >({
        path: `/payments/terms/agree`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name AccessTokenCreate
     * @request POST:/payments/access-token
     * @secure
     */
    accessTokenCreate: (
      data: {
        code: string;
        customerKey: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AccessTokenCreateData,
        {
          error: string;
        }
      >({
        path: `/payments/access-token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name RefreshAccessTokenCreate
     * @request POST:/payments/refresh-access-token
     * @secure
     */
    refreshAccessTokenCreate: (
      data: {
        refreshToken: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        RefreshAccessTokenCreateData,
        {
          error: string;
        }
      >({
        path: `/payments/refresh-access-token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PromotionsCardList
     * @request GET:/payments/promotions/card
     * @secure
     */
    promotionsCardList: (params: RequestParams = {}) =>
      this.request<PromotionsCardListData, any>({
        path: `/payments/promotions/card`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name CardRegisteredCreate
     * @request POST:/payments/card-registered
     * @secure
     */
    cardRegisteredCreate: (params: RequestParams = {}) =>
      this.request<
        CardRegisteredCreateData,
        {
          error: string;
        }
      >({
        path: `/payments/card-registered`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  door = {
    /**
     * No description
     *
     * @name QrcodeCreate
     * @request POST:/door/qrcode
     * @secure
     */
    qrcodeCreate: (
      data: {
        storeId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<QrcodeCreateData, any>({
        path: `/door/qrcode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name QrcodeInstructorCreate
     * @request POST:/door/qrcode/instructor
     * @secure
     */
    qrcodeInstructorCreate: (params: RequestParams = {}) =>
      this.request<QrcodeInstructorCreateData, any>({
        path: `/door/qrcode/instructor`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckCreate
     * @request POST:/door/check
     * @secure
     */
    checkCreate: (
      data: {
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CheckCreateData, any>({
        path: `/door/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name VerifyCreate
     * @request POST:/door/verify
     * @secure
     */
    verifyCreate: (
      data: {
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VerifyCreateData, any>({
        path: `/door/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  fnb = {
    /**
     * No description
     *
     * @tags F&B (User)
     * @name PaymentPinList
     * @request GET:/fnb/payment-pin
     * @secure
     */
    paymentPinList: (params: RequestParams = {}) =>
      this.request<PaymentPinListData, any>({
        path: `/fnb/payment-pin`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name PaymentPinPartialUpdate
     * @request PATCH:/fnb/payment-pin
     * @secure
     */
    paymentPinPartialUpdate: (
      data: {
        /**
         * @minLength 4
         * @maxLength 10
         */
        pin: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentPinPartialUpdateData, any>({
        path: `/fnb/payment-pin`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name CategoriesList
     * @request GET:/fnb/categories
     * @secure
     */
    categoriesList: (params: RequestParams = {}) =>
      this.request<CategoriesListData, any>({
        path: `/fnb/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name ProductsList
     * @request GET:/fnb/products
     * @secure
     */
    productsList: (
      query?: {
        subCategoryId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductsListOutput, any>({
        path: `/fnb/products`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name OrdersCreate
     * @request POST:/fnb/orders
     * @secure
     */
    ordersCreate: (
      data: {
        methodKey: string;
        /**
         * @minLength 4
         * @maxLength 10
         */
        pin: string;
        useParentCard?: boolean;
        /** @minItems 1 */
        items: {
          productId: number;
          /** @min 1 */
          quantity: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        OrdersCreateData,
        {
          error: string;
        }
      >({
        path: `/fnb/orders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name OrdersList
     * @request GET:/fnb/orders
     * @secure
     */
    ordersList: (params: RequestParams = {}) =>
      this.request<OrdersListData, any>({
        path: `/fnb/orders`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name PaymentRequestCreate
     * @request POST:/fnb/payment-request
     * @secure
     */
    paymentRequestCreate: (
      data: {
        methodKey: string;
        /** @minItems 1 */
        items: {
          productId: number;
          /** @min 1 */
          quantity: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentRequestCreateData,
        {
          error: string;
        }
      >({
        path: `/fnb/payment-request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags F&B (User)
     * @name OrdersDetail
     * @request GET:/fnb/orders/{id}
     * @secure
     */
    ordersDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        OrdersDetailData,
        {
          error: string;
        }
      >({
        path: `/fnb/orders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  parent = {
    /**
     * No description
     *
     * @tags Parent
     * @name ChildrenList
     * @request GET:/parent/children
     * @secure
     */
    childrenList: (params: RequestParams = {}) =>
      this.request<ChildrenListData, any>({
        path: `/parent/children`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name ChildrenRequestCreate
     * @request POST:/parent/children/request
     * @secure
     */
    childrenRequestCreate: (
      data: {
        childPhoneNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ChildrenRequestCreateData,
        {
          error: string;
        }
      >({
        path: `/parent/children/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name ChildrenRequestConfirmCreate
     * @request POST:/parent/children/request/{id}/confirm
     * @secure
     */
    childrenRequestConfirmCreate: (
      id: number,
      data: {
        verificationCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ChildrenRequestConfirmCreateData,
        {
          error: string;
        }
      >({
        path: `/parent/children/request/${id}/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name ChildrenDelete
     * @request DELETE:/parent/children/{childUserId}
     * @secure
     */
    childrenDelete: (childUserId: number, params: RequestParams = {}) =>
      this.request<
        ChildrenDeleteData,
        {
          error: string;
        }
      >({
        path: `/parent/children/${childUserId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name ChildrenConsentPartialUpdate
     * @request PATCH:/parent/children/{childUserId}/consent
     * @secure
     */
    childrenConsentPartialUpdate: (
      childUserId: number,
      data: {
        paymentConsentType: "ALWAYS_REQUIRE" | "NO_REQUIRE";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ChildrenConsentPartialUpdateData,
        {
          error: string;
        }
      >({
        path: `/parent/children/${childUserId}/consent`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name PaymentRequestsList
     * @request GET:/parent/payment-requests
     * @secure
     */
    paymentRequestsList: (params: RequestParams = {}) =>
      this.request<PaymentRequestsListData, any>({
        path: `/parent/payment-requests`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name PaymentRequestsApproveCreate
     * @request POST:/parent/payment-requests/{id}/approve
     * @secure
     */
    paymentRequestsApproveCreate: (id: number, params: RequestParams = {}) =>
      this.request<
        PaymentRequestsApproveCreateData,
        {
          error: string;
        }
      >({
        path: `/parent/payment-requests/${id}/approve`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name PaymentRequestsRejectCreate
     * @request POST:/parent/payment-requests/{id}/reject
     * @secure
     */
    paymentRequestsRejectCreate: (id: number, params: RequestParams = {}) =>
      this.request<
        PaymentRequestsRejectCreateData,
        {
          error: string;
        }
      >({
        path: `/parent/payment-requests/${id}/reject`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name ChildrenPaymentsList
     * @request GET:/parent/children/{childUserId}/payments
     * @secure
     */
    childrenPaymentsList: (childUserId: number, params: RequestParams = {}) =>
      this.request<ChildrenPaymentsListData, any>({
        path: `/parent/children/${childUserId}/payments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name FnbPaymentRequestsList
     * @request GET:/parent/fnb-payment-requests
     * @secure
     */
    fnbPaymentRequestsList: (params: RequestParams = {}) =>
      this.request<FnbPaymentRequestsListData, any>({
        path: `/parent/fnb-payment-requests`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name FnbPaymentRequestsApproveCreate
     * @request POST:/parent/fnb-payment-requests/{id}/approve
     * @secure
     */
    fnbPaymentRequestsApproveCreate: (id: number, params: RequestParams = {}) =>
      this.request<
        FnbPaymentRequestsApproveCreateData,
        {
          error: string;
        }
      >({
        path: `/parent/fnb-payment-requests/${id}/approve`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parent
     * @name FnbPaymentRequestsRejectCreate
     * @request POST:/parent/fnb-payment-requests/{id}/reject
     * @secure
     */
    fnbPaymentRequestsRejectCreate: (id: number, params: RequestParams = {}) =>
      this.request<
        FnbPaymentRequestsRejectCreateData,
        {
          error: string;
        }
      >({
        path: `/parent/fnb-payment-requests/${id}/reject`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  child = {
    /**
     * No description
     *
     * @tags Child
     * @name ParentInfoList
     * @request GET:/child/parent-info
     * @secure
     */
    parentInfoList: (params: RequestParams = {}) =>
      this.request<ParentInfoListData, any>({
        path: `/child/parent-info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Child
     * @name PaymentRequestCreate
     * @request POST:/child/payment-request
     * @secure
     */
    paymentRequestCreate: (
      data: {
        methodKey: string;
        cardInstallmentPlan?: number;
        items: {
          planId: number;
          addonPlanIds?: number[];
          lockerId?: number;
          startedAt?: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PaymentRequestCreateResult,
        {
          error: string;
        }
      >({
        path: `/child/payment-request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Child
     * @name LinkRequestList
     * @request GET:/child/link-request
     * @secure
     */
    linkRequestList: (params: RequestParams = {}) =>
      this.request<LinkRequestListData, any>({
        path: `/child/link-request`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
